webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var platform_browser_dynamic_1 = __webpack_require__(1);
	var core_1 = __webpack_require__(3);
	var app_module_1 = __webpack_require__(23);
	if (true) {
	    core_1.enableProdMode();
	}
	platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	// Angular2 imports
	var core_1 = __webpack_require__(3);
	var platform_browser_1 = __webpack_require__(21);
	var forms_1 = __webpack_require__(24);
	var http_1 = __webpack_require__(28);
	var platform_browser_2 = __webpack_require__(21);
	var angulartics2_google_analytics_1 = __webpack_require__(29);
	var angulartics2_1 = __webpack_require__(69);
	// Angular2 Material Design Lite
	var angular2_mdl_1 = __webpack_require__(71);
	// My router
	var app_routing_1 = __webpack_require__(126);
	// My components
	// Root component
	var app_component_1 = __webpack_require__(199);
	// Bokeh components
	var plot_component_1 = __webpack_require__(201);
	var bokeh_create_model_component_1 = __webpack_require__(203);
	var bokeh_use_model_component_1 = __webpack_require__(205);
	// Home components
	var home_component_1 = __webpack_require__(149);
	// Further details components
	var further_details_component_1 = __webpack_require__(197);
	// Speciation components
	var specifications_component_1 = __webpack_require__(158);
	var choose_specifications_component_1 = __webpack_require__(206);
	var json_edit_component_1 = __webpack_require__(208);
	// Dicom components
	var dicom_component_1 = __webpack_require__(160);
	var send_to_parameterisation_component_1 = __webpack_require__(211);
	// Parameterise components
	var parameterise_component_1 = __webpack_require__(127);
	var width_length_table_component_1 = __webpack_require__(213);
	var x_y_input_component_1 = __webpack_require__(141);
	// Model components
	var width_length_area_input_component_1 = __webpack_require__(152);
	var create_model_component_1 = __webpack_require__(151);
	var use_model_component_1 = __webpack_require__(154);
	var insert_table_component_1 = __webpack_require__(215);
	var create_insert_table_component_1 = __webpack_require__(217);
	// Storage components
	var storage_management_component_1 = __webpack_require__(156);
	// Misc components
	var page_not_found_component_1 = __webpack_require__(147);
	// My pipes
	// Custom json pipe
	var my_json_pipe_1 = __webpack_require__(209);
	// My services
	// Data services
	var model_data_1 = __webpack_require__(137);
	var current_settings_1 = __webpack_require__(140);
	var data_persistence_service_1 = __webpack_require__(132);
	var local_storage_service_1 = __webpack_require__(218);
	var specifications_data_service_1 = __webpack_require__(139);
	// Server api services
	var electron_api_service_1 = __webpack_require__(129);
	// Utility services
	var title_service_1 = __webpack_require__(131);
	var AppModule = (function () {
	    function AppModule() {
	    }
	    AppModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                platform_browser_1.BrowserModule,
	                forms_1.FormsModule,
	                http_1.HttpModule,
	                angular2_mdl_1.MdlModule,
	                //  MaterialModule.forRoot(),
	                app_routing_1.routing,
	                angulartics2_1.Angulartics2Module.forRoot()
	            ],
	            declarations: [
	                app_component_1.AppComponent,
	                parameterise_component_1.ParameteriseComponent,
	                further_details_component_1.FurtherDetailsComponent,
	                plot_component_1.PlotComponent,
	                page_not_found_component_1.PageNotFoundComponent,
	                width_length_table_component_1.WidthLengthTableComponent,
	                my_json_pipe_1.MyJsonPipe,
	                home_component_1.HomeComponent,
	                create_model_component_1.CreateModelComponent,
	                use_model_component_1.UseModelComponent,
	                storage_management_component_1.StorageManagementComponent,
	                specifications_component_1.SpecificationsComponent,
	                dicom_component_1.DicomComponent,
	                send_to_parameterisation_component_1.SendToParameterisationComponent,
	                json_edit_component_1.JsonEditComponent,
	                bokeh_create_model_component_1.BokehCreateModelComponent,
	                bokeh_use_model_component_1.BokehUseModelComponent,
	                choose_specifications_component_1.ChooseSpecificationsComponent,
	                width_length_area_input_component_1.WidthLengthAreaInputComponent,
	                x_y_input_component_1.XYInputComponent,
	                insert_table_component_1.InsertTableComponent,
	                create_insert_table_component_1.CreateInsertTableComponent
	            ],
	            providers: [
	                electron_api_service_1.ElectronApiService,
	                title_service_1.TitleService,
	                platform_browser_2.Title,
	                local_storage_service_1.LocalStorageService,
	                angulartics2_google_analytics_1.Angulartics2GoogleAnalytics,
	                model_data_1.ModelData, model_data_1.ModelMeasurement, model_data_1.ModelGrid, model_data_1.Predictions, model_data_1.AreaLengthConversion,
	                data_persistence_service_1.DataPersistenceService,
	                current_settings_1.CurrentSettings,
	                specifications_data_service_1.MachineSpecificationsService
	            ],
	            bootstrap: [
	                app_component_1.AppComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AppModule);
	    return AppModule;
	}());
	exports.AppModule = AppModule;


/***/ },
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var angulartics2_1 = __webpack_require__(30);
	var Angulartics2GoogleAnalytics = (function () {
	    function Angulartics2GoogleAnalytics(angulartics2) {
	        var _this = this;
	        this.angulartics2 = angulartics2;
	        this.angulartics2.settings.pageTracking.trackRelativePath = true;
	        this.angulartics2.settings.ga = {
	            additionalAccountNames: [],
	            userId: null
	        };
	        this.angulartics2.pageTrack.subscribe(function (x) { return _this.pageTrack(x.path); });
	        this.angulartics2.eventTrack.subscribe(function (x) { return _this.eventTrack(x.action, x.properties); });
	        this.angulartics2.exceptionTrack.subscribe(function (x) { return _this.exceptionTrack(x); });
	        this.angulartics2.setUsername.subscribe(function (x) { return _this.setUsername(x); });
	        this.angulartics2.setUserProperties.subscribe(function (x) { return _this.setUserProperties(x); });
	        this.angulartics2.userTimings.subscribe(function (x) { return _this.userTimings(x); });
	    }
	    Angulartics2GoogleAnalytics.prototype.pageTrack = function (path) {
	        if (typeof _gaq !== 'undefined' && _gaq) {
	            _gaq.push(['_trackPageview', path]);
	            for (var _i = 0, _a = this.angulartics2.settings.ga.additionalAccountNames; _i < _a.length; _i++) {
	                var accountName = _a[_i];
	                _gaq.push([accountName + '._trackPageview', path]);
	            }
	            ;
	        }
	        if (typeof ga !== 'undefined' && ga) {
	            if (this.angulartics2.settings.ga.userId) {
	                ga('set', '&uid', this.angulartics2.settings.ga.userId);
	            }
	            ga('send', 'pageview', path);
	            for (var _b = 0, _c = this.angulartics2.settings.ga.additionalAccountNames; _b < _c.length; _b++) {
	                var accountName = _c[_b];
	                ga(accountName + '.send', 'pageview', path);
	            }
	            ;
	        }
	    };
	    Angulartics2GoogleAnalytics.prototype.eventTrack = function (action, properties) {
	        if (!properties || !properties.category) {
	            properties = properties || {};
	            properties.category = 'Event';
	        }
	        if (properties.value) {
	            var parsed = parseInt(properties.value, 10);
	            properties.value = isNaN(parsed) ? 0 : parsed;
	        }
	        if (ga) {
	            var eventOptions = {
	                eventCategory: properties.category,
	                eventAction: action,
	                eventLabel: properties.label,
	                eventValue: properties.value,
	                nonInteraction: properties.noninteraction,
	                page: properties.page || location.hash.substring(1) || location.pathname,
	                userId: this.angulartics2.settings.ga.userId
	            };
	            this.setDimensionsAndMetrics(properties);
	            if (this.angulartics2.settings.ga.transport) {
	                ga('send', 'event', eventOptions, { transport: this.angulartics2.settings.ga.transport });
	            }
	            else {
	                ga('send', 'event', eventOptions);
	            }
	            for (var _i = 0, _a = this.angulartics2.settings.ga.additionalAccountNames; _i < _a.length; _i++) {
	                var accountName = _a[_i];
	                ga(accountName + '.send', 'event', eventOptions);
	            }
	        }
	        else if (_gaq) {
	            _gaq.push(['_trackEvent', properties.category, action, properties.label, properties.value, properties.noninteraction]);
	        }
	    };
	    Angulartics2GoogleAnalytics.prototype.exceptionTrack = function (properties) {
	        if (!properties || !properties.appId || !properties.appName || !properties.appVersion) {
	            console.error('Must be setted appId, appName and appVersion.');
	            return;
	        }
	        if (properties.fatal === undefined) {
	            console.log('No "fatal" provided, sending with fatal=true');
	            properties.exFatal = true;
	        }
	        properties.exDescription = properties.description;
	        ga('send', 'exception', properties);
	    };
	    Angulartics2GoogleAnalytics.prototype.setUsername = function (userId) {
	        this.angulartics2.settings.ga.userId = userId;
	    };
	    Angulartics2GoogleAnalytics.prototype.setUserProperties = function (properties) {
	        this.setDimensionsAndMetrics(properties);
	    };
	    Angulartics2GoogleAnalytics.prototype.userTimings = function (properties) {
	        if (!properties || !properties.timingCategory || !properties.timingVar || !properties.timingValue) {
	            console.error('Properties timingCategory, timingVar, and timingValue are required to be set.');
	            return;
	        }
	        if (ga) {
	            ga('send', 'timing', properties);
	        }
	    };
	    Angulartics2GoogleAnalytics.prototype.setDimensionsAndMetrics = function (properties) {
	        if (ga) {
	            for (var idx = 1; idx <= 200; idx++) {
	                if (properties['dimension' + idx.toString()]) {
	                    ga('set', 'dimension' + idx.toString(), properties['dimension' + idx.toString()]);
	                }
	                if (properties['metric' + idx.toString()]) {
	                    ga('set', 'metric' + idx.toString(), properties['metric' + idx.toString()]);
	                }
	            }
	        }
	    };
	    Angulartics2GoogleAnalytics.decorators = [
	        { type: core_1.Injectable },
	    ];
	    Angulartics2GoogleAnalytics.ctorParameters = [
	        { type: angulartics2_1.Angulartics2, },
	    ];
	    return Angulartics2GoogleAnalytics;
	}());
	exports.Angulartics2GoogleAnalytics = Angulartics2GoogleAnalytics;


/***/ },
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var router_1 = __webpack_require__(41);
	var parameterise_component_1 = __webpack_require__(127);
	var page_not_found_component_1 = __webpack_require__(147);
	var home_component_1 = __webpack_require__(149);
	var create_model_component_1 = __webpack_require__(151);
	var use_model_component_1 = __webpack_require__(154);
	var storage_management_component_1 = __webpack_require__(156);
	var specifications_component_1 = __webpack_require__(158);
	var dicom_component_1 = __webpack_require__(160);
	var further_details_component_1 = __webpack_require__(197);
	var appRoutes = [
	    {
	        path: 'home',
	        component: home_component_1.HomeComponent,
	        data: {
	            title: 'Home'
	        }
	    },
	    {
	        path: 'details',
	        component: further_details_component_1.FurtherDetailsComponent
	    },
	    {
	        path: 'storage',
	        redirectTo: 'database'
	    },
	    {
	        path: 'database',
	        component: storage_management_component_1.StorageManagementComponent
	    },
	    {
	        path: 'specifications',
	        component: specifications_component_1.SpecificationsComponent
	    },
	    {
	        path: 'dicom',
	        component: dicom_component_1.DicomComponent
	    },
	    {
	        path: 'parameterise',
	        component: parameterise_component_1.ParameteriseComponent
	    },
	    {
	        path: 'create-model',
	        component: create_model_component_1.CreateModelComponent
	    },
	    {
	        path: 'use-model',
	        component: use_model_component_1.UseModelComponent
	    },
	    {
	        path: '',
	        component: home_component_1.HomeComponent
	    },
	    {
	        path: 'model',
	        redirectTo: 'create-model'
	    },
	    {
	        path: '**', component: page_not_found_component_1.PageNotFoundComponent
	    }
	];
	exports.appRoutingProviders = [];
	exports.routing = router_1.RouterModule.forRoot(appRoutes);


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(41);
	var insert_data_1 = __webpack_require__(128);
	var electron_api_service_1 = __webpack_require__(129);
	var title_service_1 = __webpack_require__(131);
	var data_persistence_service_1 = __webpack_require__(132);
	var specifications_data_service_1 = __webpack_require__(139);
	var x_y_input_component_1 = __webpack_require__(141);
	var model_data_1 = __webpack_require__(137);
	var demo_data_1 = __webpack_require__(145);
	var ParameteriseComponent = (function () {
	    function ParameteriseComponent(electronApiService, myTitleService, router, modelData, dataPersistenceService, machineSpecificationService, applicationRef) {
	        this.electronApiService = electronApiService;
	        this.myTitleService = myTitleService;
	        this.router = router;
	        this.modelData = modelData;
	        this.dataPersistenceService = dataPersistenceService;
	        this.machineSpecificationService = machineSpecificationService;
	        this.applicationRef = applicationRef;
	        this.textInputsValid = true;
	        this.equalLengths = true;
	        this.serverResponseValid = true;
	        this.dataInFlight = false;
	        this.submitDisabled = false;
	        this.machineExists = false;
	        this.machineSettingsExist = false;
	        this.ableToAddDataToModel = false;
	        this.dataAlreadyExistsOnModel = false;
	        this.serverError = false;
	        this.insertData = new insert_data_1.InsertData();
	        this.dataLoaded = false;
	        this.viewInitialised = false;
	        this.initialTextBoxUpdate = false;
	    }
	    ParameteriseComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        console.log('parameterisation.component ngOnInit');
	        this.myTitleService.setTitle('Parameterisation');
	        this.dataPersistenceService.loadServerUrl('parameterisation')
	            .then(function (serverUrl) {
	            if (serverUrl == null) {
	                _this.parameteriseURL = 'http://electronapi.simonbiggs.net/parameterise';
	            }
	            else {
	                _this.parameteriseURL = serverUrl.url;
	            }
	        });
	        this.dataPersistenceService.loadCurrentInsertData(this.insertData)
	            .then(function () {
	            _this.checkIfEqualLengths();
	            return _this.machineSpecificationService.loadData();
	        })
	            .then(function () {
	            console.log('specifications.component ngOnInit this.machineSpecificationService.loadData() promise complete');
	            _this.machineSettings = _this.machineSpecificationService.currentSettings;
	            _this.checkMachineSettings();
	            _this.checkIfCanBeSentToModel();
	            if (_this.viewInitialised && !_this.initialTextBoxUpdate) {
	                _this.textboxInputs.triggerUpdate = true;
	                _this.initialTextBoxUpdate = true;
	            }
	            _this.dataLoaded = true;
	        });
	    };
	    ParameteriseComponent.prototype.ngAfterViewInit = function () {
	        if (this.dataLoaded && !this.initialTextBoxUpdate) {
	            this.textboxInputs.triggerUpdate = true;
	            this.initialTextBoxUpdate = true;
	        }
	        this.viewInitialised = true;
	        // this.sleep(10)
	        // .then(() => {
	        //   this.textboxInputs.triggerUpdate = true
	        //   this.applicationRef.tick()
	        // })
	    };
	    ParameteriseComponent.prototype.ngAfterContentInit = function () {
	        // this.sleep(10)
	        // .then(() => {
	        //   this.textboxInputs.triggerUpdate = true
	        //   this.applicationRef.tick()
	        // })
	    };
	    ParameteriseComponent.prototype.checkMachineSettings = function () {
	        console.log('parameterisation.component checkMachineSettings');
	        if (this.machineSpecificationService.doesMachineExist(this.insertData.machine)) {
	            this.machineExists = true;
	            this.machineSettingsExist = this.machineSpecificationService.checkInsertSettingsExist(this.insertData);
	        }
	        else {
	            this.machineExists = false;
	            this.machineSettingsExist = false;
	        }
	        console.log(this.machineSettingsExist);
	    };
	    ParameteriseComponent.prototype.checkIfCanBeSentToModel = function () {
	        var _this = this;
	        console.log('parameterisation.component checkIfCanBeSentToModel');
	        if (this.machineSettingsExist) {
	            for (var _i = 0, _a = Object.keys(this.machineSettings); _i < _a.length; _i++) {
	                var key = _a[_i];
	                this.machineSettings[key] = this.insertData[key];
	            }
	            this.dataPersistenceService.loadModelData(this.modelData, this.machineSettings).then(function () {
	                console.log('parameterisation.component checkIfCanBeSentToModel this.dataPersistenceService.loadModelData(this.modelData, this.machineSettings) promise complete');
	                if (_this.modelData.measurement.width.indexOf(Number(_this.insertData.parameterisation.width)) > -1 &&
	                    _this.modelData.measurement.length.indexOf(Number(_this.insertData.parameterisation.length)) > -1 &&
	                    _this.modelData.measurement.measuredFactor.indexOf(Number(_this.insertData.measuredFactor)) > -1) {
	                    _this.dataAlreadyExistsOnModel = true;
	                    _this.ableToAddDataToModel = false;
	                }
	                else {
	                    _this.dataAlreadyExistsOnModel = false;
	                    if (Number(_this.insertData.parameterisation.width) == 0 ||
	                        Number(_this.insertData.parameterisation.length) == 0 ||
	                        Number(_this.insertData.measuredFactor) == 0) {
	                        _this.ableToAddDataToModel = false;
	                    }
	                    else {
	                        _this.ableToAddDataToModel = true;
	                    }
	                }
	            });
	        }
	        else {
	            this.ableToAddDataToModel = false;
	            this.dataAlreadyExistsOnModel = false;
	        }
	    };
	    ParameteriseComponent.prototype.onValidTextboxChange = function () {
	        var _this = this;
	        console.log('parameterisation.component onValidTextboxChange');
	        this.insertData.parameterisation.insertUpdated();
	        this.dataPersistenceService.loadParameterisationCache(this.insertData.parameterisation)
	            .then(function () {
	            console.log('parameterisation.component onValidTextboxChange this.dataPersistenceService.loadParameterisationCache(this.insertData.parameterisation) promise complete');
	            _this.checkIfEqualLengths();
	            _this.checkIfCanBeSentToModel();
	            return _this.dataPersistenceService.saveCurrentInsertData(_this.insertData);
	        })
	            .then(function () {
	            console.log('parameterisation.component onValidTextboxChange this.dataPersistenceService.saveCurrentInsertData(this.insertData)  promise complete');
	        });
	    };
	    ParameteriseComponent.prototype.checkIfEqualLengths = function () {
	        console.log('parameterisation.component checkIfEqualLengths');
	        if (this.insertData.parameterisation.insert.x.length == this.insertData.parameterisation.insert.y.length) {
	            this.equalLengths = true;
	        }
	        else {
	            this.equalLengths = false;
	        }
	    };
	    ParameteriseComponent.prototype.addMeasuredFactor = function (measuredFactor) {
	        var _this = this;
	        console.log('parameterisation.component addMeasuredFactor');
	        this.dataAlreadyExistsOnModel = true;
	        this.ableToAddDataToModel = false;
	        for (var _i = 0, _a = Object.keys(this.machineSettings); _i < _a.length; _i++) {
	            var key = _a[_i];
	            this.machineSettings[key] = this.insertData[key];
	        }
	        this.dataPersistenceService.loadModelData(this.modelData, this.machineSettings)
	            .then(function () {
	            console.log('parameterisation.component addMeasuredFactor this.dataPersistenceService.loadModelData(this.modelData, this.machineSettings) promise complete');
	            _this.modelData.model.reset();
	            _this.modelData.measurement.width.unshift(Number(_this.insertData.parameterisation.width));
	            _this.modelData.measurement.length.unshift(Number(_this.insertData.parameterisation.length));
	            _this.modelData.measurement.measuredFactor.unshift(Number(measuredFactor));
	            return _this.dataPersistenceService.saveModelData(_this.modelData, _this.machineSettings);
	        })
	            .then(function () {
	            console.log('parameterisation.component addMeasuredFactor this.dataPersistenceService.saveModelData(this.modelData, this.machineSettings) promise complete');
	            return _this.dataPersistenceService.saveCurrentSettings(_this.machineSettings);
	        })
	            .then(function () {
	            console.log('parameterisation.component addMeasuredFactor this.dataPersistenceService.saveCurrentSettings(this.machineSettings) promise complete');
	        });
	    };
	    ParameteriseComponent.prototype.predictFactor = function () {
	        var _this = this;
	        console.log('parameterisation.component predictFactor');
	        for (var _i = 0, _a = Object.keys(this.machineSettings); _i < _a.length; _i++) {
	            var key = _a[_i];
	            this.machineSettings[key] = this.insertData[key];
	        }
	        this.dataPersistenceService.saveCurrentSettings(this.machineSettings)
	            .then(function () {
	            console.log('parameterisation.component predictFactor this.dataPersistenceService.saveCurrentSettings(this.machineSettings) promise complete');
	            return _this.dataPersistenceService.loadModelData(_this.modelData, _this.machineSettings);
	        })
	            .then(function () {
	            console.log('parameterisation.component predictFactor this.dataPersistenceService.loadModelData(this.modelData, this.machineSettings) promise complete');
	            _this.modelData.predictions.width.unshift(_this.insertData.parameterisation.width);
	            _this.modelData.predictions.length.unshift(_this.insertData.parameterisation.length);
	            if (_this.insertData.measuredFactor != 0 && _this.insertData.measuredFactor != null) {
	                _this.modelData.predictions.measuredFactor.unshift(_this.insertData.measuredFactor);
	            }
	            else {
	                _this.modelData.predictions.measuredFactor.unshift(NaN);
	            }
	            return _this.dataPersistenceService.saveModelData(_this.modelData, _this.machineSettings);
	        })
	            .then(function () {
	            console.log('parameterisation.component predictFactor this.dataPersistenceService.saveModelData(this.modelData, this.machineSettings) promise complete');
	            _this.router.navigate(["/use-model"]);
	        });
	    };
	    ParameteriseComponent.prototype.loadDemoData = function () {
	        var _this = this;
	        console.log('parameterisation.component loadDemoData');
	        var insert = this.insertData.parameterisation.insert;
	        this.insertData.reset();
	        this.insertData.parameterisation.insert = insert;
	        var demoData = JSON.parse(JSON.stringify(demo_data_1.DEMO_PARAMETERISE_INPUT));
	        this.insertData.parameterisation.insert.x = demoData.insert.x;
	        this.insertData.parameterisation.insert.y = demoData.insert.y;
	        this.insertData.parameterisation.insertUpdated();
	        this.dataPersistenceService.loadParameterisationCache(this.insertData.parameterisation)
	            .then(function () {
	            console.log('parameterisation.component loadDemoData this.dataPersistenceService.loadParameterisationCache(this.insertData.parameterisation) promise complete');
	            _this.textboxInputs.triggerUpdate = true;
	            _this.checkIfEqualLengths();
	            return _this.dataPersistenceService.saveCurrentInsertData(_this.insertData);
	        })
	            .then(function () {
	            console.log('parameterisation.component loadDemoData this.dataPersistenceService.saveCurrentInsertData(this.insertData) promise complete');
	        });
	    };
	    ParameteriseComponent.prototype.sleep = function (time) {
	        console.log('parameterisation.component sleep');
	        return new Promise(function (resolve) { return setTimeout(resolve, time); });
	    };
	    ParameteriseComponent.prototype.recursiveServerSubmit = function () {
	        var _this = this;
	        console.log('parameterisation.component recursiveServerSubmit');
	        this.serverError = false;
	        this.electronApiService.sendToServer(this.parameteriseURL, JSON.stringify(this.insertData.parameterisation.insert))
	            .then(function (parameterisationResult) {
	            _this.insertData.parameterisation.circle = parameterisationResult.circle;
	            _this.insertData.parameterisation.ellipse = parameterisationResult.ellipse;
	            _this.insertData.parameterisation.width = parameterisationResult.width;
	            _this.insertData.parameterisation.length = parameterisationResult.length;
	            var complete = parameterisationResult.complete;
	            if (complete) {
	                _this.dataInFlight = false;
	                _this.serverResponseValid = true;
	                _this.checkSubmitButton();
	                _this.dataPersistenceService.saveParameterisationCache(_this.insertData.parameterisation)
	                    .then(function () {
	                    console.log('parameterisation.component recursiveServerSubmit this.dataPersistenceService.saveParameterisationCache(this.insertData.parameterisation) promise complete');
	                });
	                _this.dataPersistenceService.saveCurrentInsertData(_this.insertData)
	                    .then(function () {
	                    console.log('parameterisation.component recursiveServerSubmit this.dataPersistenceService.saveCurrentInsertData(this.insertData) promise complete');
	                });
	                _this.checkIfCanBeSentToModel();
	                if (_this.insertData.parameterisation.width == null) {
	                    _this.serverError = true;
	                }
	            }
	            else {
	                _this.sleep(500).then(function () { return _this.recursiveServerSubmit(); });
	            }
	        });
	    };
	    ParameteriseComponent.prototype.insertDataChange = function () {
	        console.log('parameterisation.component insertDataChange');
	        this.dataPersistenceService.saveCurrentInsertData(this.insertData)
	            .then(function () {
	            console.log('parameterisation.component insertDataChange this.dataPersistenceService.saveCurrentInsertData(this.insertData) promise complete');
	        });
	        this.checkMachineSettings();
	        this.checkIfCanBeSentToModel();
	    };
	    ParameteriseComponent.prototype.onSubmit = function () {
	        console.log('parameterisation.component onSubmit');
	        this.dataInFlight = true;
	        this.checkSubmitButton();
	        this.recursiveServerSubmit();
	    };
	    ParameteriseComponent.prototype.onTextInputChange = function (testInputStatus) {
	        console.log('parameterisation.component onTextInputChange');
	        this.textInputsValid = testInputStatus;
	        this.checkSubmitButton();
	    };
	    ParameteriseComponent.prototype.checkSubmitButton = function () {
	        console.log('parameterisation.component checkSubmitButton');
	        if (this.dataInFlight || !this.textInputsValid) {
	            this.submitDisabled = true;
	        }
	        else {
	            this.submitDisabled = false;
	        }
	    };
	    ParameteriseComponent.prototype.parameterisationServerChange = function (serverUrl) {
	        console.log('parameterisation.component parameterisationServerChange');
	        this.dataPersistenceService.saveServerUrl('parameterisation', serverUrl)
	            .then(function () {
	        });
	    };
	    __decorate([
	        core_1.ViewChild('textboxInputs'), 
	        __metadata('design:type', x_y_input_component_1.XYInputComponent)
	    ], ParameteriseComponent.prototype, "textboxInputs", void 0);
	    ParameteriseComponent = __decorate([
	        core_1.Component({
	            selector: 'my-parameterise',
	            template: __webpack_require__(146),
	        }), 
	        __metadata('design:paramtypes', [electron_api_service_1.ElectronApiService, title_service_1.TitleService, router_1.Router, model_data_1.ModelData, data_persistence_service_1.DataPersistenceService, specifications_data_service_1.MachineSpecificationsService, core_1.ApplicationRef])
	    ], ParameteriseComponent);
	    return ParameteriseComponent;
	}());
	exports.ParameteriseComponent = ParameteriseComponent;


/***/ },
/* 128 */
/***/ function(module, exports) {

	"use strict";
	var Coordinates = (function () {
	    function Coordinates() {
	        this.x = [0];
	        this.y = [0];
	    }
	    return Coordinates;
	}());
	exports.Coordinates = Coordinates;
	var Parameterisation = (function () {
	    function Parameterisation() {
	        this.insert = new Coordinates();
	        this.circle = new Coordinates();
	        this.ellipse = new Coordinates();
	    }
	    Parameterisation.prototype.hash = function (input) {
	        var hash = 0, i, chr, len;
	        if (input.length === 0)
	            return hash;
	        for (i = 0, len = input.length; i < len; i++) {
	            chr = input.charCodeAt(i);
	            hash = ((hash << 5) - hash) + chr;
	            hash |= 0; // Convert to 32bit integer
	        }
	        return hash;
	    };
	    Parameterisation.prototype.insertUpdated = function () {
	        if (this.insert != null) {
	            this.id = this.hash('{"x":' + JSON.stringify(this.insert.x) + ',' +
	                '"y":' + JSON.stringify(this.insert.y) +
	                '}');
	        }
	        else {
	            throw new RangeError('Insert was not defined. Cannot run insert updated.');
	        }
	    };
	    Parameterisation.prototype.reset = function () {
	        this.id = null;
	        for (var _i = 0, _a = ['insert', 'circle', 'ellipse']; _i < _a.length; _i++) {
	            var key = _a[_i];
	            this[key] = new Coordinates();
	            this[key].x = [0];
	            this[key].y = [0];
	        }
	        this.width = null;
	        this.length = null;
	    };
	    return Parameterisation;
	}());
	exports.Parameterisation = Parameterisation;
	var InsertData = (function () {
	    function InsertData(inputId) {
	        this.parameterisation = new Parameterisation();
	        if (inputId != null) {
	            this.id = inputId;
	        }
	        else {
	            this.id = 0;
	        }
	    }
	    InsertData.prototype.reset = function () {
	        this.machine = null;
	        this.parameterisation.reset();
	        this.energy = null;
	        this.applicator = null;
	        this.ssd = null;
	        this.measuredFactor = null;
	    };
	    InsertData.prototype.fillFromObject = function (object) {
	        if (object == null) {
	            this.reset();
	        }
	        else {
	            for (var _i = 0, _a = ['machine', 'energy', 'applicator', 'ssd', 'measuredFactor']; _i < _a.length; _i++) {
	                var key = _a[_i];
	                this[key] = object[key];
	            }
	            this.parameterisation.insert = object['parameterisation'].insert;
	            this.parameterisation.insertUpdated();
	            this.parameterisation.circle = object['parameterisation'].circle;
	            this.parameterisation.ellipse = object['parameterisation'].ellipse;
	            this.parameterisation.width = object['parameterisation'].width;
	            this.parameterisation.length = object['parameterisation'].length;
	        }
	    };
	    return InsertData;
	}());
	exports.InsertData = InsertData;


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(28);
	__webpack_require__(130);
	var ElectronApiService = (function () {
	    function ElectronApiService(http) {
	        this.http = http;
	        // private parameteriseURL = 'http://electronapi.simonbiggs.net/parameterise';
	        // private modelURL = 'http://electronapi.simonbiggs.net/model';
	        this.wakeUpURL = 'http://electronapi.simonbiggs.net/wakeup';
	    }
	    // Initial get from server to wake it up
	    ElectronApiService.prototype.wakeUpServer = function () {
	        return this.http
	            .get(this.wakeUpURL).toPromise();
	    };
	    ElectronApiService.prototype.sendToServer = function (URL, input) {
	        return this.http
	            .post(URL, input)
	            .toPromise()
	            .then(function (res) {
	            var nan = null;
	            return res.json();
	        })
	            .catch(this.handleError);
	    };
	    ElectronApiService.prototype.handleError = function (error) {
	        console.error('An error occurred', error);
	        return Promise.reject(error.message || error);
	    };
	    ElectronApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_1.Http])
	    ], ElectronApiService);
	    return ElectronApiService;
	}());
	exports.ElectronApiService = ElectronApiService;


/***/ },
/* 130 */,
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var TitleService = (function () {
	    function TitleService() {
	        this.title = 'Home';
	    }
	    TitleService.prototype.getTitle = function () {
	        return this.title;
	    };
	    TitleService.prototype.setTitle = function (title) {
	        this.title = title;
	    };
	    TitleService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], TitleService);
	    return TitleService;
	}());
	exports.TitleService = TitleService;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	// import Dexie from 'dexie'
	var dexie_service_1 = __webpack_require__(133);
	var current_settings_1 = __webpack_require__(140);
	var insert_data_1 = __webpack_require__(128);
	var DataPersistenceService = (function () {
	    function DataPersistenceService() {
	    }
	    DataPersistenceService.prototype.loadCurrentSettings = function () {
	        console.log('data-persistence.service loadCurrentSettings');
	        var currentSettings = new current_settings_1.CurrentSettings();
	        return dexie_service_1.db.currentSettings.toArray()
	            .then(function (result) {
	            console.log('data-persistence.service loadCurrentSettings db.currentSettings.toArray() promise complete');
	            if (result.length == 0) {
	                for (var _i = 0, _a = ['machine', 'energy', 'applicator', 'ssd']; _i < _a.length; _i++) {
	                    var key = _a[_i];
	                    currentSettings[key] = null;
	                }
	            }
	            else {
	                currentSettings = result[0];
	            }
	            // console.log(currentSettings)
	            return currentSettings;
	        });
	    };
	    DataPersistenceService.prototype.saveCurrentSettings = function (currentSettings) {
	        console.log('data-persistence.service saveCurrentSettings');
	        return dexie_service_1.db.currentSettings.put(currentSettings)
	            .then(function () {
	            console.log('data-persistence.service saveCurrentSettings db.currentSettings.put(currentSettings) promise complete');
	        });
	    };
	    DataPersistenceService.prototype.loadSpecificationsData = function () {
	        console.log('data-persistence.service loadSpecificationsData');
	        return dexie_service_1.db.specifications.toArray()
	            .then(function (result) {
	            console.log('data-persistence.service loadSpecificationsData db.specifications.toArray() promise complete');
	            return result;
	        });
	    };
	    DataPersistenceService.prototype.saveSpecificationsData = function (specification) {
	        console.log('data-persistence.service saveSpecificationsData');
	        return dexie_service_1.db.specifications.put(specification)
	            .then(function () {
	            console.log("data-persistence.service saveSpecificationsData db.specifications.put(specification) promise complete");
	        });
	    };
	    DataPersistenceService.prototype.loadModelData = function (modelData, currentSettings) {
	        console.log('data-persistence.service loadModelData');
	        var storageKey = currentSettings.returnKey();
	        modelData.machineSettingsKey = storageKey;
	        return dexie_service_1.db.modelData.get(storageKey)
	            .then(function (result) {
	            console.log("data-persistence.service loadModelData db.modelData.get(storageKey) promise complete");
	            if (result == null) {
	                modelData.fillFromObject({});
	            }
	            else {
	                modelData.fillFromObject(result);
	            }
	        });
	    };
	    DataPersistenceService.prototype.saveModelData = function (modelData, currentSettings) {
	        console.log('data-persistence.service saveModelData');
	        var storageKey = currentSettings.returnKey();
	        modelData.machineSettingsKey = storageKey;
	        var modelDataLite = modelData.exportLite();
	        return dexie_service_1.db.modelData.put(modelDataLite)
	            .then(function () {
	            console.log("data-persistence.service loadModelData db.modelData.put(modelDataLite) promise complete");
	        });
	    };
	    DataPersistenceService.prototype.loadParameterisationCache = function (parameterisation) {
	        console.log('data-persistence.service loadParameterisationCache');
	        return dexie_service_1.db.parameterisationCache.get(parameterisation.id)
	            .then(function (result) {
	            console.log("data-persistence.service loadParameterisationCache db.parameterisationCache.get(parameterisation.parameterisationKey) promise complete");
	            if (result == null) {
	                for (var _i = 0, _a = ['width', 'length', 'circle', 'ellipse']; _i < _a.length; _i++) {
	                    var key = _a[_i];
	                    parameterisation[key] = null;
	                }
	            }
	            else {
	                for (var _b = 0, _c = ['width', 'length', 'circle', 'ellipse']; _b < _c.length; _b++) {
	                    var key = _c[_b];
	                    parameterisation[key] = result[key];
	                }
	            }
	        });
	        // let localStorageObject = JSON.parse(localStorage.getItem(parameterisation.parameterisationKey))
	        // if (localStorageObject) {
	        //   for (let key of ['circle', 'ellipse']) {
	        //     parameterisation[key] = new Coordinates()
	        //     if (localStorageObject[key]) {
	        //       parameterisation[key].x = localStorageObject[key].x
	        //       parameterisation[key].y = localStorageObject[key].y
	        //     }
	        //     else {
	        //       parameterisation[key].x = [0]
	        //       parameterisation[key].y = [0] 
	        //     }
	        //   }
	        //   parameterisation.width = localStorageObject['width']
	        //   parameterisation.length = localStorageObject['length']
	        // }
	        // else {
	        //   for (let key of ['width', 'length', 'circle', 'ellipse']) {
	        //     parameterisation[key] = null
	        //   }
	        // }
	    };
	    DataPersistenceService.prototype.saveParameterisationCache = function (parameterisation) {
	        console.log('data-persistence.service saveParameterisationCache');
	        return dexie_service_1.db.parameterisationCache.put(parameterisation)
	            .then(function () {
	            console.log("data-persistence.service saveParameterisationCache db.parameterisationCache.put(parameterisation) promise complete");
	        });
	        // localStorage.setItem(
	        //   JSON.stringify(parameterisation.insert), 
	        //   JSON.stringify(parameterisation)
	        // )
	    };
	    DataPersistenceService.prototype.loadCurrentInsertData = function (insertData) {
	        console.log('data-persistence.service loadCurrentInsertData');
	        // This is required because the coodinate inputs to the text boxes are not using ngModel.
	        // This work around is brittle.
	        var insert = insertData.parameterisation.insert;
	        // let parameterisation = new Parameterisation()
	        // parameterisation.insert = insertData.parameterisation.insert
	        // parameterisation.insertUpdated()
	        // insertData.parameterisation = parameterisation
	        // this.loadParameterisationCache(insertData.parameterisation)
	        return dexie_service_1.db.currentInsertData.get(0)
	            .then(function (result) {
	            if (result == null) {
	                insertData.reset();
	            }
	            else {
	                insert.x = result.parameterisation.insert.x;
	                insert.y = result.parameterisation.insert.y;
	                insertData.fillFromObject(result);
	            }
	            insertData.parameterisation.insert = insert;
	        });
	        // let localStorageInsertDataString = localStorage['last_insertData']
	        // let object = JSON.parse(localStorageInsertDataString)
	        // if (object != null) {      
	        //   insertData.fillFromObject(object)
	        //   this.loadParameterisationCache(insertData.parameterisation)
	        // }
	    };
	    DataPersistenceService.prototype.saveCurrentInsertData = function (insertData) {
	        console.log('data-persistence.service saveCurrentInsertData');
	        return dexie_service_1.db.currentInsertData.put(insertData)
	            .then(function () {
	            console.log("data-persistence.service saveCurrentInsertData db.currentInsertData.put(insertData)) promise complete");
	        });
	        // localStorage.setItem(
	        //   "last_insertData", JSON.stringify(insertData))
	    };
	    DataPersistenceService.prototype.loadServerUrl = function (purpose) {
	        console.log('data-persistence.service loadServerUrl');
	        return dexie_service_1.db.serverURLs.get(purpose);
	        // let url: string
	        // if (purpose == 'parameterisation') {
	        //   url = localStorage.getItem("parameteriseURL")
	        //   if (url == null) {
	        //     url = 'http://electronapi.simonbiggs.net/parameterise';
	        //   }
	        // }
	        // if (purpose == 'model') {
	        //   url = localStorage.getItem("modelURL")
	        //   if (url == null) {
	        //     url = 'http://electronapi.simonbiggs.net/model';
	        //   }
	        // }
	        // if (url == null) {
	        //   throw new Error("Url was null")
	        // }
	        // return url
	    };
	    DataPersistenceService.prototype.saveServerUrl = function (purpose, url) {
	        console.log('data-persistence.service saveServerUrl');
	        var serverUrl = new dexie_service_1.ServerURLs();
	        serverUrl.purpose = purpose;
	        serverUrl.url = url;
	        return dexie_service_1.db.serverURLs.put(serverUrl);
	        // if (purpose == 'parameterisation') {
	        //   localStorage.setItem("parameteriseURL", url)
	        // }
	        // if (purpose == 'model') {
	        //   localStorage.setItem("modelURL", url)
	        // }
	    };
	    DataPersistenceService.prototype.loadDicomInsertList = function () {
	        var _this = this;
	        console.log('data-persistence.service loadDicomInsertList');
	        return dexie_service_1.db.dicomInsertList.toArray()
	            .then(function (result) {
	            console.log('data-persistence.service loadDicomInsertList db.dicomInsertList.toArray() promise complete');
	            for (var _i = 0, result_1 = result; _i < result_1.length; _i++) {
	                var insertData = result_1[_i];
	                var parameterisation = new insert_data_1.Parameterisation();
	                parameterisation.insert = insertData.parameterisation.insert;
	                parameterisation.insertUpdated();
	                insertData.parameterisation = parameterisation;
	                _this.loadParameterisationCache(insertData.parameterisation);
	            }
	            return result;
	        });
	        // let insertList: InsertData[]
	        // let insertListString = localStorage.getItem('dicom_insertList')
	        // if (insertListString) {
	        //   insertList = JSON.parse(insertListString);
	        // }
	        // else {
	        //   insertList = []
	        // }
	        // return insertList
	    };
	    DataPersistenceService.prototype.saveDicomInsertList = function (insertList) {
	        console.log('data-persistence.service saveDicomInsertList');
	        return dexie_service_1.db.dicomInsertList.bulkPut(insertList)
	            .then(function () {
	            console.log('data-persistence.service saveDicomInsertList db.dicomInsertList.bulkPut(insertList) promise complete');
	        });
	        // localStorage.setItem('dicom_insertList', JSON.stringify(insertList));
	    };
	    DataPersistenceService.prototype.jsonTransform = function (input) {
	        console.log('data-persistence.service jsonTransform');
	        var jsonText = JSON.stringify(input, null, 2);
	        jsonText = jsonText.replace(/,\s*(-?\d+(\.\d+)?)/g, ", $1");
	        jsonText = jsonText.replace(/\n/g, "\n  ");
	        return jsonText;
	    };
	    DataPersistenceService.prototype.databaseDump = function () {
	        var _this = this;
	        console.log('data-persistence.service databaseDump');
	        var schemaString = "";
	        var tablesString = "";
	        var tableDumps = {};
	        var stringDump = "";
	        var promiseList = [];
	        dexie_service_1.db.tables.forEach(function (table, i) {
	            var primKeyAndIndexes = [table.schema.primKey].concat(table.schema.indexes);
	            var schemaSyntax = primKeyAndIndexes.map(function (index) { return index.src; }).join(', ');
	            schemaString = schemaString.concat("\n" + "      \"" + table.name + "\": " + "\"" +
	                schemaSyntax + "\"" + (i < dexie_service_1.db.tables.length - 1 ? "," : ""));
	            tableDumps[table.name] = {};
	            promiseList.push(table.toArray(function (objectArray) {
	                tableDumps[table.name] = objectArray;
	            }));
	        });
	        return Promise.all(promiseList)
	            .then(function () {
	            stringDump = "{\n  \"databaseDetails\": {\n    \"name\": \"" + dexie_service_1.db.name + "\",\n    \"version\": " + dexie_service_1.db.verno + ",\n    \"schema\": {" + schemaString + "\n    }\n  },\n  \"databaseContents\": " + _this.jsonTransform(tableDumps) + "\n}";
	            // console.log(stringDump)
	            return stringDump;
	        });
	    };
	    DataPersistenceService.prototype.emptyDatabase = function () {
	        console.log('data-persistence.service emptyDatabase');
	        var promiseList = [];
	        var pulledFromLocalStorage;
	        dexie_service_1.db.tables.forEach(function (table, i) {
	            promiseList.push(table.clear());
	        });
	        return Promise.all(promiseList)
	            .then(function () {
	            pulledFromLocalStorage = {
	                id: 0,
	                pulledFromLocalStorage: true
	            };
	            return dexie_service_1.db.pulledFromLocalStorage.add(pulledFromLocalStorage);
	        });
	    };
	    DataPersistenceService.prototype.appendJsonToDatabase = function (object) {
	        console.log('data-persistence.service appendJsonToDatabase');
	        var promiseList = [];
	        var databaseContents = object['databaseContents'];
	        dexie_service_1.db.tables.forEach(function (table, i) {
	            promiseList.push(table.bulkPut(databaseContents[table.name]));
	        });
	        return Promise.all(promiseList);
	    };
	    DataPersistenceService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], DataPersistenceService);
	    return DataPersistenceService;
	}());
	exports.DataPersistenceService = DataPersistenceService;


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var dexie_1 = __webpack_require__(134);
	var insert_data_1 = __webpack_require__(128);
	var model_data_1 = __webpack_require__(137);
	var specifications_data_service_1 = __webpack_require__(139);
	var current_settings_1 = __webpack_require__(140);
	var PulledFromLocalStorage = (function () {
	    function PulledFromLocalStorage() {
	    }
	    return PulledFromLocalStorage;
	}());
	exports.PulledFromLocalStorage = PulledFromLocalStorage;
	var ServerURLs = (function () {
	    function ServerURLs() {
	    }
	    return ServerURLs;
	}());
	exports.ServerURLs = ServerURLs;
	var DexieDatabase = (function (_super) {
	    __extends(DexieDatabase, _super);
	    function DexieDatabase() {
	        var _this = this;
	        _super.call(this, "DefaultDatabase");
	        var db = this;
	        // db.delete()
	        db.version(1).stores({
	            specifications: 'machine, makeAndModel, energy, R50, applicator, ssd',
	            currentSettings: 'id, machine, energy, applicator, ssd',
	            currentInsertData: 'id, machine, parameterisation, energy, applicator, ssd, measuredFactor',
	            modelData: 'machineSettingsKey, measurement, model, predictions',
	            dicomInsertList: 'id, machine, parameterisation, energy, applicator, ssd, measuredFactor',
	            serverURLs: 'purpose, url',
	            parameterisationCache: 'id, insert, width, length, circle, ellipse',
	            pulledFromLocalStorage: 'id, pulledFromLocalStorage'
	        });
	        db.pulledFromLocalStorage.mapToClass(PulledFromLocalStorage);
	        db.modelData.mapToClass(model_data_1.ModelData);
	        db.specifications.mapToClass(specifications_data_service_1.MachineSpecification);
	        db.currentSettings.mapToClass(current_settings_1.CurrentSettings);
	        db.parameterisationCache.mapToClass(insert_data_1.Parameterisation);
	        db.currentInsertData.mapToClass(insert_data_1.InsertData);
	        db.serverURLs.mapToClass(ServerURLs);
	        db.dicomInsertList.mapToClass(insert_data_1.InsertData);
	        db.pulledFromLocalStorage.toArray()
	            .then(function (result) {
	            if (result[0] == null) {
	                _this.fillDatabaseFromLocalStorage();
	            }
	            else if (result[0].pulledFromLocalStorage == false) {
	                db.specifications.clear();
	                db.modelData.clear();
	                _this.fillDatabaseFromLocalStorage();
	            }
	        });
	    }
	    DexieDatabase.prototype.fillDatabaseFromLocalStorage = function () {
	        console.log('dexie.service fillDatabaseFromLocalStorage');
	        var specifications = this.loadSpecificationsFromLocalStorage();
	        var machineList = [];
	        for (var _i = 0, specifications_1 = specifications; _i < specifications_1.length; _i++) {
	            var specification = specifications_1[_i];
	            machineList.push(specification.machine);
	        }
	        machineList.sort();
	        for (var i = 0; i < machineList.length - 1; i++) {
	            if (machineList[i] == machineList[i + 1]) {
	                console.log(machineList);
	                throw new RangeError("Local storage specifications contain duplicate Machine IDs");
	            }
	        }
	        var modelDataLiteArray = this.loadModelDataFromLocalStorage(specifications);
	        var machineSettingsKeys = [];
	        for (var _a = 0, modelDataLiteArray_1 = modelDataLiteArray; _a < modelDataLiteArray_1.length; _a++) {
	            var modelDataLite = modelDataLiteArray_1[_a];
	            machineSettingsKeys.push(modelDataLite.machineSettingsKey);
	        }
	        machineSettingsKeys.sort();
	        for (var i = 0; i < machineSettingsKeys.length - 1; i++) {
	            if (machineSettingsKeys[i] == machineSettingsKeys[i + 1]) {
	                throw new RangeError("Local storage specifications contain duplicate models");
	            }
	        }
	        exports.db.specifications.bulkAdd(specifications)
	            .then(function () {
	            console.log('dexie.service fillDatabaseFromLocalStorage db.specification.bulkAdd(specifications) promise complete');
	            return exports.db.modelData.bulkAdd(modelDataLiteArray);
	        })
	            .then(function () {
	            console.log('dexie.service fillDatabaseFromLocalStorage db.modelData.bulkAdd(modelDataLiteArray) promise complete');
	            var pulledFromLocalStorage = {
	                id: 0,
	                pulledFromLocalStorage: true
	            };
	            exports.db.pulledFromLocalStorage.add(pulledFromLocalStorage);
	        });
	    };
	    DexieDatabase.prototype.testArrayOfStrings = function (input) {
	        console.log('dexie.service testArrayOfStrings');
	        if (input instanceof Array) {
	            input.forEach(function (item) {
	                if (typeof item !== 'string') {
	                    return false;
	                }
	            });
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    DexieDatabase.prototype.testArrayOfNumbers = function (input) {
	        console.log('dexie.service testArrayOfNumbers');
	        if (input instanceof Array) {
	            input.forEach(function (item) {
	                if (typeof item !== 'number') {
	                    return false;
	                }
	            });
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    DexieDatabase.prototype.loadSpecificationsFromLocalStorage = function () {
	        console.log('dexie.service loadSpecificationsFromLocalStorage');
	        var oldSpec = JSON.parse(localStorage.getItem("specifications"));
	        var newSpec;
	        var newSpecArray = [];
	        var makeAndModel;
	        var energy;
	        var R50;
	        var applicator;
	        var ssd;
	        if (oldSpec != null) {
	            for (var _i = 0, _a = Object.keys(oldSpec); _i < _a.length; _i++) {
	                var machine = _a[_i];
	                makeAndModel = oldSpec[machine]['model'];
	                energy = oldSpec[machine]['energy'];
	                R50 = [];
	                for (var _b = 0, _c = oldSpec[machine]['energy']; _b < _c.length; _b++) {
	                    var energy_1 = _c[_b];
	                    R50.push(oldSpec[machine]['R50'][energy_1]);
	                }
	                applicator = oldSpec[machine]['applicator'];
	                ssd = oldSpec[machine]['ssd'];
	                if (makeAndModel !== undefined && typeof makeAndModel !== "string") {
	                    console.log(makeAndModel);
	                    throw new RangeError("Loaded makeAndModel type was not string");
	                }
	                if (energy !== undefined && !this.testArrayOfNumbers(energy)) {
	                    console.log(energy);
	                    throw new RangeError("Loaded energy type was not number[]");
	                }
	                if (R50 !== undefined && !this.testArrayOfNumbers(R50)) {
	                    console.log(R50);
	                    throw new RangeError("Loaded energy type was not number[]");
	                }
	                if (applicator !== undefined && !this.testArrayOfStrings(applicator)) {
	                    console.log(applicator);
	                    throw new RangeError("Loaded applicator type was not string[]");
	                }
	                if (ssd !== undefined && !this.testArrayOfNumbers(ssd)) {
	                    console.log(ssd);
	                    throw new RangeError("Loaded ssd type was not number[]");
	                }
	                newSpec = {
	                    machine: machine,
	                    makeAndModel: makeAndModel,
	                    energy: energy,
	                    R50: R50,
	                    applicator: applicator,
	                    ssd: ssd
	                };
	                newSpecArray.push(newSpec);
	            }
	        }
	        return newSpecArray;
	    };
	    DexieDatabase.prototype.loadModelDataFromLocalStorage = function (specificationsArray) {
	        console.log('dexie.service loadModelDataFromLocalStorage');
	        var modelData;
	        var modelDataLiteArray = [];
	        var currentSettings = new current_settings_1.CurrentSettings();
	        for (var _i = 0, specificationsArray_1 = specificationsArray; _i < specificationsArray_1.length; _i++) {
	            var specification = specificationsArray_1[_i];
	            currentSettings.machine = specification.machine;
	            for (var _a = 0, _b = specification.energy; _a < _b.length; _a++) {
	                var energy = _b[_a];
	                currentSettings.energy = energy;
	                for (var _c = 0, _d = specification.applicator; _c < _d.length; _c++) {
	                    var applicator = _d[_c];
	                    currentSettings.applicator = applicator;
	                    for (var _e = 0, _f = specification.ssd; _e < _f.length; _e++) {
	                        var ssd = _f[_e];
	                        currentSettings.ssd = ssd;
	                        var parsedData = JSON.parse(localStorage.getItem(currentSettings.returnKey()));
	                        if (parsedData != null) {
	                            modelData = new model_data_1.ModelData();
	                            modelData.fillFromObject(parsedData);
	                            modelData.updateKey(currentSettings);
	                            modelDataLiteArray.push(modelData.exportLite());
	                        }
	                    }
	                }
	            }
	        }
	        return modelDataLiteArray;
	    };
	    return DexieDatabase;
	}(dexie_1.default));
	exports.DexieDatabase = DexieDatabase;
	exports.db = new DexieDatabase();


/***/ },
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var base_data_1 = __webpack_require__(138);
	var AreaLengthConversion = (function (_super) {
	    __extends(AreaLengthConversion, _super);
	    function AreaLengthConversion() {
	        _super.apply(this, arguments);
	        this.width = [];
	        this.length = [];
	        this.area = [];
	        this.measuredFactor = [];
	    }
	    AreaLengthConversion.prototype.convertLengthToArea = function (width, length) {
	        console.log('model.data AreaLengthConversion convertLengthToArea');
	        var area = Math.PI * width * length / 4;
	        return Math.round(area * 10) / 10;
	    };
	    AreaLengthConversion.prototype.convertAreaToLength = function (width, area) {
	        console.log('model.data AreaLengthConversion convertAreaToLength');
	        var length = 4 * area / (Math.PI * width);
	        return Math.round(length * 10) / 10;
	    };
	    AreaLengthConversion.prototype.updateAreaFromLength = function () {
	        console.log('model.data AreaLengthConversion updateAreaFromLength');
	        var width;
	        var length;
	        var area;
	        this.area = [];
	        for (var i in this.length) {
	            width = this.width[i];
	            length = this.length[i];
	            area = this.convertLengthToArea(width, length);
	            this.area.push(area);
	        }
	    };
	    AreaLengthConversion.prototype.updateLengthFromArea = function () {
	        console.log('model.data AreaLengthConversion updateLengthFromArea');
	        var width;
	        var length;
	        var area;
	        this.length = [];
	        for (var i in this.area) {
	            width = this.width[i];
	            area = this.area[i];
	            length = this.convertAreaToLength(width, area);
	            this.length.push(length);
	        }
	    };
	    AreaLengthConversion.prototype.initialLengthAreaUpdate = function () {
	        console.log('model.data AreaLengthConversion initialLengthAreaUpdate');
	        if (this.length.length < this.area.length) {
	            this.updateLengthFromArea();
	        }
	        else {
	            this.updateAreaFromLength();
	        }
	    };
	    AreaLengthConversion = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], AreaLengthConversion);
	    return AreaLengthConversion;
	}(base_data_1.Base));
	exports.AreaLengthConversion = AreaLengthConversion;
	var ModelMeasurement = (function (_super) {
	    __extends(ModelMeasurement, _super);
	    function ModelMeasurement() {
	        _super.apply(this, arguments);
	        this.propNames = ['width', 'length', 'area', 'measuredFactor'];
	        this.keyConversions = {
	            'factor': 'measuredFactor'
	        };
	    }
	    ModelMeasurement = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], ModelMeasurement);
	    return ModelMeasurement;
	}(AreaLengthConversion));
	exports.ModelMeasurement = ModelMeasurement;
	var ModelGrid = (function (_super) {
	    __extends(ModelGrid, _super);
	    function ModelGrid() {
	        _super.apply(this, arguments);
	        this.propNames = ['width', 'length', 'predictedFactor'];
	        this.keyConversions = {
	            'factor': 'predictedFactor'
	        };
	        this.width = [];
	        this.length = [];
	        this.predictedFactor = [];
	    }
	    ModelGrid = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], ModelGrid);
	    return ModelGrid;
	}(base_data_1.Base));
	exports.ModelGrid = ModelGrid;
	var Predictions = (function (_super) {
	    __extends(Predictions, _super);
	    function Predictions() {
	        _super.apply(this, arguments);
	        this.propNames = ['width', 'length', 'area', 'measuredFactor', 'predictedFactor'];
	        this.predictedFactor = [];
	    }
	    Predictions = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], Predictions);
	    return Predictions;
	}(AreaLengthConversion));
	exports.Predictions = Predictions;
	var ModelData = (function () {
	    function ModelData() {
	        this.propNames = ['measurement', 'model', 'predictions'];
	        this.measurement = new ModelMeasurement();
	        this.model = new ModelGrid();
	        this.predictions = new Predictions();
	    }
	    ModelData.prototype.fillFromObject = function (object) {
	        console.log('model.data ModelData fillFromObject');
	        if (object == null) {
	            for (var _i = 0, _a = this.propNames; _i < _a.length; _i++) {
	                var propName = _a[_i];
	                this[propName].reset();
	            }
	        }
	        else {
	            for (var _b = 0, _c = this.propNames; _b < _c.length; _b++) {
	                var propName = _c[_b];
	                if (object[propName] == null) {
	                    this[propName].reset();
	                }
	                else {
	                    this[propName].fillFromObject(object[propName]);
	                }
	            }
	        }
	        this.measurement.initialLengthAreaUpdate();
	        this.predictions.initialLengthAreaUpdate();
	    };
	    ModelData.prototype.updateKey = function (currentSettings) {
	        this.machineSettingsKey = currentSettings.returnKey();
	    };
	    ModelData.prototype.exportLite = function () {
	        console.log('model.data ModelData exportLite');
	        var modelDataLite = {
	            machineSettingsKey: this.machineSettingsKey,
	            measurement: {
	                width: this.measurement.width,
	                length: this.measurement.length,
	                measuredFactor: this.measurement.measuredFactor
	            },
	            model: {
	                width: this.model.width,
	                length: this.model.length,
	                predictedFactor: this.model.predictedFactor
	            },
	            predictions: {
	                width: this.predictions.width,
	                length: this.predictions.length,
	                measuredFactor: this.predictions.measuredFactor,
	                predictedFactor: this.predictions.predictedFactor
	            }
	        };
	        return modelDataLite;
	    };
	    ModelData = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], ModelData);
	    return ModelData;
	}());
	exports.ModelData = ModelData;


/***/ },
/* 138 */
/***/ function(module, exports) {

	"use strict";
	var Base = (function () {
	    function Base() {
	    }
	    Base.prototype.reset = function () {
	        for (var _i = 0, _a = this.propNames; _i < _a.length; _i++) {
	            var propName = _a[_i];
	            this[propName] = [];
	        }
	    };
	    Base.prototype.fillFromObject = function (object) {
	        object = this.updateOldKeyNames(object);
	        for (var _i = 0, _a = this.propNames; _i < _a.length; _i++) {
	            var propName = _a[_i];
	            if (object[propName] == null) {
	                this[propName] = [];
	            }
	            else {
	                this[propName] = object[propName];
	            }
	        }
	    };
	    Base.prototype.updateOldKeyNames = function (object) {
	        var newKey;
	        for (var oldKey in this.keyConversions) {
	            if (object[oldKey] != null && object[this.keyConversions[oldKey]] == null) {
	                newKey = this.keyConversions[oldKey];
	                Object.defineProperty(object, newKey, Object.getOwnPropertyDescriptor(object, oldKey));
	                delete object[oldKey];
	            }
	        }
	        return object;
	    };
	    return Base;
	}());
	exports.Base = Base;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var current_settings_1 = __webpack_require__(140);
	var data_persistence_service_1 = __webpack_require__(132);
	var MachineSpecification = (function () {
	    function MachineSpecification() {
	        this.machine = "";
	        this.makeAndModel = "";
	        this.energy = [];
	        this.R50 = [];
	        this.applicator = [];
	        this.ssd = [];
	    }
	    MachineSpecification = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], MachineSpecification);
	    return MachineSpecification;
	}());
	exports.MachineSpecification = MachineSpecification;
	var MachineSpecificationsService = (function () {
	    function MachineSpecificationsService(currentSettings) {
	        this.currentSettings = currentSettings;
	        this.dataPersistenceService = new data_persistence_service_1.DataPersistenceService();
	    }
	    MachineSpecificationsService.prototype.checkInsertSettingsExist = function (insertData) {
	        var specification = this.returnMachineSpecification(insertData.machine);
	        console.log(specification);
	        if (specification.energy.indexOf(Number(insertData.energy)) > -1 &&
	            specification.applicator.indexOf(String(insertData.applicator)) > -1 &&
	            specification.ssd.indexOf(Number(insertData.ssd)) > -1) {
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    MachineSpecificationsService.prototype.doesMachineExist = function (machineID) {
	        if (this.machineList.indexOf(machineID) > -1) {
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    MachineSpecificationsService.prototype.returnMachineSpecification = function (machineID) {
	        var machineSpecification;
	        var index;
	        index = this.machineList.indexOf(machineID);
	        if (index == -1) {
	            // throw new RangeError("Requested machine does not exist")
	            machineSpecification = null;
	        }
	        else {
	            machineSpecification = this.specifications[index];
	        }
	        return machineSpecification;
	    };
	    MachineSpecificationsService.prototype.returnCurrentR50 = function (energyLookup) {
	        var index;
	        index = this.currentSpecification.energy.indexOf(energyLookup);
	        if (index == -1) {
	            throw new RangeError("Requested energy is not within the current specification");
	        }
	        return this.currentSpecification.R50[index];
	    };
	    MachineSpecificationsService.prototype.loadData = function () {
	        var _this = this;
	        console.log('specifications-data.service loadData');
	        return this.dataPersistenceService.loadCurrentSettings()
	            .then(function (currentSettings) {
	            console.log('specifications-data.service loadData this.dataPersistenceService.loadCurrentSettings() promise complete');
	            _this.currentSettings = currentSettings;
	            return _this.dataPersistenceService.loadSpecificationsData();
	        })
	            .then(function (specificationArray) {
	            console.log('specifications-data.service loadData this.dataPersistenceService.loadSpecificationsData() promise complete');
	            _this.specifications = specificationArray;
	            _this.updateSpecifications();
	        });
	    };
	    MachineSpecificationsService.prototype.updateSpecifications = function () {
	        console.log('specifications-data.service updateSpecifications');
	        if (this.specifications == null) {
	            this.specifications = [];
	            this.machineList = [];
	        }
	        else {
	            this.updateMachineList();
	            this.updateCurrentSpecification();
	        }
	    };
	    MachineSpecificationsService.prototype.updateMachineList = function () {
	        console.log('specifications-data.service updateMachineList');
	        this.machineList = [];
	        for (var _i = 0, _a = this.specifications; _i < _a.length; _i++) {
	            var specification = _a[_i];
	            this.machineList.push(specification.machine);
	        }
	    };
	    MachineSpecificationsService.prototype.updateCurrentSpecification = function () {
	        console.log('specifications-data.service updateCurrentSpecification');
	        var machineSpecification;
	        machineSpecification = this.returnMachineSpecification(this.currentSettings.machine);
	        if (machineSpecification == null) {
	            this.currentSpecification = this.specifications[0];
	            this.currentSettings.machine = this.machineList[0];
	        }
	        else {
	            this.currentSpecification = machineSpecification;
	        }
	        this.refreshCurrentSettings();
	        // console.warn(this.currentIndex)
	        // console.warn(this.specifications)
	        // console.warn(this.currentSpecification)
	    };
	    MachineSpecificationsService.prototype.refreshCurrentSettings = function () {
	        console.log('specifications-data.service refreshCurrentSettings');
	        if (this.currentSpecification != null) {
	            for (var _i = 0, _a = ["energy", "applicator", "ssd"]; _i < _a.length; _i++) {
	                var item = _a[_i];
	                if (this.currentSpecification[item] == null) {
	                    this.currentSettings[item] = null;
	                }
	                else {
	                    if (this.currentSpecification[item].length > 0) {
	                        if (this.currentSpecification[item].indexOf(this.currentSettings[item]) == -1) {
	                            this.currentSettings[item] = this.currentSpecification[item][0];
	                        }
	                    }
	                    else {
	                        this.currentSettings[item] = null;
	                    }
	                }
	            }
	        }
	        else {
	            for (var _b = 0, _c = ["energy", "applicator", "ssd"]; _b < _c.length; _b++) {
	                var item = _c[_b];
	                this.currentSettings[item] = null;
	            }
	        }
	        this.dataPersistenceService.saveCurrentSettings(this.currentSettings);
	    };
	    MachineSpecificationsService.prototype.newMachine = function (newMachineID, newMakeAndModel) {
	        console.log('specifications-data.service newMachine');
	        if (this.machineList.indexOf(newMachineID) != -1) {
	            throw new RangeError("This 'new' machine already exists");
	        }
	        var newSpecification = new MachineSpecification();
	        newSpecification.machine = newMachineID;
	        newSpecification.makeAndModel = newMakeAndModel;
	        this.specifications.push(newSpecification);
	        this.updateMachineList();
	        this.changeMachine(newMachineID);
	    };
	    MachineSpecificationsService.prototype.changeMachine = function (swapToMachineID) {
	        console.log('specifications-data.service changeMachine');
	        this.currentSettings.machine = swapToMachineID;
	        this.updateCurrentSpecification();
	    };
	    MachineSpecificationsService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [current_settings_1.CurrentSettings])
	    ], MachineSpecificationsService);
	    return MachineSpecificationsService;
	}());
	exports.MachineSpecificationsService = MachineSpecificationsService;


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var CurrentSettings = (function () {
	    function CurrentSettings() {
	        this.id = 0;
	        this.machine = null;
	        this.energy = null;
	        this.applicator = null;
	        this.ssd = null;
	    }
	    CurrentSettings.prototype.returnKey = function () {
	        return ('{"machine":' + JSON.stringify(String(this.machine)) + ',' +
	            '"energy":' + JSON.stringify(Number(this.energy)) + ',' +
	            '"applicator":' + JSON.stringify(String(this.applicator)) + ',' +
	            '"ssd":' + JSON.stringify(Number(this.ssd)) +
	            '}');
	    };
	    CurrentSettings = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], CurrentSettings);
	    return CurrentSettings;
	}());
	exports.CurrentSettings = CurrentSettings;


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var insert_data_1 = __webpack_require__(128);
	var text_input_control_1 = __webpack_require__(142);
	var XYInputComponent = (function () {
	    function XYInputComponent() {
	        this.textboxLabels = {
	            x: "X coordinates (cm @iso)",
	            y: "Y coordinates (cm @iso)"
	        };
	        this.disabled = false;
	        this.rows = 4;
	        this.validTextBoxChange = new core_1.EventEmitter();
	        this.texboxValidCheck = new core_1.EventEmitter();
	    }
	    XYInputComponent.prototype.ngOnInit = function () {
	        this.textInputControl = new text_input_control_1.TextInputControl(['x', 'y'], this.dataInputs);
	        this.textInputControl.updateAllTextboxInputs();
	    };
	    XYInputComponent.prototype.ngDoCheck = function () {
	        if (this.triggerUpdate) {
	            this.textInputControl.updateAllTextboxInputs();
	            // console.log(this.triggerUpdate)
	            this.triggerUpdate = false;
	        }
	    };
	    XYInputComponent.prototype.onTextboxChange = function (key, newInput) {
	        var oldValid = this.textInputControl.textboxValid[key];
	        this.textInputControl.validateTextboxInput(key, newInput);
	        if (this.textInputControl.textboxValid[key] != oldValid) {
	            this.texboxValidCheck.emit(this.textInputControl.checkAllValid());
	        }
	        if (this.textInputControl.textboxValid[key]) {
	            this.validTextBoxChange.emit();
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], XYInputComponent.prototype, "textboxLabels", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', insert_data_1.Coordinates)
	    ], XYInputComponent.prototype, "dataInputs", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], XYInputComponent.prototype, "triggerUpdate", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], XYInputComponent.prototype, "disabled", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], XYInputComponent.prototype, "rows", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], XYInputComponent.prototype, "validTextBoxChange", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], XYInputComponent.prototype, "texboxValidCheck", void 0);
	    XYInputComponent = __decorate([
	        core_1.Component({
	            selector: 'my-x-y-input',
	            template: __webpack_require__(144)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], XYInputComponent);
	    return XYInputComponent;
	}());
	exports.XYInputComponent = XYInputComponent;


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var sanitise_validation_1 = __webpack_require__(143);
	var TextInputControl = (function () {
	    function TextInputControl(inputNames, dataInputs) {
	        this.inputNames = inputNames;
	        this.dataInputs = dataInputs;
	        this.textboxInput = {};
	        this.textboxValid = {};
	        for (var _i = 0, _a = this.inputNames; _i < _a.length; _i++) {
	            var key = _a[_i];
	            this.textboxInput[key] = "";
	            this.textboxValid[key] = true;
	        }
	    }
	    TextInputControl.prototype.updateAllTextboxInputs = function () {
	        for (var _i = 0, _a = this.inputNames; _i < _a.length; _i++) {
	            var key = _a[_i];
	            this.updateTextboxInput(key);
	        }
	    };
	    TextInputControl.prototype.updateTextboxInput = function (key) {
	        this.textboxInput[key] = String(this.dataInputs[key])
	            .replace(/,/g, ', ');
	    };
	    TextInputControl.prototype.validateTextboxInput = function (key, newInput) {
	        this.textboxValid[key] = false;
	        try {
	            if (sanitise_validation_1.validateInput(newInput)) {
	                this.dataInputs[key] = eval('[' + newInput.replace(/[,;\n\t]\s*/g, ', ') + ']');
	                this.textboxValid[key] = true;
	            }
	        }
	        catch (err) {
	            console.log(err);
	        }
	    };
	    TextInputControl.prototype.checkAllValid = function () {
	        for (var _i = 0, _a = this.inputNames; _i < _a.length; _i++) {
	            var key = _a[_i];
	            if (!this.textboxValid[key]) {
	                return false;
	            }
	        }
	        return true;
	    };
	    return TextInputControl;
	}());
	exports.TextInputControl = TextInputControl;


/***/ },
/* 143 */
/***/ function(module, exports) {

	"use strict";
	function validateInput(input) {
	    // return /^(-?\d*(\.\d+)?[,;\s]+)*-?\d*(\.\d+)?[,;\s]*$/.test(input)
	    return /^[-\d\.,;\sNa]*$/.test(input);
	}
	exports.validateInput = validateInput;


/***/ },
/* 144 */
/***/ function(module, exports) {

	module.exports = "<div *ngFor=\"let key of textInputControl.inputNames\">\n  <mdl-textfield \n    type=\"text\"\n    [label]=\"textboxLabels[key]\"\n    [(ngModel)]=\"textInputControl.textboxInput[key]\"\n    (input)=\"onTextboxChange(key, $event.target.value)\"\n    [rows]=rows\n    floating-label\n    [disabled]=disabled\n    [style.width]=\"'100%'\"></mdl-textfield>\n  <p *ngIf=\"!textInputControl.textboxValid[key]\">\n    The {{key}} input is invalid\n  </p>\n</div>";

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var insert_data_1 = __webpack_require__(128);
	var insert = {
	    x: [
	        0.99, -0.14, -1.0, -1.73, -2.56, -3.17, -3.49,
	        -3.57, -3.17, -2.52, -1.76, -1.04, -0.17,
	        0.77, 1.63, 2.36, 2.79, 2.91, 3.04, 3.22,
	        3.34, 3.37, 3.08, 2.54, 1.88, 1.02, 0.99],
	    y: [
	        5.05, 4.98, 4.42, 3.24, 1.68, 0.6, -0.64,
	        -1.48, -2.38, -3.77, -4.81, -5.26, -5.51,
	        -5.58, -5.23, -4.64, -3.77, -2.77, -1.68,
	        -0.29, 1.23, 2.68, 3.8, 4.6, 5.01, 5.08,
	        5.05]
	};
	var parameterisation = new insert_data_1.Parameterisation();
	parameterisation.reset();
	parameterisation.insert = insert;
	exports.DEMO_PARAMETERISE_INPUT = parameterisation;


/***/ },
/* 146 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mdl-grid\">\n  <div class=\"mdl-cell mdl-cell--6-col mdl-cell--8-col-tablet\" style=\"display: flex; align-items: center; flex-flow: row wrap;\">\n    <h5>Equivalent ellipse parameterisation</h5>\n    <p>This is for the determination of equivalent ellipse widths and lengths as defined in the paper method.</p>\n\n    <p>\n      To begin shape parameterisation you need to define your insert shape. \n      This can be done by editing the x and y coordinates within the text boxes below or by using a shape       \n      <a routerLink=\"/dicom\" routerLinkActive=\"active\">\n        pulled from a dicom file.\n      </a>\n    </p>\n\n    <p>\n      Coordinates can be separated by commas (,), semicolons (;), tabs, or new lines.\n      This web app should handle copying and pasting from a range of sources (including excel).\n      Number inputs can only contain the characters 0-9, a minus sign (-) and decimal points (.).\n    </p>\n\n    <my-x-y-input #textboxInputs\n      [dataInputs]=\"insertData.parameterisation.insert\"\n      [triggerUpdate]=false\n      [rows]=4\n      [disabled]=\"dataInFlight\"\n      (texboxValidCheck)=\"textInputsValid=$event\"\n      (validTextBoxChange)=onValidTextboxChange()\n      [style.width]=\"'100%'\"></my-x-y-input>\n\n    <!--<mdl-textfield\n      type=\"text\"\n      label=\"X coordinates (cm @iso)\"\n      [(ngModel)]=\"textAreaX\"\n      (input)=\"inputTextAreaX($event.target.value)\"\n      rows=4\n      floating-label\n      [disabled]=\"dataInFlight\"\n      [style.width]=\"'100%'\"></mdl-textfield>\n\n    <mdl-textfield\n      type=\"text\"\n      label=\"Y coordinates (cm @iso)\"\n      [(ngModel)]=\"textAreaY\"\n      (input)=\"inputTextAreaY($event.target.value)\"\n      rows=4\n      floating-label\n      [disabled]=\"dataInFlight\"\n      [style.width]=\"'100%'\"></mdl-textfield>-->\n\n    <p *ngIf=\"!equalLengths\">\n      The x and y coordinate lengths need to be the same as each other.\n    </p>\n\n    <p *ngIf=\"insertData.parameterisation.insert.x.length < 3 || insertData.parameterisation.insert.y.length < 3\">\n      You need at least 3 data points to create an insert shape.\n    </p>\n\n    <div style=\"width:100%; height:30px\"></div>\n\n    <button\n      mdl-button mdl-button-type=\"raised\" \n      mdl-colored=\"primary\" \n      mdl-ripple\n      angulartics2On=\"click\" angularticsEvent=\"Parameterise | Load demo data\"\n      [disabled]=\"submitDisabled\"\n      (click)=\"loadDemoData()\">Load Demo Data         \n    </button>\n\n    <div style=\"width:20px; height:30px\"></div>\n\n    <button\n      mdl-button mdl-button-type=\"raised\" \n      mdl-colored=\"primary\" \n      mdl-ripple\n      angulartics2On=\"click\" angularticsEvent=\"Parameterise | Parameterise insert\"\n      [disabled]=\"submitDisabled || !textInputsValid || !equalLengths\"\n      (click)=\"onSubmit()\">Parameterise Insert          \n    </button>\n\n\n\n    <div [hidden]=\"serverResponseValid\">\n      {{serverErrorMessage}}\n    </div>\n\n    <div style=\"height:20px; width:100%;\"></div>\n\n    <my-plot \n      [insert_x]=\"insertData.parameterisation.insert.x\"\n      [insert_y]=\"insertData.parameterisation.insert.y\"\n      [circle]=\"insertData.parameterisation.circle\"\n      [ellipse]=\"insertData.parameterisation.ellipse\"\n      [enabled]=\"textInputsValid && equalLengths\">\n    </my-plot>\n\n    <div style=\"height:20px; width:20px;\"></div>\n\n    <my-width-length-table\n      [width]=\"insertData.parameterisation.width\"\n      [length]=\"insertData.parameterisation.length\"\n      [enabled]=\"textInputsValid && equalLengths\">\n    </my-width-length-table>\n\n  </div>\n  <div class=\"mdl-cell mdl-cell--6-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\">\n    <h5>Send parameterisation to model</h5>\n    <p>\n      Once you have parameterised an insert shape you may either predict this insert with the model, or you may add the insert to the model.\n    </p>\n    <p>\n      To predict the insert with the model you must have filled in the correct machine ID, energy, applicator, and ssd in the text boxes below.\n      Furthermore these inputs need to correspond to one of the \n      <a routerLink=\"/specifications\" routerLinkActive=\"active\">\n        machine specifications you have defined.\n      </a>\n    </p>\n    <p>\n      To append the current insert shape along with its measured factor to the model you must have filled in the corresponding machine ID, energy, applicator, ssd, and measured factor in the text boxes below.\n      Once again the machine specifications given need to correspond to one of the \n      <a routerLink=\"/specifications\" routerLinkActive=\"active\">\n        machine specifications you have defined.\n      </a>\n    </p>\n\n\n    <mdl-textfield\n      type=\"text\"\n      label=\"Machine (ID)\"\n      (input)=\"insertDataChange()\"\n      floating-label\n      [(ngModel)]=\"insertData.machine\"\n      style=\"width:100%\"></mdl-textfield>\n\n    <p *ngIf=\"!machineExists\">\n      This machine ID does not exist within your \n      <a routerLink=\"/specifications\" routerLinkActive=\"active\">\n        provided machine specifications.\n      </a>\n    </p>\n    <mdl-textfield\n      type=\"text\"\n      label=\"Energy (Nominal or MeV)\"\n      (input)=\"insertDataChange()\"\n      floating-label\n      [(ngModel)]=\"insertData.energy\"\n      style=\"width:100%\"></mdl-textfield>\n    <mdl-textfield\n      type=\"text\"\n      label=\"Applicator (ID)\"\n      (input)=\"insertDataChange()\"\n      floating-label\n      [(ngModel)]=\"insertData.applicator\"\n      style=\"width:100%\"></mdl-textfield>\n    <mdl-textfield\n      type=\"text\"\n      label=\"SSD (cm)\"\n      (input)=\"insertDataChange()\"\n      floating-label\n      [(ngModel)]=\"insertData.ssd\"\n      style=\"width:100%\"></mdl-textfield>\n\n    <p *ngIf=\"!machineSettingsExist\">\n      These specific machine settings do not exist within your       \n      <a routerLink=\"/specifications\" routerLinkActive=\"active\">\n        provided machine specifications.\n      </a>\n    </p>\n\n    <mdl-textfield #measuredFactorInput\n      type=\"text\"\n      label=\"Measured insert factor (as per TG 25)\"\n      (input)=\"insertDataChange()\"\n      floating-label\n      [(ngModel)]=\"insertData.measuredFactor\"\n      style=\"width:100%\"></mdl-textfield>\n\n    <button\n      mdl-button mdl-button-type=\"raised\" \n      mdl-colored=\"primary\" \n      mdl-ripple\n      angulartics2On=\"click\" angularticsEvent=\"Parameterise | Add measured factor to model\"\n      [disabled]=\"!ableToAddDataToModel || !machineSettingsExist || measuredFactorInput.value==null || measuredFactorInput.value=='' || submitDisabled || !textboxInputs || !equalLengths\"\n      (click)=\"addMeasuredFactor(measuredFactorInput.value)\">Add Measured Factor to Model            \n    </button>\n\n    <p *ngIf=\"dataAlreadyExistsOnModel && !submitDisabled && textInputsValid && equalLengths && machineSettingsExist\">\n      This width, length, and measured factor combination exists within the model.       \n      <a routerLink=\"/model\" routerLinkActive=\"active\">\n        View the model.\n      </a>\n    </p>\n    \n    <div style=\"height:20px; width:20px;\"></div>\n\n\n\n\n    <button\n      mdl-button mdl-button-type=\"raised\"\n      mdl-colored=\"primary\" \n      mdl-ripple\n      angulartics2On=\"click\" angularticsEvent=\"Parameterise | Predict factor with model\"\n      [disabled]=\"!machineSettingsExist || submitDisabled || !textInputsValid || !equalLengths || insertData.parameterisation.width == null || insertData.parameterisation.length == null\"\n      (click)=\"predictFactor()\">Predict Factor with Model        \n    </button>\n\n\n\n\n  </div>\n\n\n\n  <div class=\"mdl-cell mdl-cell--6-col mdl-cell--8-col-tablet\">\n    <h5>Change parameterisation server url (optional)</h5>\n    <p>Only change the following address if you wish to use your own server. This is not required to be edited. The default server is: <br>\n      <a>http://electronapi.simonbiggs.net/parameterise</a>       \n    </p>\n    <mdl-textfield\n      type=\"text\"\n      label=\"Parameterisation Server Address\"\n      (input)=\"parameterisationServerChange($event.target.value)\"\n      floating-label\n      [(ngModel)]=\"parameteriseURL\"\n      style=\"width:100%\"></mdl-textfield>\n  </div>\n\n</div>\n";

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var PageNotFoundComponent = (function () {
	    function PageNotFoundComponent() {
	    }
	    PageNotFoundComponent = __decorate([
	        core_1.Component({
	            selector: 'my-page-not-found',
	            template: __webpack_require__(148)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PageNotFoundComponent);
	    return PageNotFoundComponent;
	}());
	exports.PageNotFoundComponent = PageNotFoundComponent;


/***/ },
/* 148 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mdl-grid\">\n  <div class=\"mdl-cell mdl-cell--12-col\">\n    This page has not been found. Please provide feedback ...\n  </div>\n</div>";

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var title_service_1 = __webpack_require__(131);
	var HomeComponent = (function () {
	    function HomeComponent(myTitleService) {
	        this.myTitleService = myTitleService;
	    }
	    HomeComponent.prototype.ngOnInit = function () {
	        this.myTitleService.setTitle('Home');
	    };
	    HomeComponent = __decorate([
	        core_1.Component({
	            selector: 'my-home',
	            template: __webpack_require__(150)
	        }), 
	        __metadata('design:paramtypes', [title_service_1.TitleService])
	    ], HomeComponent);
	    return HomeComponent;
	}());
	exports.HomeComponent = HomeComponent;


/***/ },
/* 150 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mdl-grid\">\n  <div class=\"mdl-cell mdl-cell--6-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\">\n    <h3 itemprop=\"name\">Electron insert factor modelling</h3>\n\n    <h4>Disclaimer and Copyright</h4>\n    <p>\n    Electron insert factor empirical modelling<br>   \n    Copyright (C) 2015-2016  Simon Biggs<br>\n    <br>\n    This program is free software: you can redistribute it and/or modify\n    it under the terms of the GNU Affero General Public License as\n    published by the Free Software Foundation, either version 3 of the\n    License, or (at your option) any later version.<br><br>\n\n    This program is distributed in the hope that it will be useful,\n    but <b>without any warranty</b>; without even the implied warranty of\n    <b>merchantability</b> or <b>fitness for a particular purpose</b>.  See the\n    GNU Affero General Public License for more details.<br><br>\n\n    You should have received a copy of the GNU Affero General Public License\n    along with this program.  If not, see <a href=\"http://www.gnu.org/licenses/\">http://www.gnu.org/licenses/</a>.\n    </p>\n\n    <h4>Description</h4>\n    <p>\n      This online web app is for the modelling of the electron insert factor. <b>It is not intended to be the sole basis upon which monitor units are adjusted.</b>\n      This tool is helpful for two cases, to check for consistency amongst measurements allowing remeasurement when required, and to help a qualified medical physicst make an informed desicion on what the electron insert factor is.\n      If this model disagrees with the insert factor predicted by your planning system in a significant manner it is recommended you take a measurement of the shape in question.\n    </p>\n\n    <p>Any use of this webapp recognises that this program is automatically updated when I make changes. All changes are recorded within Github's version control. The logs of the changes to the web app can be accessed from <a href=\"https://github.com/SimonBiggs/electroninserts-webapp/commits/master\">here</a>, changes to the modelling and parameterisation server are documented <a href=\"https://github.com/SimonBiggs/electronfactor-server/commits/master\">here</a>. \n    By using this software you assume the responsibility and risk of any changes this web app undergoes. On the <a routerLink=\"/details\" routerLinkActive=\"active\">\n            further details page</a> it is outlined how you may download a static version of this webapp if you wish to be in control of when the app updates.</p>\n    <p>For more information on this model and an overview for which scenarios it has been validated see the publication detailed below. \n      Of note is it is suspected that when the long axis of an equivalent ellipse begins to contribute to the loss of lateral scatter the assumptions underpinning the shape parameterisation may no longer hold. This might be able to be overcome by just using circles when the shape becomes that small. The demo data available within the <a routerLink=\"/create-model\" routerLinkActive=\"active\">\n            create model component</a> was collected on an Elekta Agility at an energy of 12 MeV on a 10x10 cm applicator. The smallest width tested was 3.2 cm at isocentre.\n      For the remaining energies of 6, 9, 15, and 18 MeV the smallest width tested was 5 cm. \n      If you are able to further validate this model please contact me so that I may provide more information on where this model has been shown to work and where it does not. \n    </p>\n    <p>\n      If you find bugs, have any suggestions, or simply wish to share your results from using this model please submit either an issue or a pull request to the <a href=\"https://github.com/SimonBiggs/electroninserts-webapp/issues\">Github version control system</a> or <a href=\"mailto:mail@simonbiggs.net\">send me an email</a>.\n    </p>\n\n    <h4>Publication</h4>\n    <!--<h6>Original paper</h6>-->\n    <p>The paper detailing the algorithim and the samples for which it has been validated:</p>\n    <p>\n      S. Biggs, M. Sobolewski, R. Murry, J. Kenny, Spline modelling electron insert factors using routine measurements. Physica Medica (2015), <a href=\"http://dx.doi.org/10.1016/j.ejmp.2015.11.002\">doi:10.1016/j.ejmp.2015.11.002</a>.\n    </p>\n\n\n  \n\n   \n  </div>\n  <div class=\"mdl-cell mdl-cell--6-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\">      \n\n  <h4>Web app structure</h4>\n    <p>This web app is divided into six logical components all of which can be accessed from the navigation menu. These are outlined below:</p>\n      <ul>\n        <li>\n          <a routerLink=\"/specifications\" routerLinkActive=\"active\">\n            Machine specifications component\n          </a>\n          <ul><li>Used to define your centre specific machine specifications.</li></ul>   \n          \n        </li>\n        <li>\n          <a routerLink=\"/dicom\" routerLinkActive=\"active\">\n            Dicom component\n          </a>\n          <ul><li>Used to extract patient insert shapes from Dicom files.</li></ul>\n        </li>\n        <li>\n          <a routerLink=\"/parameterise\" routerLinkActive=\"active\">\n            Parameterisation component\n          </a>\n          <ul><li>Used to parameterise insert shapes into equivalent ellipse widths and lengths for use within the empirical model.</li></ul>\n        </li>\n        <li>\n          <a routerLink=\"/create-model\" routerLinkActive=\"active\">\n            Create model component\n          </a>\n          <ul><li>Use this to create the model once there are at least 8 measured factors for a given machine, applicator, energy, ssd combination.</li></ul>\n        </li>\n        <li>\n          <a routerLink=\"/use-model\" routerLinkActive=\"active\">\n            Use model component\n          </a>\n          <ul><li>Use this to quickly calculate small or large numbers of predicted factors.</li>\n            <li>Measured factors can be given here to batch evaluate the models ability to predict factors for validation purposes.</li></ul>          \n        </li>\n        <li>\n          <a routerLink=\"/database\" routerLinkActive=\"active\">\n            Database management component\n          </a>\n          <ul><li>Use this to transfer and backup the data within the local browser data.</li></ul>\n          \n        </li>\n      </ul>\n\n    <h4>Demo Instructions</h4>\n    <p>\n      If you wish to simply demo this app these are the following steps you can take:\n    </p>\n    <ul>\n      <li>\n        Within the \n        <a routerLink=\"/dicom\" routerLinkActive=\"active\">\n          dicom component \n        </a>\n        download the demo dicom file, load it into the web app and see the insert shapes be pulled from the dicom file without any network traffic\n      </li>\n      <li>\n        Within the \n        <a routerLink=\"/parameterise\" routerLinkActive=\"active\">\n          parameterise component\n        </a>\n        press the \"Load Demo Data\" button and then press the \"Parameteterise Insert\" button to see the parameterisation algorithim in action\n      </li>\n      <li>\n        Within the \n        <a routerLink=\"/model\" routerLinkActive=\"active\">\n          model component\n        </a>\n        press the \"Load Demo Data\" button and then press the \"Calculate Spline Model\" to see the spline model being created. \n        You can then either hover over the model, or tap on the model to view the relevant values.\n      </li>\n    </ul>\n\n\n    <h4>Implementation instructions</h4>\n    <p>\n      To implement this web app in your centre you need to do the following:\n    </p>\n    <ul>\n      <li>  \n        Specify the machine models and the corresponding applicators, energies, and ssds within the    \n        <a routerLink=\"/specifications\" routerLinkActive=\"active\">\n          machine specification component.\n        </a>\n      </li>\n      <li> \n        Collate / measure your electron insert factor measurements. These factors are to measured in accordance to TG 25. \n        Measured insert factors from regular or irregular shapes are able to be used.  \n      </li>\n      <li>\n        Parameterising new insert shapes\n        <ul>\n          <li>\n            If the insert shapes are ellipses, you may directly input the ellipse widths and lengths as projected to the isocentre within the \n            <a routerLink=\"/create-model\" routerLinkActive=\"active\">\n              create model component.\n            </a>\n          </li>\n          <li>\n            If you know the x and y coordinates of your insert then determine the equivalent ellipse widths and lengths by inputting x and y coordinates as defined at isocentre within the \n            <a routerLink=\"/parameterise\" routerLinkActive=\"active\">\n              parameterisation component.\n            </a>          \n          </li>\n          <li>\n            If the insert shape is defined within your planning system, export the patient plan to dicom and then read the insert coordinates from the dicom file using the\n            <a routerLink=\"/dicom\" routerLinkActive=\"active\">\n              dicom component.\n            </a>          \n          </li>\n          <li>\n            If you have a batch of generic insert shapes you can directly input the widths and areas of the shapes into the  \n            <a routerLink=\"/create-model\" routerLinkActive=\"active\">\n              create model component</a>. The width is defined as the diameter of the largest fully encompassed circle of your insert shapes at isocentre. The area is defined as the insert shape area projected to isocentre.\n            Rectangles can be input in this way by simply inputting the rectangle's width projected to isocentre as width, and its area projected to isocentre as area.\n          </li>\n        </ul>\n      </li>\n      <li>\n        Once you have the corresponding equivalent ellipse widths and lengths for your measured factors these may be appended to the relevant machine configuration within the \n        <a routerLink=\"/create-model\" routerLinkActive=\"active\">\n          create model component\n        </a>\n      </li>\n      <li>\n        Whenever a machine configuration gets at least 8 data points you may press the \"Run Spline Model\" on the \n        <a routerLink=\"/create-model\" routerLinkActive=\"active\">\n          create model component\n        </a>\n        which will allow the prediction of insert factors for other widths and lengths.\n      </li>\n      <li>\n        The \n        <a routerLink=\"/use-model\" routerLinkActive=\"active\">\n          use model component\n        </a>\n        is specifically designed to aid you in looking up large batches of factors. This can be helpful for validating your model. \n      </li>\n      <li>\n        Once you are content with your model use the \n        <a routerLink=\"/database\" routerLinkActive=\"active\">\n          database management component\n        </a>\n        to export and backup your data. This data can be placed on a shared drive for access by users who need to use the model.\n      </li>\n      <li>\n        If you need to have a consistent reliable interface you may wish to consider downloading a copy of this web app and serving it within your centre's intranet.\n        This can be achieved by following the relevant steps given within the \n        <a routerLink=\"/details\" fragment=\"locally\" routerLinkActive=\"active\">\n          further details component</a>.\n      </li>\n    </ul>\n\n    <!--<h4>Use instructions</h4>\n    <ul>\n      <li>\n        Export the patient plan to dicom and then read the insert coordinates from the dicom file using the\n        <a routerLink=\"/dicom\" routerLinkActive=\"active\">\n          dicom component.\n        </a>          \n      </li>\n      <li>\n        Press the \"Parameterise Insert\" button to determine the equivalent ellipse width and length\n      </li>\n      <li>\n        Press the \"Predict Factor with Model\" button to automatically change the machine configuration to that which matches your loaded insert\n      </li>\n      <li>\n        Hover your mouse over the relevant width and length within the model to predict your insert factor\n      </li>\n    </ul>-->\n\n\n  </div>\n\n</div>";

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var title_service_1 = __webpack_require__(131);
	var electron_api_service_1 = __webpack_require__(129);
	var model_data_1 = __webpack_require__(137);
	var data_persistence_service_1 = __webpack_require__(132);
	var current_settings_1 = __webpack_require__(140);
	var width_length_area_input_component_1 = __webpack_require__(152);
	var CreateModelComponent = (function () {
	    function CreateModelComponent(modelData, myTitleService, electronApiService, dataPersistenceService, currentSettings, ngZone) {
	        var _this = this;
	        this.modelData = modelData;
	        this.myTitleService = myTitleService;
	        this.electronApiService = electronApiService;
	        this.dataPersistenceService = dataPersistenceService;
	        this.currentSettings = currentSettings;
	        this.ngZone = ngZone;
	        this.textboxLabels = {
	            width: "Width of ellipse given by diameter of largest encompassed circle (cm @iso)",
	            length: "Length of ellipse that matches insert shape area (cm @iso)",
	            area: "[Optional] Area of insert shape (cm^2 @iso)",
	            measuredFactor: "Measured insert factor (as per TG 25)"
	        };
	        this.textboxValid = true;
	        this.numberOfShapesToLeaveBehind = 8;
	        this.selectionList = [];
	        this.lengthSmallerThanWidth = false;
	        this.plot_width = 600;
	        this.dataInFlight = false;
	        window.onresize = function (e) {
	            ngZone.run(function () {
	                _this.updatePlotWidth();
	            });
	        };
	    }
	    CreateModelComponent.prototype.ngOnDestroy = function () {
	        window.onresize = null;
	    };
	    CreateModelComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.myTitleService.setTitle('Create Model');
	        this.dataPersistenceService.loadServerUrl('model')
	            .then(function (serverUrl) {
	            if (serverUrl == null) {
	                _this.modelURL = 'http://electronapi.simonbiggs.net/model';
	            }
	            else {
	                _this.modelURL = serverUrl.url;
	            }
	        });
	        this.updatePlotWidth();
	    };
	    CreateModelComponent.prototype.selectionChanged = function (selectionList) {
	        this.selectionList = selectionList;
	    };
	    CreateModelComponent.prototype.shuffleArray = function (array) {
	        for (var i = array.length - 1; i > 0; i--) {
	            var j = Math.floor(Math.random() * (i + 1));
	            var temp = array[i];
	            array[i] = array[j];
	            array[j] = temp;
	        }
	        return array;
	    };
	    CreateModelComponent.prototype.convertToNumber = function (input) {
	        return Number(input);
	    };
	    CreateModelComponent.prototype.randomMove = function () {
	        var randomSelection = [];
	        for (var i in this.selectionList) {
	            if (Number(i) < Number(this.numberOfShapesToLeaveBehind)) {
	                randomSelection.push(false);
	            }
	            else {
	                randomSelection.push(true);
	            }
	        }
	        randomSelection = this.shuffleArray(randomSelection);
	        this.selectionList = randomSelection;
	        this.moveSelectedFactorsToUseModel();
	    };
	    CreateModelComponent.prototype.moveSelectedFactorsToUseModel = function () {
	        for (var i in this.selectionList) {
	            if (this.selectionList[i]) {
	                for (var _i = 0, _a = ['width', 'length', 'measuredFactor']; _i < _a.length; _i++) {
	                    var key = _a[_i];
	                    this.modelData.predictions[key].unshift(Number(this.modelData.measurement[key][i]));
	                }
	            }
	        }
	        this.removeSelectedFactors();
	    };
	    CreateModelComponent.prototype.removeSelectedFactors = function () {
	        this.modelData.model.reset();
	        for (var i = this.selectionList.length - 1; i > -1; i--) {
	            if (this.selectionList[i]) {
	                for (var _i = 0, _a = ['width', 'length', 'area', 'measuredFactor']; _i < _a.length; _i++) {
	                    var key = _a[_i];
	                    this.modelData.measurement[key].splice(i, 1);
	                }
	            }
	        }
	        for (var _b = 0, _c = ['width', 'length', 'area', 'measuredFactor']; _b < _c.length; _b++) {
	            var key = _c[_b];
	            this.modelData.measurement[key] = this.modelData.measurement[key].slice(0);
	        }
	        this.saveModel();
	        this.textboxInputs.triggerUpdate = true;
	    };
	    // addSelectedFactorsToModel() {
	    //   console.log('use-model.component addSelectedFactorsToModel')
	    //   this.modelData.model.reset()
	    //   for (let i in this.selectionList) {
	    //     if (this.selectionList[i] && this.canBeSentToModel[i] ) {
	    //       for (let key of ['width', 'length', 'measuredFactor']) {
	    //         this.modelData.measurement[key].push(Number(this.modelData.predictions[key][i]))
	    //       }
	    //     }
	    //   }
	    //   this.checkAllIfCanBeAddedToModel()
	    //   this.saveModel()
	    // }
	    CreateModelComponent.prototype.updatePlotWidth = function () {
	        this.plot_width = this.plotContainer.nativeElement.clientWidth;
	    };
	    CreateModelComponent.prototype.currentMachineSettingsUpdated = function (newSettings) {
	        this.currentSettings = newSettings;
	        this.loadMeasuredData();
	        this.checkLengthSmallerThanWidth();
	    };
	    CreateModelComponent.prototype.loadMeasuredData = function () {
	        var _this = this;
	        this.dataPersistenceService.loadModelData(this.modelData, this.currentSettings).then(function () {
	            _this.textboxInputs.triggerUpdate = true;
	        });
	    };
	    CreateModelComponent.prototype.saveModel = function () {
	        this.dataPersistenceService.saveModelData(this.modelData, this.currentSettings);
	    };
	    CreateModelComponent.prototype.checkLengthSmallerThanWidth = function () {
	        this.lengthSmallerThanWidth = false;
	        for (var i = 0; i < this.modelData.measurement.width.length; i++) {
	            if (this.modelData.measurement.width[i] > this.modelData.measurement.length[i]) {
	                this.lengthSmallerThanWidth = true;
	                return;
	            }
	        }
	    };
	    CreateModelComponent.prototype.onValidTextboxChange = function () {
	        this.modelData.model.reset();
	        this.checkLengthSmallerThanWidth();
	        this.saveModel();
	    };
	    CreateModelComponent.prototype.basicServerSubmit = function () {
	        var _this = this;
	        this.dataInFlight = true;
	        this.electronApiService.sendToServer(this.modelURL, JSON.stringify(this.modelData.measurement))
	            .then(function (modelResult) {
	            _this.modelData.model.width = modelResult.model_width;
	            _this.modelData.model.length = modelResult.model_length;
	            _this.modelData.model.predictedFactor = modelResult.model_factor;
	            _this.dataInFlight = false;
	            _this.saveModel();
	        });
	    };
	    CreateModelComponent.prototype.modelServerChange = function (newModelURL) {
	        this.dataPersistenceService.saveServerUrl('model', newModelURL);
	    };
	    CreateModelComponent.prototype.defaultServer = function () {
	        this.modelURL = 'http://electronapi.simonbiggs.net/model';
	        this.dataPersistenceService.saveServerUrl('model', this.modelURL);
	    };
	    CreateModelComponent.prototype.loadDemoData = function () {
	        for (var _i = 0, _a = ['machine', 'energy', 'applicator', 'ssd']; _i < _a.length; _i++) {
	            var key = _a[_i];
	            this.currentSettings[key] = null;
	        }
	        this.settingsPicker.currentSettings = this.currentSettings;
	        this.modelData.model.reset();
	        this.modelData.measurement.reset();
	        this.modelData.measurement.width = [
	            3.71, 6.78, 6.3, 7.56, 5.26, 6.53, 7.08, 4.38, 3.66,
	            4.21, 4.21, 6.54, 5.86, 3.17, 6., 8.06, 6.31, 5.26,
	            4.21, 5.21, 4.59, 5.34, 6.41, 5.26, 5.25, 7.82, 4.2,
	            3.16, 7.18, 5.72, 6.08, 6.64, 8.4, 4.59, 3.15, 4.67,
	            4.21, 9.45, 7.64, 3.17, 3.17, 7.36];
	        this.modelData.measurement.length = [
	            4.36, 10.97, 6.33, 10.05, 13.66, 10.99, 10.77, 5.47,
	            5.04, 8.41, 13.65, 8.41, 8.62, 9.43, 7.97, 11.85,
	            8.24, 10.52, 6.82, 11.4, 5.67, 9.64, 8.69, 8.41,
	            5.26, 10.85, 4.21, 5.25, 11.27, 11.6, 6.64, 9.81,
	            8.42, 6.54, 3.16, 6.28, 10.51, 9.47, 8.99, 13.64,
	            6.83, 7.37];
	        this.modelData.measurement.measuredFactor = [
	            0.9489, 1.0067, 0.9858, 1.0045, 0.9868, 1.0004, 1.0052,
	            0.9634, 0.9437, 0.9708, 0.9757, 0.9931, 0.9896, 0.9492,
	            0.9911, 1.0067, 0.9923, 0.9879, 0.9609, 0.9884, 0.9587,
	            0.9934, 0.9991, 0.9831, 0.9705, 1.0019, 0.9562, 0.9348,
	            0.9987, 0.9989, 0.9933, 0.9991, 1.0067, 0.9683, 0.9296,
	            0.9735, 0.9709, 1.0084, 1.0028, 0.953, 0.9484, 1.0032];
	        this.modelData.measurement.updateAreaFromLength();
	        this.checkLengthSmallerThanWidth();
	        this.textboxInputs.triggerUpdate = true;
	    };
	    __decorate([
	        core_1.ViewChild('plotContainer'), 
	        __metadata('design:type', Object)
	    ], CreateModelComponent.prototype, "plotContainer", void 0);
	    __decorate([
	        core_1.ViewChild('settingsPicker'), 
	        __metadata('design:type', Object)
	    ], CreateModelComponent.prototype, "settingsPicker", void 0);
	    __decorate([
	        core_1.ViewChild('textboxInputs'), 
	        __metadata('design:type', width_length_area_input_component_1.WidthLengthAreaInputComponent)
	    ], CreateModelComponent.prototype, "textboxInputs", void 0);
	    CreateModelComponent = __decorate([
	        core_1.Component({
	            selector: 'my-create-model',
	            template: __webpack_require__(153)
	        }), 
	        __metadata('design:paramtypes', [model_data_1.ModelData, title_service_1.TitleService, electron_api_service_1.ElectronApiService, data_persistence_service_1.DataPersistenceService, current_settings_1.CurrentSettings, core_1.NgZone])
	    ], CreateModelComponent);
	    return CreateModelComponent;
	}());
	exports.CreateModelComponent = CreateModelComponent;


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var model_data_1 = __webpack_require__(137);
	var text_input_control_1 = __webpack_require__(142);
	var WidthLengthAreaInputComponent = (function () {
	    function WidthLengthAreaInputComponent() {
	        this.textboxLabels = {
	            width: "Width of ellipse given by diameter of largest encompassed circle (cm @iso)",
	            length: "Length of ellipse that matches insert shape area (cm @iso)",
	            area: "Area of insert shape (cm^2 @iso)",
	            measuredFactor: "Measured insert factor (as per TG 25)"
	        };
	        this.disabled = false;
	        this.rows = 2;
	        this.validTextBoxChange = new core_1.EventEmitter();
	        this.texboxValidCheck = new core_1.EventEmitter();
	        this.lastEdit = 'length';
	    }
	    WidthLengthAreaInputComponent.prototype.ngOnInit = function () {
	        this.textInputControl = new text_input_control_1.TextInputControl(['width', 'length', 'area', 'measuredFactor'], this.dataInputs);
	        this.textInputControl.updateAllTextboxInputs();
	    };
	    WidthLengthAreaInputComponent.prototype.ngDoCheck = function () {
	        if (this.triggerUpdate) {
	            this.textInputControl.updateAllTextboxInputs();
	            // console.log(this.triggerUpdate)
	            this.triggerUpdate = false;
	        }
	    };
	    WidthLengthAreaInputComponent.prototype.onTextboxChange = function (key, newInput) {
	        var oldValid = this.textInputControl.textboxValid[key];
	        this.textInputControl.validateTextboxInput(key, newInput);
	        if (this.textInputControl.textboxValid[key] != oldValid) {
	            this.texboxValidCheck.emit(this.textInputControl.checkAllValid());
	        }
	        if (this.textInputControl.textboxValid[key]) {
	            if (key == 'length' || (key == 'width' && this.lastEdit == 'length')) {
	                this.dataInputs.updateAreaFromLength();
	                this.textInputControl.updateTextboxInput('area');
	                this.lastEdit = 'length';
	            }
	            if (key == 'area' || (key == 'width' && this.lastEdit == 'area')) {
	                this.dataInputs.updateLengthFromArea();
	                this.textInputControl.updateTextboxInput('length');
	                this.lastEdit = 'area';
	            }
	            this.validTextBoxChange.emit();
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], WidthLengthAreaInputComponent.prototype, "textboxLabels", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', model_data_1.AreaLengthConversion)
	    ], WidthLengthAreaInputComponent.prototype, "dataInputs", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], WidthLengthAreaInputComponent.prototype, "triggerUpdate", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], WidthLengthAreaInputComponent.prototype, "disabled", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], WidthLengthAreaInputComponent.prototype, "rows", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], WidthLengthAreaInputComponent.prototype, "validTextBoxChange", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], WidthLengthAreaInputComponent.prototype, "texboxValidCheck", void 0);
	    WidthLengthAreaInputComponent = __decorate([
	        core_1.Component({
	            selector: 'my-width-length-area-input',
	            template: __webpack_require__(144)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], WidthLengthAreaInputComponent);
	    return WidthLengthAreaInputComponent;
	}());
	exports.WidthLengthAreaInputComponent = WidthLengthAreaInputComponent;


/***/ },
/* 153 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mdl-grid\">\n  <div class=\"mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\">\n    <h5>Description</h5>\n    <p>\n      Use this component to turn a set of at least 8 measured factors with corresponding equivalent widths and lengths into a spline model.\n      These widths and lengths need to be determined using the parameterisation method employed within the \n      <a routerLink=\"/parameterise\" routerLinkActive=\"active\">\n        parameterisation component.\n      </a>\n    </p>\n    <p>\n      You are free to edit the widths, lengths, and factors manually below, or have the       \n      <a routerLink=\"/parameterise\" routerLinkActive=\"active\">\n        parameterisation component\n      </a>\n      automatically add the measured factors to the correct model. Both work interchangably.\n      You may only add shapes via the \n      <a routerLink=\"/parameterise\" routerLinkActive=\"active\">\n        parameterisation component\n      </a>\n      if machine ID, applicator, energy, ssd, and measured factor are filled in and they match a machine configuration defined within the \n      <a routerLink=\"/specifications\" routerLinkActive=\"active\">\n        specifications component.\n      </a> \n    </p>\n    <p>\n      A spline model is only valid for a single machine configuration. \n      Therefore each machine, applicator, energy, ssd has its own model. \n      Using the machine configuration section below you can change between the configurations.\n      This will only work if you have already\n      <a routerLink=\"/specifications\" routerLinkActive=\"active\">\n        defined your machine configurations.\n      </a> \n    </p>\n\n  </div>\n  <div class=\"mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\">\n    <h5>Choose machine configuration</h5>\n    <p>\n      Here is where you select the machine specifications for the model you with to edit. \n      You will only see options here if you have actually       \n      <a routerLink=\"/specifications\" routerLinkActive=\"active\">\n        defined your machine configurations.\n      </a> \n    </p>\n  </div>\n\n  <div [style.width]=\"'100%'\">\n    <my-choose-specifications #settingsPicker\n      (settingsUpdated)=currentMachineSettingsUpdated($event)>\n    </my-choose-specifications>\n  </div>\n  \n\n  <div class=\"mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\">\n    <div [style.width]=\"'100%'\" [style.height]=\"'30px'\"></div>\n    <h5>\n      The model\n      <span *ngIf=\"currentSettings.machine != null && currentSettings.energy != null && currentSettings.energy != 0 && currentSettings.applicator != null && currentSettings.applicator != '' && currentSettings.ssd != null && currentSettings.ssd != 0\">\n        for machine ID {{currentSettings.machine}}, at an energy of {{currentSettings.energy}} MeV, on the {{currentSettings.applicator}} applicator at {{currentSettings.ssd}} cm SSD\n      </span>\n      </h5>    \n  </div>\n  <div class=\"mdl-cell mdl-cell--6-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\">\n\n    <h6>Input widths, lengths, and factors</h6>\n    <p>\n      Use the following text boxes to directly edit the measured data used by the spline model.\n    </p>\n    <p>\n      Coordinates can be separated by commas (,), semicolons (;), tabs, or new lines.\n      This web app should handle copying and pasting from a range of sources (including excel).\n      Number inputs can only contain the characters 0-9, a minus sign (-) and decimal points (.).\n    </p>\n\n    <my-width-length-area-input #textboxInputs\n      [dataInputs]=modelData.measurement\n      [textboxLabels]=textboxLabels\n      [triggerUpdate]=false\n      [rows]=4\n      [disabled]=\"dataInFlight\"\n      (texboxValidCheck)=\"textboxValid=$event\"\n      (validTextBoxChange)=onValidTextboxChange()></my-width-length-area-input>\n\n    <!--<div *ngFor=\"let key of ['width', 'length', 'measuredFactor']\">\n      <mdl-textfield \n        type=\"text\"\n        [label]=\"textboxLabels[key]\"\n        [(ngModel)]=\"this.textboxInput[key]\"\n        (input)=\"onTextboxChange(key, $event.target.value)\"\n        rows=4\n        floating-label\n        [disabled]=\"dataInFlight\"\n        [style.width]=\"'100%'\"></mdl-textfield>\n      <p *ngIf=\"!textboxValid[key]\">\n        The {{key}} input is invalid\n      </p>\n      <span *ngIf=\"key=='length'\">\n        \n      </span>\n    </div>-->\n    <p *ngIf=\"lengthSmallerThanWidth\">\n      There exists a length value that is smaller than its corresponding width. Spline modelling is disabled as a result.\n    </p>\n    <p *ngIf=\"modelData.measurement.measuredFactor.length != modelData.measurement.width.length || modelData.measurement.measuredFactor.length != modelData.measurement.length.length || modelData.measurement.width.length != modelData.measurement.length.length\">\n      The lengths of the inputs are not equal. Spline modelling is disabled as a result.\n    </p>\n    <p *ngIf=\"modelData.measurement.width.length < 8 || modelData.measurement.length.length < 8 || modelData.measurement.measuredFactor.length < 8\">\n      There are currently less than 8 data points. Spline modelling is disabled as a result.\n    </p>\n  </div>\n\n<div class=\"mdl-cell mdl-cell--6-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\" #plotContainer>\n    <h6>The spline model</h6>\n    <button\n      mdl-button mdl-button-type=\"raised\" \n      mdl-colored=\"primary\" \n      mdl-ripple\n      angulartics2On=\"click\" angularticsEvent=\"Model | Load demo data\"\n      [disabled]=\"dataInFlight\"\n      (click)=\"loadDemoData()\">Load demo data         \n    </button>\n      \n    <button\n      mdl-button mdl-button-type=\"raised\" \n      mdl-colored=\"primary\" \n      mdl-ripple\n      angulartics2On=\"click\" angularticsEvent=\"Model | Calculate spline model\"\n      [disabled]=\"modelData.measurement.width.length < 8 || modelData.measurement.length.length < 8 || modelData.measurement.measuredFactor.length < 8 || dataInFlight || modelData.measurement.measuredFactor.length != modelData.measurement.width.length || modelData.measurement.measuredFactor.length != modelData.measurement.length.length || modelData.measurement.width.length != modelData.measurement.length.length || !textboxValid || lengthSmallerThanWidth\"\n      (click)=\"basicServerSubmit()\">Calculate Spline Model\n    </button>\n    \n\n    <div *ngIf=\"modelData.measurement.width.length > 0 && modelData.measurement.length.length > 0 && modelData.measurement.measuredFactor.length > 0\">\n      <my-bokeh-create-model\n        [title]=\"'Model Plot'\"\n        [scatter_x]=\"modelData.measurement.width\"\n        [scatter_y]=\"modelData.measurement.length\"\n        [scatter_z]=\"modelData.measurement.measuredFactor\"\n        [pcolour_x]=\"modelData.model.width\"\n        [pcolour_y]=\"modelData.model.length\"\n        [pcolour_z]=\"modelData.model.predictedFactor\"\n        [plot_width]=\"plot_width\"\n        [plot_height]=\"380\"\n        [selectionList]=\"selectionList\">\n      </my-bokeh-create-model>\n    </div>\n    <div *ngIf=\"modelData.measurement.width.length == 0 || modelData.measurement.length.length == 0|| modelData.measurement.measuredFactor.length == 0\">\n      <p>\n        <font color=\"red\">There is currently no data for this combination.</font> If you wish to load some demo data to see the model in action press the \"load demo data\" button below.\n        To set this model up with your own data follow the instructions in the description at the top of this page.\n      </p>\n    </div>\n\n\n  </div>\n\n\n  <div class=\"mdl-cell mdl-cell--6-col mdl-cell--8-col-tablet\">\n    <h5>Change modelling server url (optional)</h5>\n    <p>Only change the following address if you wish to use your own server. This is not required to be edited. The default is: <br>\n      <a (click)=\"defaultServer()\">http://electronapi.simonbiggs.net/model</a>        \n    </p>\n    <mdl-textfield\n      type=\"text\"\n      label=\"Spline model server address\"\n      (input)=\"modelServerChange($event.target.value)\"\n      floating-label\n      [(ngModel)]=\"modelURL\"\n      style=\"width:100%\"></mdl-textfield>\n\n \n    \n  </div>\n\n\n  <div class=\"mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\">  \n    <h5>Move factors to the use model component for model validation</h5>\n        <button *ngIf=\"selectionList != null\"\n          mdl-button mdl-button-type=\"raised\" \n          mdl-colored=\"primary\" \n          mdl-ripple\n          angulartics2On=\"click\" angularticsEvent=\"Create Model | Move selected factors to use model component\"\n          [disabled]=\"selectionList.indexOf(true) == -1 || dataInFlight || currentSettings.machine == null || currentSettings.energy == null || currentSettings.energy == 0 || currentSettings.applicator == null || currentSettings.applicator == '' || currentSettings.ssd == null || currentSettings.ssd == 0\"\n          (click)=\"moveSelectedFactorsToUseModel()\">Move selected factors to use model component         \n        </button>\n        <button *ngIf=\"selectionList != null\"\n          mdl-button mdl-button-type=\"raised\" \n          mdl-colored=\"primary\" \n          mdl-ripple\n          angulartics2On=\"click\" angularticsEvent=\"Create Model | Remove selected factors\"\n          [disabled]=\"selectionList.indexOf(true) == -1 || dataInFlight\"\n          (click)=\"removeSelectedFactors()\">Remove selected factors\n        </button>   \n        <button *ngIf=\"selectionList != null\"\n          mdl-button mdl-button-type=\"raised\" \n          mdl-colored=\"primary\" \n          mdl-ripple\n          angulartics2On=\"click\" angularticsEvent=\"Create Model | Randomly move shapes\"\n          [disabled]=\"selectionList.length < convertToNumber(numberOfShapesToLeaveBehind) + 1 || dataInFlight || currentSettings.machine == null || currentSettings.energy == null || currentSettings.energy == 0 || currentSettings.applicator == null || currentSettings.applicator == '' || currentSettings.ssd == null || currentSettings.ssd == 0\"\n          (click)=\"randomMove()\">Randomly move all but {{numberOfShapesToLeaveBehind}} shapes to use model component\n        </button>\n        <mdl-textfield\n          type=\"number\"\n          label=\"Number of shapes to leave behind after random move\"\n          floating-label\n          [(ngModel)]=\"numberOfShapesToLeaveBehind\"\n          style=\"width:100%\"></mdl-textfield>\n        <div style=\"overflow: auto\">\n          <my-create-insert-table\n            [width]=\"modelData.measurement.width\"\n            [length]=\"modelData.measurement.length\"\n            [area]=\"modelData.measurement.area\"\n            [measuredFactor]=\"modelData.measurement.measuredFactor\"\n            (selectionChangedEvent)=\"selectionChanged($event)\"></my-create-insert-table>\n        </div>\n\n  </div>\n\n</div>";

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var title_service_1 = __webpack_require__(131);
	var model_data_1 = __webpack_require__(137);
	var data_persistence_service_1 = __webpack_require__(132);
	var current_settings_1 = __webpack_require__(140);
	var width_length_area_input_component_1 = __webpack_require__(152);
	var UseModelComponent = (function () {
	    function UseModelComponent(modelData, myTitleService, dataPersistenceService, currentSettings, ngZone) {
	        var _this = this;
	        this.modelData = modelData;
	        this.myTitleService = myTitleService;
	        this.dataPersistenceService = dataPersistenceService;
	        this.currentSettings = currentSettings;
	        this.ngZone = ngZone;
	        this.textboxLabels = {
	            width: "Width of ellipse given by diameter of largest encompassed circle (cm @iso)",
	            length: "Length of ellipse that matches insert shape area (cm @iso)",
	            area: "[Optional] Area of insert shape (cm^2 @iso)",
	            measuredFactor: "[Optional] Measured insert factor (as per TG 25)"
	        };
	        this.modelLookup = {};
	        this.predictionDifference = [];
	        this.selectionList = [];
	        this.canBeSentToModel = [];
	        this.disableSendToModelButtons = true;
	        this.plot_width = 600;
	        window.onresize = function (e) {
	            ngZone.run(function () {
	                _this.updatePlotWidth();
	            });
	        };
	    }
	    UseModelComponent.prototype.ngOnDestroy = function () {
	        console.log('use-model.component ngOnDestroy');
	        window.onresize = null;
	    };
	    UseModelComponent.prototype.ngOnInit = function () {
	        console.log('use-model.component ngOnInit');
	        this.myTitleService.setTitle('Use Model');
	        this.updatePlotWidth();
	        this.updateModelLookup();
	    };
	    UseModelComponent.prototype.ngAfterViewInit = function () {
	        console.log('use-model.component ngAfterViewInit');
	        this.loadMeasuredData();
	        this.updatePredictedFactors();
	    };
	    UseModelComponent.prototype.selectionChanged = function (selectionList) {
	        console.log('use-model.component selectionChanged');
	        this.selectionList = selectionList;
	        this.disableSendToModelButtons = true;
	        for (var i in this.selectionList) {
	            if (this.selectionList[i] && this.canBeSentToModel[i]) {
	                this.disableSendToModelButtons = false;
	            }
	        }
	    };
	    UseModelComponent.prototype.lookupFactor = function (width, length) {
	        console.log('use-model.component lookupFactor');
	        width = Math.round(width * 10) / 10;
	        length = Math.round(length * 10) / 10;
	        var key;
	        key = String(width) + "," + String(length);
	        return Math.round(this.modelLookup[key] * 1000) / 1000;
	    };
	    UseModelComponent.prototype.updatePredictedFactors = function () {
	        console.log('use-model.component updatePredictedFactors');
	        this.modelData.predictions.predictedFactor = [];
	        var amount = Math.min(this.modelData.predictions.width.length, this.modelData.predictions.length.length);
	        var predictedFactor;
	        var width;
	        var length;
	        for (var i = 0; i < amount; i++) {
	            width = this.modelData.predictions.width[i];
	            length = this.modelData.predictions.length[i];
	            predictedFactor = this.lookupFactor(width, length);
	            this.modelData.predictions.predictedFactor.push(predictedFactor);
	        }
	        this.updatePredictionDifference();
	    };
	    UseModelComponent.prototype.updatePredictionDifference = function () {
	        console.log('use-model.component updatePredictionDifference');
	        this.predictionDifference = [];
	        var measuredFactor;
	        var predictedFactor;
	        var difference;
	        for (var i in this.modelData.predictions.measuredFactor) {
	            measuredFactor = this.modelData.predictions.measuredFactor[i];
	            predictedFactor = this.modelData.predictions.predictedFactor[i];
	            difference = predictedFactor - measuredFactor;
	            difference = Math.round(difference * 1000) / 1000;
	            this.predictionDifference.push(difference);
	        }
	    };
	    UseModelComponent.prototype.updateModelLookup = function () {
	        console.log('use-model.component updateModelLookup');
	        this.modelLookup = {};
	        var key;
	        for (var i in this.modelData.model.width) {
	            key = String(this.modelData.model.width[i]) + "," + String(this.modelData.model.length[i]);
	            this.modelLookup[key] = this.modelData.model.predictedFactor[i];
	        }
	    };
	    UseModelComponent.prototype.updatePlotWidth = function () {
	        console.log('use-model.component updatePlotWidth');
	        this.plot_width = this.plotContainer.nativeElement.clientWidth;
	    };
	    UseModelComponent.prototype.currentMachineSettingsUpdated = function (newSettings) {
	        console.log('use-model.component currentMachineSettingsUpdated');
	        this.currentSettings = newSettings;
	        this.loadMeasuredData();
	    };
	    UseModelComponent.prototype.loadMeasuredData = function () {
	        var _this = this;
	        console.log('use-model.component loadMeasuredData');
	        if (this.currentSettings === undefined) {
	            throw new RangeError("Tried to load measured data but current settings are not defined");
	        }
	        this.dataPersistenceService.loadModelData(this.modelData, this.currentSettings).then(function () {
	            console.log('use-model.component loadMeasuredData this.dataPersistenceService.loadModelData(this.modelData, this.currentSettings) promise complete');
	            _this.updateModelLookup();
	            _this.updatePredictedFactors();
	            _this.checkAllIfCanBeAddedToModel();
	            _this.textboxInputs.triggerUpdate = true;
	        });
	    };
	    UseModelComponent.prototype.saveModel = function () {
	        console.log('use-model.component saveModel');
	        this.dataPersistenceService.saveModelData(this.modelData, this.currentSettings);
	    };
	    UseModelComponent.prototype.onValidTextboxChange = function () {
	        console.log('use-model.component onValidTextboxChange');
	        this.updatePredictedFactors();
	        this.checkAllIfCanBeAddedToModel();
	        this.saveModel();
	    };
	    UseModelComponent.prototype.checkIfCanAddToModel = function (width, length, measuredFactor) {
	        console.log('use-model.component checkIfCanAddToModel');
	        if (width != null && length != null && measuredFactor != null) {
	            if (this.modelData.measurement.width.indexOf(Number(width)) > -1 &&
	                this.modelData.measurement.length.indexOf(Number(length)) > -1 &&
	                this.modelData.measurement.measuredFactor.indexOf(Number(measuredFactor)) > -1) {
	                return false;
	            }
	            else if (Number(width) == 0 ||
	                Number(length) == 0 ||
	                Number(measuredFactor) == 0) {
	                return false;
	            }
	            else {
	                return true;
	            }
	        }
	        else {
	            return false;
	        }
	    };
	    UseModelComponent.prototype.checkAllIfCanBeAddedToModel = function () {
	        console.log('use-model.component checkAllIfCanBeAddedToModel');
	        this.canBeSentToModel = [];
	        var width;
	        var length;
	        var measuredFactor;
	        for (var i in this.modelData.predictions.width) {
	            width = this.modelData.predictions.width[i];
	            length = this.modelData.predictions.length[i];
	            measuredFactor = this.modelData.predictions.measuredFactor[i];
	            this.canBeSentToModel.push(this.checkIfCanAddToModel(width, length, measuredFactor));
	        }
	    };
	    UseModelComponent.prototype.moveSelectedFactorsToModel = function () {
	        console.log('use-model.component moveSelectedFactorsToModel');
	        this.modelData.model.reset();
	        for (var i = this.selectionList.length - 1; i > -1; i--) {
	            if (this.selectionList[i] && this.canBeSentToModel[i]) {
	                for (var _i = 0, _a = ['width', 'length', 'area', 'measuredFactor']; _i < _a.length; _i++) {
	                    var key = _a[_i];
	                    this.modelData.measurement[key].unshift(Number(this.modelData.predictions[key][i]));
	                    this.modelData.predictions[key].splice(i, 1);
	                }
	            }
	        }
	        this.updatePredictedFactors();
	        this.checkAllIfCanBeAddedToModel();
	        this.saveModel();
	        this.textboxInputs.triggerUpdate = true;
	    };
	    UseModelComponent.prototype.addSelectedFactorsToModel = function () {
	        console.log('use-model.component addSelectedFactorsToModel');
	        this.modelData.model.reset();
	        for (var i = this.selectionList.length - 1; i > -1; i--) {
	            if (this.selectionList[i] && this.canBeSentToModel[i]) {
	                for (var _i = 0, _a = ['width', 'length', 'measuredFactor']; _i < _a.length; _i++) {
	                    var key = _a[_i];
	                    this.modelData.measurement[key].unshift(Number(this.modelData.predictions[key][i]));
	                }
	            }
	        }
	        this.checkAllIfCanBeAddedToModel();
	        this.saveModel();
	    };
	    UseModelComponent.prototype.removeSelectedFactors = function () {
	        console.log('use-model.component addSelectedFactorsToModel');
	        for (var i = this.selectionList.length - 1; i > -1; i--) {
	            if (this.selectionList[i]) {
	                for (var _i = 0, _a = ['width', 'length', 'area', 'measuredFactor']; _i < _a.length; _i++) {
	                    var key = _a[_i];
	                    this.modelData.predictions[key].splice(i, 1);
	                }
	            }
	        }
	        this.updatePredictedFactors();
	        this.checkAllIfCanBeAddedToModel();
	        this.saveModel();
	        this.textboxInputs.triggerUpdate = true;
	    };
	    __decorate([
	        core_1.ViewChild('plotContainer'), 
	        __metadata('design:type', Object)
	    ], UseModelComponent.prototype, "plotContainer", void 0);
	    __decorate([
	        core_1.ViewChild('settingsPicker'), 
	        __metadata('design:type', Object)
	    ], UseModelComponent.prototype, "settingsPicker", void 0);
	    __decorate([
	        core_1.ViewChild('textboxInputs'), 
	        __metadata('design:type', width_length_area_input_component_1.WidthLengthAreaInputComponent)
	    ], UseModelComponent.prototype, "textboxInputs", void 0);
	    UseModelComponent = __decorate([
	        core_1.Component({
	            selector: 'my-use-model',
	            template: __webpack_require__(155)
	        }), 
	        __metadata('design:paramtypes', [model_data_1.ModelData, title_service_1.TitleService, data_persistence_service_1.DataPersistenceService, current_settings_1.CurrentSettings, core_1.NgZone])
	    ], UseModelComponent);
	    return UseModelComponent;
	}());
	exports.UseModelComponent = UseModelComponent;


/***/ },
/* 155 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mdl-grid\">\n  <div class=\"mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\">\n    <h5>Use models</h5>\n    <p>\n      This component is where created models are used. \n      Factors for prediction will be able to be inputted using width, and then either length or area, and optionally\n      a measured factor can be included for the purpose of comparing model results with measurement.\n    </p>\n    <p>\n      You can either use the parameterisation component to parameterise your shapes, or if you have a large data set of \n      generic shapes you need only determine the diameter of the largest encompassed circle to define width, and then\n      you may input shape area instead of length. \n      For example, the diameter of the largest fully encompassed circle within a rectangle is the width of the rectangle, \n      and the area of a rectangle is width x length.\n      This allows you to quickly check large data sets of previous measurements on generic shapes.\n    </p>\n  </div>\n\n  <div class=\"mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\">\n    <h5>Choose machine configuration</h5>\n    <my-choose-specifications #settingsPicker\n      (settingsUpdated)=currentMachineSettingsUpdated($event)>\n    </my-choose-specifications>\n  </div>\n\n  <div class=\"mdl-cell mdl-cell--6-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\">\n    <h5>Inserts being predicted</h5>\n    <my-width-length-area-input #textboxInputs\n      [dataInputs]=modelData.predictions\n      [textboxLabels]=textboxLabels\n      [triggerUpdate]=false\n      (validTextBoxChange)=onValidTextboxChange()></my-width-length-area-input>\n    <!--<p>Predicted factors: {{modelData.predictions.predictedFactor}}</p>\n    <p>Prediction minus measured: {{predictionDifference}}</p>-->\n\n    \n  </div>\n\n  <div class=\"mdl-cell mdl-cell--6-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\" #plotContainer>\n    <div *ngIf=\"modelData.predictions.width.length > 0 && modelData.predictions.length.length > 0 && modelData.predictions.predictedFactor != null\">\n      <my-bokeh-use-model\n        [title]=\"'Model Plot'\"\n        [scatter_x]=\"modelData.predictions.width\"\n        [scatter_y]=\"modelData.predictions.length\"\n        [area]=\"modelData.predictions.area\"\n        [scatter_z]=\"modelData.predictions.measuredFactor\"\n        [predicted_factor]=\"modelData.predictions.predictedFactor\"\n        [pcolour_x]=\"modelData.model.width\"\n        [pcolour_y]=\"modelData.model.length\"\n        [pcolour_z]=\"modelData.model.predictedFactor\"\n        [plot_width]=\"plot_width\"\n        [plot_height]=\"380\"\n        [selectionList]=\"selectionList\">\n      </my-bokeh-use-model>\n    </div>\n    <div *ngIf=\"modelData.model.width.length == 0 || modelData.model.length.length == 0|| modelData.model.predictedFactor.length == 0\">\n      <p>\n        A model has not been calculated for this machine specification.\n        If you do have at least 8 data points please calculate the spline model on the           \n        <a routerLink=\"/create-model\" routerLinkActive=\"active\">\n          create model component.\n        </a>\n      </p>\n    </div>\n    \n  </div>\n\n\n\n  <div class=\"mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\">\n\n    <h5>Batch add or delete factors</h5>\n\n    <button *ngIf=\"selectionList != null\"\n      mdl-button mdl-button-type=\"raised\" \n      mdl-colored=\"primary\" \n      mdl-ripple\n      angulartics2On=\"click\" angularticsEvent=\"Use Model | Move selected factors onto model if able \"\n      [disabled]=\"disableSendToModelButtons || currentSettings.machine == null || currentSettings.energy == null || currentSettings.energy == 0 || currentSettings.applicator == null || currentSettings.applicator == '' || currentSettings.ssd == null || currentSettings.ssd == 0\"\n      (click)=\"moveSelectedFactorsToModel()\">Move selected factors onto model if able \n    </button>\n    <button *ngIf=\"selectionList != null\"\n      mdl-button mdl-button-type=\"raised\" \n      mdl-colored=\"primary\" \n      mdl-ripple\n      angulartics2On=\"click\" angularticsEvent=\"Use Model | Add selected factors onto model if able \"\n      [disabled]=\"disableSendToModelButtons || currentSettings.machine == null || currentSettings.energy == null || currentSettings.energy == 0 || currentSettings.applicator == null || currentSettings.applicator == '' || currentSettings.ssd == null || currentSettings.ssd == 0\"\n      (click)=\"addSelectedFactorsToModel()\">Add selected factors onto model if able           \n    </button>\n    <button *ngIf=\"selectionList != null\"\n      mdl-button mdl-button-type=\"raised\" \n      mdl-colored=\"primary\" \n      mdl-ripple\n      angulartics2On=\"click\" angularticsEvent=\"Use Model | Remove selected factors\"\n      [disabled]=\"selectionList.indexOf(true) == -1\"\n      (click)=\"removeSelectedFactors()\">Remove selected factors\n    </button>\n\n    <div style=\"overflow: auto\">\n      <my-insert-table\n        [width]=\"modelData.predictions.width\"\n        [length]=\"modelData.predictions.length\"\n        [area]=\"modelData.predictions.area\"\n        [predictedFactor]=\"modelData.predictions.predictedFactor\"\n        [measuredFactor]=\"modelData.predictions.measuredFactor\"\n        [canBeAdded]=\"canBeSentToModel\"\n        (selectionChangedEvent)=\"selectionChanged($event)\"></my-insert-table>\n    </div>\n  </div>\n</div>";

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var title_service_1 = __webpack_require__(131);
	// import { LocalStorageService } from '../../services/data-services/local-storage.service';
	var data_persistence_service_1 = __webpack_require__(132);
	var StorageManagementComponent = (function () {
	    function StorageManagementComponent(myTitleService, dataPersistenceService) {
	        var _this = this;
	        this.myTitleService = myTitleService;
	        this.dataPersistenceService = dataPersistenceService;
	        this.reader = new FileReader();
	        this.emptyDataBaseString = "{\n  \"databaseDetails\": {\n    \"name\": \"DefaultDatabase\",\n    \"version\": 1,\n    \"schema\": {\n      \"specifications\": \"machine, makeAndModel, energy, R50, applicator, ssd\",\n      \"currentSettings\": \"id, machine, energy, applicator, ssd\",\n      \"currentInsertData\": \"id, machine, parameterisation, energy, applicator, ssd, measuredFactor\",\n      \"modelData\": \"machineSettingsKey, measurement, model, predictions\",\n      \"dicomInsertList\": \"id, machine, parameterisation, energy, applicator, ssd, measuredFactor\",\n      \"serverURLs\": \"purpose, url\",\n      \"parameterisationCache\": \"id, insert, width, length, circle, ellipse\",\n      \"pulledFromLocalStorage\": \"id, pulledFromLocalStorage\"\n    }\n  },\n  \"databaseContents\": {\n    \"specifications\": [],\n    \"currentSettings\": [],\n    \"currentInsertData\": [],\n    \"modelData\": [],\n    \"dicomInsertList\": [],\n    \"serverURLs\": [],\n    \"parameterisationCache\": [],\n    \"pulledFromLocalStorage\": [\n      {\n        \"id\": 0,\n        \"pulledFromLocalStorage\": true\n      }\n    ]\n  }\n}";
	        this.reader.onload = function (event) {
	            console.log('storage-management.component this.reader.onload');
	            var contents = event.target.result;
	            _this.fileJsonObject = JSON.parse(contents);
	        };
	    }
	    StorageManagementComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        console.log('storage-management.component ngOnInit');
	        this.myTitleService.setTitle('Database management');
	        this.dataPersistenceService.databaseDump()
	            .then(function (stringDump) {
	            _this.databaseDump = stringDump;
	        });
	    };
	    StorageManagementComponent.prototype.ngAfterViewInit = function () {
	        // this.highlightJson()
	    };
	    StorageManagementComponent.prototype.highlightJson = function () {
	        hljs.highlightBlock(this.jsonCodeDisplay);
	    };
	    StorageManagementComponent.prototype.exportDataBase = function () {
	        var _this = this;
	        console.log('storage-management.component exportDataBase');
	        this.dataPersistenceService.databaseDump()
	            .then(function (stringDump) {
	            _this.databaseDump = stringDump;
	            var element = document.createElement('a');
	            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(stringDump));
	            element.setAttribute('download', 'databaseDump.json');
	            element.style.display = 'none';
	            document.body.appendChild(element);
	            element.click();
	            document.body.removeChild(element);
	        });
	    };
	    StorageManagementComponent.prototype.openFile = function (event) {
	        console.log('storage-management.component openFile');
	        if (typeof event.target !== 'undefined') {
	            var file = event.target.files[0];
	            if (file) {
	                this.reader.readAsText(file);
	            }
	        }
	        else {
	            console.log(event);
	        }
	    };
	    StorageManagementComponent.prototype.appendJsonToDatabase = function (jsonObject) {
	        var _this = this;
	        this.dataPersistenceService.appendJsonToDatabase(jsonObject)
	            .then(function () {
	            return _this.dataPersistenceService.databaseDump();
	        })
	            .then(function (stringDump) {
	            _this.databaseDump = stringDump;
	            _this.fileJsonObject = null;
	        });
	    };
	    StorageManagementComponent.prototype.emptyDatabase = function () {
	        var _this = this;
	        this.dataPersistenceService.databaseDump()
	            .then(function (stringDump) {
	            _this.tempSaveOfDatabaseDump = stringDump;
	            return _this.dataPersistenceService.emptyDatabase();
	        })
	            .then(function () {
	            return _this.dataPersistenceService.databaseDump();
	        })
	            .then(function (stringDump) {
	            _this.databaseDump = stringDump;
	        });
	    };
	    StorageManagementComponent.prototype.undoDataEmpty = function () {
	        this.appendJsonToDatabase(JSON.parse(this.tempSaveOfDatabaseDump));
	    };
	    __decorate([
	        core_1.ViewChild('jsonCodeDisplay'), 
	        __metadata('design:type', Object)
	    ], StorageManagementComponent.prototype, "jsonCodeDisplay", void 0);
	    StorageManagementComponent = __decorate([
	        core_1.Component({
	            selector: 'my-storage-management',
	            template: __webpack_require__(157)
	        }), 
	        __metadata('design:paramtypes', [title_service_1.TitleService, data_persistence_service_1.DataPersistenceService])
	    ], StorageManagementComponent);
	    return StorageManagementComponent;
	}());
	exports.StorageManagementComponent = StorageManagementComponent;


/***/ },
/* 157 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mdl-grid\">\n  <div class=\"mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--6-col-phone\">\n    <h5>Description</h5>\n    <p>\n      All of your model data is stored within an <a href=\"https://developer.mozilla.org/en/docs/Web/API/IndexedDB_API\">IndexedDB</a> database within your browser.\n      This database is specific to your browser, computer, and this web address. This means that other websites nor other computers can access this data directly.\n      To use your data across a range of computers you need to export it to file, and then import it on the computers that need to use the data.\n    </p>\n    <p>\n      This component is for exporting, deleting, and adding data to and from this browser's database.\n    </p>\n\n    <p>\n      Internally this web app uses <a href=\"http://dexie.org/\">Dexie.js</a> to access the database api.\n    </p>\n  </div>\n  <div class=\"mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--6-col-phone\">\n    <h5>Export database to file</h5>\n    <p>\n      The following button will export the browser database to a .json file. Use this to either backup or transfer your data.\n    </p>\n    <button\n      mdl-button mdl-button-type=\"fab\" \n      mdl-colored=\"primary\" \n      mdl-ripple\n      angulartics2On=\"click\" angularticsEvent=\"Storage | Export browser database\"\n      (click)=\"exportDataBase()\"><img src=\"/webapp/lib/material/file_download.png\">\n    </button>\n  </div>\n  <div class=\"mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--6-col-phone\">\n    <h5>Delete data from database</h5>\n    <p>\n      The following button will remove the data from your database. \n      Use this if you wish to freshly import a new file or to start afresh.\n    </p>\n    <button\n      mdl-button mdl-button-type=\"fab\" \n      mdl-colored=\"primary\" \n      mdl-ripple\n      angulartics2On=\"click\" angularticsEvent=\"Storage | Empty current database\"\n      [disabled]=\"emptyDataBaseString==databaseDump\"\n      (click)=\"emptyDatabase()\"><img src=\"/webapp/lib/material/delete_forever.png\">\n    </button>\n    <button\n      mdl-button mdl-button-type=\"fab\" \n      mdl-colored=\"primary\" \n      mdl-ripple\n      angulartics2On=\"click\" angularticsEvent=\"Storage | Empty current database\"\n      [disabled]=\"tempSaveOfDatabaseDump==null || emptyDataBaseString!=databaseDump\"\n      (click)=\"undoDataEmpty()\"><img src=\"/webapp/lib/material/undo.png\">\n    </button>\n\n  </div>\n  <div class=\"mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--6-col-phone\">\n\n\n    <h5>Add data to database from file</h5>\n    <p>\n      The following button will append the contents of the given .json file to your browser database.\n      If a key within your .json file matches that of your browser database then the database entry will be overwritten.\n      This is not reversable.\n    </p>\n\n    <input type='file' (change)='openFile($event)'>\n\n    <button      \n      mdl-button mdl-button-type=\"fab\" \n      mdl-colored=\"primary\" \n      mdl-ripple\n      angulartics2On=\"click\" angularticsEvent=\"Storage | Empty current database\"\n      [disabled]=\"fileJsonObject == null\"\n      (click)=\"appendJsonToDatabase(fileJsonObject)\"><img src=\"/webapp/lib/material/file_upload.png\">\n    </button>\n  </div>\n\n  <div *ngIf=\"databaseDump != null\" class=\"mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\">\n    <h5>Your current raw database file</h5>\n      <p>\n        Number of characters within database dump: {{databaseDump.length}} \n      </p>\n      <div style=\"white-space: pre-wrap\"><div #jsonCodeDisplay><code class=\"json\">{{databaseDump}}</code></div>\n  </div>\n</div>";

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var title_service_1 = __webpack_require__(131);
	var data_persistence_service_1 = __webpack_require__(132);
	var specifications_data_service_1 = __webpack_require__(139);
	var SpecificationsComponent = (function () {
	    function SpecificationsComponent(myTitleService, dataPersistenceService, machineSpecificationService) {
	        this.myTitleService = myTitleService;
	        this.dataPersistenceService = dataPersistenceService;
	        this.machineSpecificationService = machineSpecificationService;
	        this.newMachineIDValid = false;
	        this.newModelValid = false;
	        this.newMachineValid = false;
	        this.edittingMachine = null;
	        this.newEnergyValid = false;
	        this.newR50Valid = false;
	        this.newEnergySetValid = false;
	        this.edittingEnergy = null;
	        this.newApplicatorValid = false;
	        this.edittingApplicator = null;
	        this.newSSDValid = false;
	        this.edittingSSD = null;
	    }
	    SpecificationsComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        console.log('specifications.component ngOnInit');
	        this.myTitleService.setTitle('Specifications');
	        this.machineSpecificationService.loadData()
	            .then(function () {
	            console.log('specifications.component ngOnInit this.machineSpecificationService.loadData() promise complete');
	            _this.currentSettings = _this.machineSpecificationService.currentSettings;
	        });
	    };
	    SpecificationsComponent.prototype.checkNewMachineIDInput = function () {
	        console.log('specifications.component checkNewMachineIDInput');
	        if (this.machineSpecificationService.machineList.indexOf(this.newMachineID) == -1 &&
	            this.newMachineID != null && this.newMachineID != "") {
	            this.newMachineIDValid = true;
	        }
	        else {
	            this.newMachineIDValid = false;
	        }
	        this.checkNewMachineValid();
	    };
	    SpecificationsComponent.prototype.checkNewModelInput = function () {
	        console.log('specifications.component checkNewModelInput');
	        if (this.newModel != null && this.newModel != "") {
	            this.newModelValid = true;
	        }
	        else {
	            this.newModelValid = false;
	        }
	        this.checkNewMachineValid();
	    };
	    SpecificationsComponent.prototype.checkNewMachineValid = function () {
	        console.log('specifications.component checkNewMachineValid');
	        this.newMachineValid = (this.newMachineIDValid && this.newModelValid);
	    };
	    SpecificationsComponent.prototype.addMachineID = function () {
	        console.log('specifications.component addMachineID');
	        if (!this.newMachineValid) {
	            throw new RangeError('The new machine being added is not a valid input');
	        }
	        this.machineSpecificationService.newMachine(this.newMachineID, this.newModel);
	        this.newMachineID = null;
	        this.newModel = null;
	        this.newMachineIDValid = false;
	        this.newModelValid = false;
	        this.newMachineValid = false;
	        this.dataPersistenceService.saveSpecificationsData(this.machineSpecificationService.currentSpecification);
	    };
	    SpecificationsComponent.prototype.checkNewEnergyInput = function () {
	        console.log('specifications.component checkNewEnergyInput');
	        if (this.machineSpecificationService.currentSpecification.energy.indexOf(Number(this.newEnergy)) < 0 &&
	            this.newEnergy != null && !isNaN(Number(this.newEnergy))) {
	            this.newEnergyValid = true;
	        }
	        else {
	            this.newEnergyValid = false;
	        }
	        this.checkNewEnergySetValid();
	    };
	    SpecificationsComponent.prototype.checkNewR50Input = function () {
	        console.log('specifications.component checkNewR50Input');
	        if (this.newR50 != null && !isNaN(Number(this.newR50))) {
	            this.newR50Valid = true;
	        }
	        else {
	            this.newR50Valid = false;
	        }
	        this.checkNewEnergySetValid();
	    };
	    SpecificationsComponent.prototype.checkNewEnergySetValid = function () {
	        console.log('specifications.component checkNewEnergySetValid');
	        this.newEnergySetValid = (this.newEnergyValid && this.newR50Valid);
	    };
	    SpecificationsComponent.prototype.addEnergy = function () {
	        console.log('specifications.component addEnergy');
	        if (!this.newEnergySetValid) {
	            throw new RangeError('The new energy set being added is not valid');
	        }
	        this.machineSpecificationService.currentSpecification.energy.push(Number(this.newEnergy));
	        this.machineSpecificationService.currentSpecification.R50.push(Number(this.newR50));
	        this.newEnergy = null;
	        this.newR50 = null;
	        this.newEnergyValid = false;
	        this.newR50Valid = false;
	        this.newEnergySetValid = false;
	        this.dataPersistenceService.saveSpecificationsData(this.machineSpecificationService.currentSpecification);
	    };
	    SpecificationsComponent.prototype.checkNewApplicatorInput = function () {
	        console.log('specifications.component checkNewApplicatorInput');
	        if (this.machineSpecificationService.currentSpecification.applicator.indexOf(this.newApplicator.toLowerCase()) < 0 &&
	            this.newApplicator != null && this.newApplicator != "") {
	            this.newApplicatorValid = true;
	        }
	        else {
	            this.newApplicatorValid = false;
	        }
	    };
	    SpecificationsComponent.prototype.addApplicator = function () {
	        console.log('specifications.component addApplicator');
	        if (!this.newApplicatorValid) {
	            throw new RangeError('The new applicator being added is not valid');
	        }
	        this.machineSpecificationService.currentSpecification.applicator.push(this.newApplicator.toLowerCase());
	        this.newApplicator = null;
	        this.newApplicatorValid = false;
	        this.dataPersistenceService.saveSpecificationsData(this.machineSpecificationService.currentSpecification);
	    };
	    SpecificationsComponent.prototype.checkNewSSDInput = function () {
	        console.log('specifications.component checkNewSSDInput');
	        if (this.machineSpecificationService.currentSpecification.ssd.indexOf(Number(this.newSSD)) < 0 &&
	            this.newSSD != null && !isNaN(Number(this.newSSD))) {
	            this.newSSDValid = true;
	        }
	        else {
	            this.newSSDValid = false;
	        }
	    };
	    SpecificationsComponent.prototype.addSSD = function () {
	        console.log('specifications.component addSSD');
	        if (!this.newSSDValid) {
	            throw new RangeError('The new ssd being added is not valid');
	        }
	        if (this.newSSDValid) {
	            this.machineSpecificationService.currentSpecification.ssd.push(Number(this.newSSD));
	            this.newSSD = null;
	            this.newSSDValid = false;
	            this.dataPersistenceService.saveSpecificationsData(this.machineSpecificationService.currentSpecification);
	        }
	    };
	    SpecificationsComponent = __decorate([
	        core_1.Component({
	            selector: 'my-specifications',
	            template: __webpack_require__(159)
	        }), 
	        __metadata('design:paramtypes', [title_service_1.TitleService, data_persistence_service_1.DataPersistenceService, specifications_data_service_1.MachineSpecificationsService])
	    ], SpecificationsComponent);
	    return SpecificationsComponent;
	}());
	exports.SpecificationsComponent = SpecificationsComponent;


/***/ },
/* 159 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mdl-grid\">\n\n  <div class=\"mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\">\n    <h5>Machine specifications editing</h5>\n    <p>\n      Use this component to define your centre's machine specifications. \n      These will be used throughout this web app to silo each model into its own specific machine ID, applicator, energy, ssd combination.\n    </p>\n    <p>\n      Begin by entering your machine ID as defined within your treatment planning system along with the machine's make and model. \n      Note that these specifications are stored and accessed only on your local machine.\n      They are not sent to the server.\n    </p>\n    <p>\n      <font color=\"#d3d3d3\">\n        Currently specifcations can only be added. At this current time they cannot be edited nor deleted once they have been defined.\n      </font>\n    </p>\n  </div>\n  <div class=\"mdl-cell mdl-cell--4-col mdl-cell--4-col-tablet mdl-cell--6-col-phone\" *ngIf=\"machineSpecificationService != null && currentSettings != null\">\n    <mdl-card mdl-shadow=\"6\" style=\"width:100%\">\n      <mdl-card-title>\n        <h2 mdl-card-title-text>Machine IDs</h2>\n      </mdl-card-title>\n\n      <mdl-list>\n        \n        <div *ngFor=\"let machine of machineSpecificationService.machineList\">\n        \n          <div *ngIf=\"machine!=edittingMachine\">\n            <mdl-list-item lines=\"3\">\n              <mdl-list-item-primary-content>\n                <!--<div (click)=\"editMachine(machine)\">-->\n                <div>\n                  <span>{{machine}}</span>\n                  <mdl-list-item-text-body>{{machineSpecificationService.returnMachineSpecification(machine).makeAndModel}}</mdl-list-item-text-body>\n                </div>\n              </mdl-list-item-primary-content>\n              <mdl-list-item-secondary-action>\n                <button\n                  mdl-button\n                  mdl-button-type=\"icon\"\n                  mdl-ripple\n                  [disabled]=\"machine==currentSettings.machine || edittingMachine!=null\"\n                  (click)=\"machineSpecificationService.changeMachine(machine)\"><mdl-icon>dashboard</mdl-icon>       \n                </button>\n                <!--<button\n                  mdl-button *ngIf=\"machine!=edittingMachine\"\n                  mdl-button-type=\"icon\"\n                  mdl-ripple\n                  [disabled]=\"false\"\n                  (click)=\"editMachine(machine)\"><mdl-icon>edit</mdl-icon>       \n                </button>-->\n              </mdl-list-item-secondary-action>\n            </mdl-list-item>\n\n          </div>\n\n          <div *ngIf=\"machine==edittingMachine\">\n            <mdl-list-item lines=\"3\">\n              <mdl-list-item-primary-content>\n                <mdl-textfield #machineIDTextField\n                  type=\"text\"\n                  label=\"Machine ID\"\n                  [value]=\"machine\"\n                  (keyup.enter)=\"finishMachineEdit(machine, machineIDTextField.value, modelTextField.value)\"\n                  floating-label\n                  style=\"display:inline;\"></mdl-textfield>\n                <mdl-textfield #modelTextField\n                  type=\"text\"\n                  label=\"Model\"\n                  [value]=\"machineSpecificationService.returnMachineSpecification(machine).makeAndModel\"\n                  (keyup.enter)=\"finishMachineEdit(machine, machineIDTextField.value, modelTextField.value)\"\n                  floating-label\n                  style=\"display:inline;\"></mdl-textfield>\n              </mdl-list-item-primary-content>\n\n              <mdl-list-item-secondary-action>\n                <!--<button\n                  mdl-button\n                  mdl-button-type=\"icon\"\n                  mdl-ripple\n                  [disabled]=\"machine!=edittingMachine\"\n                  (click)=\"deleteMachine(machine)\"><mdl-icon>delete</mdl-icon>       \n                </button>-->\n                <button\n                  mdl-button\n                  mdl-button-type=\"icon\"\n                  mdl-ripple\n                  [disabled]=\"true\"><mdl-icon>delete</mdl-icon>       \n                </button>\n                <button\n                  mdl-button\n                  mdl-button-type=\"icon\"\n                  mdl-ripple\n                  mdl-colored=\"primary\" \n                  [disabled]=\"machine==currentSettings.machine || edittingMachine!=null\"\n                  (click)=\"changeCurrentMachine(machine)\"><mdl-icon>dashboard</mdl-icon>       \n                </button>\n                <button\n                  mdl-button\n                  mdl-button-type=\"icon\"\n                  mdl-ripple\n                  [disabled]=\"false\"\n                  (click)=\"finishMachineEdit(machine, machineIDTextField.value, modelTextField.value)\"><mdl-icon>done</mdl-icon>       \n                </button>\n              </mdl-list-item-secondary-action>\n            </mdl-list-item>\n\n          </div>\n        </div>\n\n\n      </mdl-list>\n      <mdl-card-actions mdl-card-border>\n        <mdl-textfield\n          type=\"text\"\n          label=\"New Machine ID\"\n          [(ngModel)]=\"newMachineID\"\n          (input)=\"checkNewMachineIDInput()\"\n          (keyup.enter)=\"addMachineID()\"\n          floating-label\n          style=\"width:100%\"></mdl-textfield>\n        <mdl-textfield\n          type=\"text\"\n          label=\"Machine Make and Model\"\n          [(ngModel)]=\"newModel\"\n          (input)=\"checkNewModelInput()\"\n          angulartics2On=\"keyup.enter\" angularticsEvent=\"Specifications | Enter press | Add machine ID\"\n          (keyup.enter)=\"addMachineID()\"\n          floating-label\n          style=\"width:70%\"></mdl-textfield>\n        <button \n          [disabled]=\"!newMachineValid\"\n          mdl-button \n          mdl-button-type=\"mini-fab\"\n          mdl-ripple\n          angulartics2On=\"click\" angularticsEvent=\"Specifications | Button click | Add machine ID\"\n          (click)=\"addMachineID()\">\n          <mdl-icon>add</mdl-icon>\n        </button>\n      </mdl-card-actions>\n\n    </mdl-card>\n  </div>\n\n  <div *ngIf=\"edittingMachine==null && machineSpecificationService.currentSpecification != null && currentSettings != null\" class=\"mdl-cell mdl-cell--4-col mdl-cell--4-col-tablet mdl-cell--6-col-phone\">\n    <mdl-card mdl-shadow=\"6\"  style=\"width:100%\">\n      <mdl-card-title>\n        <h2 mdl-card-title-text>Energies for {{currentSettings.machine}}</h2>\n      </mdl-card-title>\n        <mdl-list>\n          <mdl-list-item *ngFor=\"let energy of machineSpecificationService.currentSpecification.energy\" lines=\"3\">\n            <mdl-list-item-primary-content>\n              <span>{{energy}} MeV</span>\n              <mdl-list-item-text-body>R50: {{machineSpecificationService.returnCurrentR50(energy)}} cm</mdl-list-item-text-body>\n            </mdl-list-item-primary-content>\n            <mdl-list-item-secondary-action>\n              <!--<button\n                mdl-button\n                mdl-button-type=\"icon\"\n                mdl-ripple\n                [disabled]=\"true\"\n                (click)=\"null\"><mdl-icon>done</mdl-icon>       \n              </button>\n              <button\n                mdl-button\n                mdl-button-type=\"icon\"\n                mdl-ripple\n                [disabled]=\"true\"\n                (click)=\"null\"><mdl-icon>edit</mdl-icon>       \n              </button>\n              <button\n                mdl-button\n                mdl-button-type=\"icon\"\n                mdl-ripple\n                [disabled]=\"true\"\n                (click)=\"null\"><mdl-icon>delete</mdl-icon>       \n              </button>-->\n            </mdl-list-item-secondary-action>\n          </mdl-list-item>\n        </mdl-list>\n\n      <mdl-card-actions mdl-card-border>\n        <mdl-textfield\n          type=\"text\"\n          label=\"New Energy (MeV)\"\n          [(ngModel)]=\"newEnergy\"\n          (input)=\"checkNewEnergyInput()\"\n          (keyup.enter)=\"addEnergy()\"\n          floating-label\n          style=\"width:100%\"></mdl-textfield>\n        <mdl-textfield\n          type=\"text\"\n          label=\"R50 for New Energy (cm)\"\n          [(ngModel)]=\"newR50\"\n          (input)=\"checkNewR50Input()\"\n          angulartics2On=\"keyup.enter\" angularticsEvent=\"Specifications | Enter press | Add energy\"\n          (keyup.enter)=\"addEnergy()\"\n          floating-label\n          style=\"width:70%\"></mdl-textfield>\n        <button \n          [disabled]=\"!newEnergySetValid\" \n          mdl-button \n          angulartics2On=\"click\" angularticsEvent=\"Specifications | Button click | Add energy\"\n          mdl-button-type=\"mini-fab\"\n          (click)=\"addEnergy()\">\n          <mdl-icon>add</mdl-icon>\n        </button>\n      </mdl-card-actions>\n    </mdl-card>\n  </div>\n\n  <div *ngIf=\"edittingMachine==null && machineSpecificationService.currentSpecification != null && currentSettings != null\" class=\"mdl-cell mdl-cell--4-col mdl-cell--4-col-tablet mdl-cell--6-col-phone\">\n    <mdl-card mdl-shadow=\"6\"  style=\"width:100%\">\n      <mdl-card-title>\n        <h2 mdl-card-title-text>Applicators for {{currentSettings.machine}}</h2>\n      </mdl-card-title>\n        <mdl-list>\n          <mdl-list-item *ngFor=\"let applicator of machineSpecificationService.currentSpecification.applicator\">\n            <mdl-list-item-primary-content>\n              <mdl-list-item-text-body>{{applicator}}</mdl-list-item-text-body>\n            </mdl-list-item-primary-content>\n            <mdl-list-item-secondary-action>\n              <!--<button\n                mdl-button\n                mdl-button-type=\"icon\"\n                mdl-ripple\n                [disabled]=\"true\"\n                (click)=\"null\"><mdl-icon>done</mdl-icon>       \n              </button>\n              <button\n                mdl-button\n                mdl-button-type=\"icon\"\n                mdl-ripple\n                [disabled]=\"true\"\n                (click)=\"null\"><mdl-icon>edit</mdl-icon>       \n              </button>\n              <button\n                mdl-button\n                mdl-button-type=\"icon\"\n                mdl-ripple\n                [disabled]=\"true\"\n                (click)=\"null\"><mdl-icon>delete</mdl-icon>       \n              </button>-->\n            </mdl-list-item-secondary-action>\n          </mdl-list-item>\n        </mdl-list>\n\n      <mdl-card-actions mdl-card-border>\n        <mdl-textfield\n          type=\"text\"\n          label=\"New Applicator\"\n          [(ngModel)]=\"newApplicator\"\n          (input)=\"checkNewApplicatorInput()\"\n          angulartics2On=\"keyup.enter\" angularticsEvent=\"Specifications | Enter press | Add applicator\"\n          (keyup.enter)=\"addApplicator()\"\n          floating-label\n          style=\"width:70%\"></mdl-textfield>\n        <button \n          [disabled]=\"!newApplicatorValid\" \n          mdl-button \n          angulartics2On=\"click\" angularticsEvent=\"Specifications | Button click | Add applicator\"\n          mdl-button-type=\"mini-fab\"\n          (click)=\"addApplicator()\">\n          <mdl-icon>add</mdl-icon>\n        </button>\n      </mdl-card-actions>\n    </mdl-card>\n  </div>\n\n  <div *ngIf=\"edittingMachine==null && machineSpecificationService.currentSpecification != null && currentSettings != null\" class=\"mdl-cell mdl-cell--4-col mdl-cell--4-col-tablet mdl-cell--6-col-phone\">\n    <mdl-card mdl-shadow=\"6\"  style=\"width:100%\">\n      <mdl-card-title>\n        <h2 mdl-card-title-text>SSDs for {{currentSettings.machine}}</h2>\n      </mdl-card-title>\n        <mdl-list>\n          <mdl-list-item *ngFor=\"let ssd of this.machineSpecificationService.currentSpecification.ssd\">\n            <mdl-list-item-primary-content>\n              <mdl-list-item-text-body>{{ssd}} cm</mdl-list-item-text-body>\n            </mdl-list-item-primary-content>\n            <mdl-list-item-secondary-action>\n              <!--<button\n                mdl-button\n                mdl-button-type=\"icon\"\n                mdl-ripple\n                [disabled]=\"true\"\n                (click)=\"null\"><mdl-icon>done</mdl-icon>       \n              </button>\n              <button\n                mdl-button\n                mdl-button-type=\"icon\"\n                mdl-ripple\n                [disabled]=\"true\"\n                (click)=\"null\"><mdl-icon>edit</mdl-icon>       \n              </button>\n              <button\n                mdl-button\n                mdl-button-type=\"icon\"\n                mdl-ripple\n                [disabled]=\"true\"\n                (click)=\"null\"><mdl-icon>delete</mdl-icon>       \n              </button>-->\n            </mdl-list-item-secondary-action>\n          </mdl-list-item>\n        </mdl-list>\n\n      <mdl-card-actions mdl-card-border>\n        <mdl-textfield\n          type=\"text\"\n          label=\"New SSD (cm)\"\n          [(ngModel)]=\"newSSD\"\n          (input)=\"checkNewSSDInput()\"\n          (keyup.enter)=\"addSSD()\"\n          angulartics2On=\"keyup.enter\" angularticsEvent=\"Specifications | Enter press | Add ssd\"\n          floating-label\n          style=\"width:70%\"></mdl-textfield>\n        <button \n          [disabled]=\"!newSSDValid\" \n          mdl-button \n          angulartics2On=\"click\" angularticsEvent=\"Specifications | Button click | Add ssd\"\n          mdl-button-type=\"mini-fab\"\n          (click)=\"addSSD()\">\n          <mdl-icon>add</mdl-icon>\n        </button>\n      </mdl-card-actions>\n    </mdl-card>\n  </div>\n\n\n  <!--<div class=\"mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\">\n    <h5>Raw specification data editing (optional)</h5>\n    <p>\n      If you desire you may edit the raw machine specifications in its raw format below. \n      Currently error checking on this raw input is not implemented.\n      Incorrectly editing the data below may cause the web app not to function.\n      Input data above to determine the data structure required.</p>\n    <my-json-edit\n      [input]=\"specifications\"\n      (inputUpdated)=\"changeSpecifications($event)\"\n      buttonText=\"Update Specifications\">\n    </my-json-edit>\n  </div>-->\n\n</div>\n\n";

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(41);
	var insert_data_1 = __webpack_require__(128);
	var title_service_1 = __webpack_require__(131);
	var data_persistence_service_1 = __webpack_require__(132);
	var js_yaml_1 = __webpack_require__(161);
	// declare var yaml: any;
	// declare var pypyjs: any;
	var DicomComponent = (function () {
	    function DicomComponent(myTitleService, dataPersistenceService, router) {
	        this.myTitleService = myTitleService;
	        this.dataPersistenceService = dataPersistenceService;
	        this.router = router;
	        this.dicomExitCode = 1;
	        this.reader = new FileReader();
	    }
	    DicomComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        window['dicomData'] = ' ';
	        window['dicomLoadStatus'] = 0;
	        this.reader.onload = function () { return _this.onceFileIsLoaded(); };
	        this.dataPersistenceService.loadDicomInsertList()
	            .then(function (result) {
	            _this.insertList = result;
	        });
	        Module.print = this.sendDicomDumpToGlobalVariable;
	        this.myTitleService.setTitle('Dicom');
	        // pypyjs.exec("import json; print json.dumps({'hello': 'world'})")
	        // pypyjs.exec("import dicom; print json.dumps({'hello': 'world'})")
	    };
	    DicomComponent.prototype.sendDicomDumpToGlobalVariable = function (print) {
	        window['dicomData'] = window['dicomData'] + '\n' + print;
	    };
	    DicomComponent.prototype.updateDicomWarning = function () {
	        var status = Number(window['dicomLoadStatus']);
	        if (status == 0) {
	            this.getBlockDataButton.disabled = false;
	            this.dicomWarning = null;
	        }
	        else {
	            this.getBlockDataButton.disabled = true;
	            this.dicomWarning = 'An error occured while trying to find the block data within the provided Dicom file.';
	        }
	    };
	    DicomComponent.prototype.onceFileIsLoaded = function () {
	        var content = new Int8Array(this.reader.result);
	        console.log(content.length);
	        var fileName = 'dicomfile';
	        if (FS.isFile(fileName)) {
	            FS.unlink(fileName);
	        }
	        FS.writeFile(fileName, content, { encoding: "binary" });
	        var exit_orig = Module.exit;
	        Module.exit = function (status) {
	            window['dicomLoadStatus'] = status;
	            exit_orig(status);
	        };
	        Module.callMain(['dcmdump', fileName, '--print-all']);
	        Module.exit = exit_orig;
	        console.log(Module);
	        this.updateDicomWarning();
	        FS.unlink(fileName);
	    };
	    DicomComponent.prototype.openFile = function (event) {
	        if (typeof event.target !== 'undefined') {
	            console.log(event.target.files);
	            var file = event.target.files[0];
	            window['dicomData'] = ' ';
	            this.reader.readAsArrayBuffer(file);
	        }
	        else {
	            console.log(event);
	        }
	    };
	    DicomComponent.prototype.convertDicomDumpToDict = function (dump) {
	        // console.log(dump)
	        var yamlConvert = dump.replace(/\s*#[^#\n]*\n/g, '\n');
	        yamlConvert = yamlConvert.replace(/\s*#[^#\n]*$/g, '');
	        yamlConvert = yamlConvert.replace(/^\n*/, '');
	        yamlConvert = yamlConvert.replace(/(\([0-9a-f][0-9a-f][0-9a-f][0-9a-f],[0-9a-f][0-9a-f][0-9a-f][0-9a-f]\))/g, '$1:');
	        yamlConvert = yamlConvert.replace(/(\([0-9a-f][0-9a-f][0-9a-f][0-9a-f],[0-9a-f][0-9a-f][0-9a-f][0-9a-f]\):) SQ \(Sequence with \w+ length #=\d+\)/g, '$1');
	        yamlConvert = yamlConvert.replace(/(\([0-9a-f][0-9a-f][0-9a-f][0-9a-f],[0-9a-f][0-9a-f][0-9a-f][0-9a-f]\):) na \(Item with \w+ length #=\d+\)/g, '$1');
	        yamlConvert = yamlConvert.replace(/ *\(fffe,e00d\): na \(ItemDelimitationItem[ \w-]*\) *\n/g, '');
	        yamlConvert = yamlConvert.replace(/ *\(fffe,e0dd\): na \(SequenceDelimitationItem[ \w-\.]*\) *\n/g, '');
	        yamlConvert = yamlConvert.replace(/(\([0-9a-f][0-9a-f][0-9a-f][0-9a-f],[0-9a-f][0-9a-f][0-9a-f][0-9a-f]\):) (.*)/g, '$1 "$2"');
	        yamlConvert = yamlConvert.replace(/\\/g, ', ');
	        yamlConvert = yamlConvert.replace(/\(fffe,e000\):/g, ' - ');
	        yamlConvert = js_yaml_1.safeLoad(yamlConvert);
	        return yamlConvert;
	    };
	    DicomComponent.prototype.convertBlockDataToCoords = function (blockData) {
	        var listString = /\[[, \d\.-]*\]/.exec(blockData).toString();
	        var parsedData = JSON.parse('{ "data": ' + listString + '}');
	        var x = [];
	        var y = [];
	        var i = 0;
	        for (var _i = 0, _a = parsedData['data']; _i < _a.length; _i++) {
	            var num = _a[_i];
	            if (i % 2 == 0) {
	                x.push(parseFloat((num / 10).toFixed(2)));
	            }
	            else {
	                y.push(parseFloat((num / 10).toFixed(2)));
	            }
	            i++;
	        }
	        var insert = {
	            x: x,
	            y: y
	        };
	        return insert;
	    };
	    DicomComponent.prototype.dicomPullNumber = function (input) {
	        return Number(input.replace(/.*\[([\d\.-]*)\].*/, "$1"));
	    };
	    DicomComponent.prototype.dicomPullString = function (input) {
	        return input.replace(/.*\[(.*)\].*/, "$1");
	    };
	    DicomComponent.prototype.getBlockData = function () {
	        var _this = this;
	        var dicomPrint = window['dicomData'];
	        var dicomDict = this.convertDicomDumpToDict(dicomPrint);
	        // console.log(dicomDict)
	        var i = 0;
	        this.insertList = [];
	        var promiseList = [];
	        var beamSequence = dicomDict["(300a,00b0)"];
	        for (var _i = 0, beamSequence_1 = beamSequence; _i < beamSequence_1.length; _i++) {
	            var beam = beamSequence_1[_i];
	            var temp = beam["(300a,00f4)"];
	            if (temp != undefined) {
	                var insertData = new insert_data_1.InsertData();
	                insertData.id = i;
	                i++;
	                var blockData = beam["(300a,00f4)"][0]["(300a,0106)"];
	                insertData.parameterisation.insert = this.convertBlockDataToCoords(blockData);
	                insertData.parameterisation.insertUpdated();
	                promiseList.push(this.dataPersistenceService.loadParameterisationCache(insertData.parameterisation));
	                try {
	                    insertData.applicator = this.dicomPullString(beam["(300a,0107)"][0]["(300a,0108)"]).toLowerCase();
	                }
	                catch (err) {
	                    insertData.applicator = null;
	                    console.log(err);
	                }
	                try {
	                    insertData.energy = this.dicomPullNumber(beam["(300a,0111)"][0]["(300a,0114)"]);
	                }
	                catch (err) {
	                    insertData.energy = null;
	                    console.log(err);
	                }
	                try {
	                    insertData.ssd = this.dicomPullNumber(beam["(300a,0111)"][0]["(300a,0130)"]) / 10;
	                }
	                catch (err) {
	                    insertData.ssd = null;
	                    console.log(err);
	                }
	                try {
	                    insertData.machine = this.dicomPullString(beam["(300a,00b2)"]);
	                }
	                catch (err) {
	                    insertData.machine = null;
	                    console.log(err);
	                }
	                this.insertList.push(insertData);
	            }
	        }
	        Promise.all(promiseList)
	            .then(function () {
	            _this.dataPersistenceService.saveDicomInsertList(_this.insertList);
	        });
	    };
	    DicomComponent.prototype.sendToParameterisation = function (insertData) {
	        var _this = this;
	        insertData.id = 0;
	        this.dataPersistenceService.saveCurrentInsertData(insertData)
	            .then(function () {
	            _this.router.navigate(["/parameterise"]);
	        });
	    };
	    __decorate([
	        core_1.ViewChild('dicomOutput'), 
	        __metadata('design:type', Object)
	    ], DicomComponent.prototype, "dicomOutputDir", void 0);
	    __decorate([
	        core_1.ViewChild('getBlockDataButton'), 
	        __metadata('design:type', Object)
	    ], DicomComponent.prototype, "getBlockDataButton", void 0);
	    DicomComponent = __decorate([
	        core_1.Component({
	            selector: 'my-dicom',
	            template: __webpack_require__(196),
	            styles: ['./dicom.component.css']
	        }), 
	        __metadata('design:paramtypes', [title_service_1.TitleService, data_persistence_service_1.DataPersistenceService, router_1.Router])
	    ], DicomComponent);
	    return DicomComponent;
	}());
	exports.DicomComponent = DicomComponent;


/***/ },
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mdl-grid\">\n  <div class=\"mdl-cell mdl-cell--12-col\">\n    <h5>Locally reading Dicom patient plan files</h5>\n    <p>\n      Use this component to read a dicom patient plan file and extract the electron insert shape. \n      Export a dicom patient plan file that containts an electron plan from your planning system then open it using the file input box below.\n    </p>\n    <p>\n      For testing purposes you can download a demo dicom file from <a href=\"webapp/30x16x30_RandomElectronShapes.dcm\">here</a>.\n    </p>\n    <p>\n      This has currently been tested with Dicom files exported from Monaco and Pinnacle. \n      If you find this doesn't work with Dicom files from your TPS please produce a dummy plan that contains at least two electron beams and one photon beam and email it to me at <a href=\"mailto:mail@simonbiggs.net\">mail@simonbiggs.net</a> so that I can implement importing from that Dicom header structure.\n    </p>\n  </div>\n\n  <div class=\"mdl-cell mdl-cell--6-col\">\n    <input type='file' (change)='openFile($event)'>\n    <div *ngIf=\"dicomWarning\">{{dicomWarning}}</div>\n  </div>\n\n  <div class=\"mdl-cell mdl-cell--6-col\">\n    <button #getBlockDataButton\n      mdl-button mdl-button-type=\"raised\" \n      mdl-colored=\"primary\" \n      mdl-ripple\n      [disabled]=\"true\"\n      (click)=\"getBlockData()\">Get Dicom Insert Data\n    </button>\n\n    \n  </div>\n\n  <div *ngFor=\"let insertData of insertList\" class=\"mdl-cell mdl-cell--6-col\">\n    <mdl-card mdl-shadow=\"6\">\n      <my-send-to-parameterisation\n        [insertData]=insertData>\n      </my-send-to-parameterisation>\n\n      <mdl-card-actions mdl-card-border>\n        <button\n          mdl-button \n          mdl-ripple\n          (click)=\"sendToParameterisation(insertData)\">Send to parameterisation           \n        </button>\n      </mdl-card-actions>\n    </mdl-card>\n    \n\n\n    <!--<p>{{insert | json}}</p>-->\n  </div>\n\n  <div class=\"mdl-cell mdl-cell--12-col\">\n    <h5>Further information</h5>\n    <p>This Dicom loader does not send the Dicom file off to a server. The entire reading of the dicom file is done within javascript.\n    You can confirm this yourself by using the chrome web browser, pressing 'Ctrl + Shift + I'\n    and then clicking on the network tab. When the file is chosen, then the block data is pulled and sent to parameterisation,\n    at no point in this interaction is there network traffic.</p>\n\n    <p>The only data that will be sent to the server will be on either the paremeterisation tab or the model tab, and this data will\n      just consist of x and y coordinates or widths, lengths, and factors.\n    </p>\n  </div>\n</div>";

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var title_service_1 = __webpack_require__(131);
	var FurtherDetailsComponent = (function () {
	    function FurtherDetailsComponent(myTitleService) {
	        this.myTitleService = myTitleService;
	    }
	    FurtherDetailsComponent.prototype.ngOnInit = function () {
	        this.myTitleService.setTitle('Further Details');
	    };
	    FurtherDetailsComponent = __decorate([
	        core_1.Component({
	            selector: 'my-further-details',
	            template: __webpack_require__(198)
	        }), 
	        __metadata('design:paramtypes', [title_service_1.TitleService])
	    ], FurtherDetailsComponent);
	    return FurtherDetailsComponent;
	}());
	exports.FurtherDetailsComponent = FurtherDetailsComponent;


/***/ },
/* 198 */
/***/ function(module, exports) {

	module.exports = "<div itemscope itemtype=\"http://schema.org/SoftwareApplication\" class=\"mdl-grid\">\n  <div class=\"mdl-cell mdl-cell--6-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\">\n    <h3 itemprop=\"name\">Electron insert factor modelling</h3>\n    <p>\n      Tags: <span itemprop=\"applicationCategory\">Medical physics, electron inserts, electron cutouts, Python, Angular2, Bokeh, spline modelling</span><br>\n      Last update: <span itemprop=\"datePublished\" content=\"2016-10-18\">2016-11-13</span><br>\n      Version: <span itemprop=\"softwareVersion\">0.2.6-beta</span><br>\n      Operating systems: <span itemprop=\"operatingSystem\">Windows, Linux, Mac, Android, and iOS</span> <br>\n      Requirements: <span itemprop=\"requirements\">A browser such as <a href=\"https://www.google.com.au/chrome/browser\">Chrome</a> that supports <a href=\"http://caniuse.com/#feat=indexeddb\">IndexedDB</a> browser database</span><br>\n      Developed by: <span itemprop=\"author\" itemscope itemtype=\"http://schema.org/Person\"><a itemprop=\"name\" href=\"https://github.com/SimonBiggs\">Simon Biggs</a></span>\n    </p>\n\n    <h4>Change logs</h4>\n    <p><a href=\"https://github.com/SimonBiggs/electronfactor-server/commits/master\">Server change logs</a>. <a href=\"https://github.com/SimonBiggs/electroninserts-webapp/commits/master\">Web app change logs</a>.</p>\n\n    <h4>Disclaimer</h4>\n    <p>\n      Any use of this web app or any of its code has you accepting the AGPL3+ license which includes <b>no warranty</b> that this code is <b>fit for a particular purpose</b>. Attempts have been made to make the code transparent and it is recommended that an experienced python programmer and physicist who understands the procedure outlined in the paper and the requirements of your centre identifies whether or not this method and code is fit for your use.</p>\n\n    <h4>Use of Google Analytics</h4>\n    <p>\n      To aid in quickly identifying bugs, user experience issues, and documenting app usage the Google Analytics service is employed. \n      This collates and reports page views, button clicks, and demographic information based upon your IP address.\n      For more information on privacy regarding Google Analytics <a href=\"https://support.google.com/analytics/answer/6004245\">click here.</a>\n      If you wish to opt-out of Google Analytics data collection please <a href=\"https://tools.google.com/dlpage/gaoptout\">click here.</a>\n    </p>   \n\n\n    <h4>(Optional) Download this web app and run it locally</h4>\n      The following commands will set up this web app to work on a fresh install of <a href=\"http://releases.ubuntu.com/16.04/\">Ubuntu 16.04</a>:\n      <div style=\"overflow: auto\" id=\"locally\">\n        <pre><code class=\"bash\">sudo apt install git wget\ngit clone --recursive \\\n    https://github.com/SimonBiggs/electroninserts-webapp.git \\\n    --branch gh-pages\ncd electroninserts-webapp\n\nwget \\\n    https://goo.gl/poeKlL \\\n    -O miniconda.sh\nchmod +x miniconda.sh\n./miniconda.sh -p $HOME/miniconda\nexport PATH=$HOME/miniconda/bin:$PATH\n\nconda update conda\nconda env create \\\n    --name electroninserts python=3.5 \\\n    --file ./server/electronfactor-server/conda-requirements.txt\nsource activate electroninserts\n\npython run_webapp_locally.py</code></pre>\n      </div>\n\n      At that point you will be able to access the web app locally at http://localhost:8000.\n      Make sure the model and parameterisation servers point to http://localhost:5000/model, and http://localhost:5000/parameterise respectively.\n      You may also replace \"localhost\" with your IP to access this webapp from other computers on your network.\n\n  </div>\n  <div class=\"mdl-cell mdl-cell--6-col mdl-cell--8-col-tablet mdl-cell--6-col-phone\">\n\n    <h4>Source code</h4>\n    <p>\n      For the purpose of coding transparency and to enable the user to take responsibility for the code themselves any redistribution\n      or derivative works of this web app need to include the source code of any additions made and need to include a way\n      for users to easily access the source code of each of the components used or linked to.\n    </p>\n\n    <h5>Server Code</h5>\n\n    <h6>Base Electron Insert Factor Source Code</h6>\n    <p>\n      The python file which does the shape parameterisation and insert factor modelling which is used by the server is found here:\n      <a href=\"https://github.com/SimonBiggs/electronfactor-server/blob/master/electroninserts.py\">\n              https://github.com/SimonBiggs/electronfactor-server/blob/master/electroninserts.py</a>\n    </p>\n\n    <h6>Tornado REST API</h6>\n    <p>\n      The Tornado REST API is found here:\n      <a href=\"https://github.com/SimonBiggs/electronfactor-server/blob/master/main.py\">\n              https://github.com/SimonBiggs/electronfactor-server/blob/master/main.py</a>\n    </p>\n\n    <h6>Heroku App code</h6>\n    <p>\n      The code to make the heroku app is found here:\n      <a href=\"https://github.com/SimonBiggs/electronfactor-server\">\n              https://github.com/SimonBiggs/electronfactor-server</a>\n    </p>\n\n    <h5>Web App Code</h5>\n    <p>\n      The source code for this web app is found here:\n      <a itemprop=\"downloadUrl\" href=\"https://github.com/SimonBiggs/electroninserts-webapp\">\n            https://github.com/SimonBiggs/electroninserts-webapp</a>\n    </p>\n\n    <h5>Libraries used</h5>\n    <h6>Bokehjs</h6>\n    <p>\n      The bokehjs library is used for plots. Documentation can be found here:\n      <a href=\"http://bokeh.pydata.org/en/latest/docs/user_guide/bokehjs.html#userguide-bokehjs\">\n              http://bokeh.pydata.org/en/latest/docs/user_guide/bokehjs.html#userguide-bokehjs</a>\n    </p>\n    <p>\n      Source code can be found here:\n      <a href=\"https://github.com/bokeh/bokeh/tree/master/bokehjs\">\n              https://github.com/bokeh/bokeh/tree/master/bokehjs</a>\n    </p>\n\n    <h6>dcmjs</h6>\n    <p>\n      The dcmjs library is used for reading dicom files within javascript. Website can be found here:\n      <a href=\"http://dcmjs.org/\">\n              http://dcmjs.org/</a>\n    </p>\n    <p>\n      Source code can be found here:\n      <a href=\"https://github.com/commontk/dcmjs\">\n              https://github.com/commontk/dcmjs</a>\n    </p>\n\n    <h6>Angular2</h6>\n    <p>\n      This interface was built using Angular2. Documentation can be found here:\n      <a href=\"https://angular.io/docs/ts/latest/\">\n              https://angular.io/docs/ts/latest/</a>\n    </p>\n    <p>\n      Source code can be found here:\n      <a href=\"https://github.com/angular/angular\">\n              https://github.com/angular/angular</a>\n    </p>\n\n    <h6>Dexiejs</h6>\n    <p>\n      The browser database was interfaced with using Dexiejs. Documentation can be found here:\n      <a href=\"https://github.com/dfahlander/Dexie.js/wiki/API%20Reference\">\n              https://github.com/dfahlander/Dexie.js/wiki/API%20Reference</a>\n    </p>\n    <p>\n      Source code can be found here:\n      <a href=\"https://github.com/dfahlander/Dexie.js\">\n              https://github.com/dfahlander/Dexie.js</a>\n    </p>\n    <h6>Remaining libraries</h6>\n    <p>\n      For all remaining libraries used please see the npm package.json file:\n      <a href=\"https://github.com/SimonBiggs/electroninserts-webapp/blob/master/package.json\">\n              https://github.com/SimonBiggs/electroninserts-webapp/blob/master/package.json</a>\n    </p>\n    <p>\n      And the index file for various imports:\n      <a href=\"https://github.com/SimonBiggs/electroninserts-webapp/blob/master/src/public/index.html\">\n              https://github.com/SimonBiggs/electroninserts-webapp/blob/master/src/public/index.html</a>\n    </p>\n  </div>\n\n\n</div>";

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(41);
	var platform_browser_1 = __webpack_require__(21);
	var angulartics2_1 = __webpack_require__(69);
	var angulartics2_google_analytics_1 = __webpack_require__(29);
	var electron_api_service_1 = __webpack_require__(129);
	var title_service_1 = __webpack_require__(131);
	var AppComponent = (function () {
	    function AppComponent(electronApiService, myTitleService, router, title, angulartics2, angulartics2GoogleAnalytics) {
	        var _this = this;
	        this.electronApiService = electronApiService;
	        this.myTitleService = myTitleService;
	        this.router = router;
	        this.title = title;
	        router.events
	            .filter(function (event) { return event instanceof router_1.NavigationEnd; })
	            .subscribe(function () {
	            _this.pageTitle = _this.myTitleService.getTitle();
	            _this.title.setTitle(_this.myTitleService.getTitle() +
	                ' | Electron Insert Factor Modelling');
	        });
	    }
	    AppComponent.prototype.ngOnInit = function () {
	        var redirect = sessionStorage['redirect'];
	        delete sessionStorage['redirect'];
	        if (redirect && redirect != location.href) {
	            history.replaceState(null, null, redirect);
	            this.router.navigate([redirect]);
	        }
	        this.electronApiService.wakeUpServer();
	        this.pageTitle = this.myTitleService.getTitle();
	        this.title.setTitle(this.myTitleService.getTitle() +
	            ' | Electron Insert Factor Modelling');
	    };
	    AppComponent = __decorate([
	        core_1.Component({
	            selector: 'my-app',
	            template: __webpack_require__(200),
	        }), 
	        __metadata('design:paramtypes', [electron_api_service_1.ElectronApiService, title_service_1.TitleService, router_1.Router, platform_browser_1.Title, angulartics2_1.Angulartics2, angulartics2_google_analytics_1.Angulartics2GoogleAnalytics])
	    ], AppComponent);
	    return AppComponent;
	}());
	exports.AppComponent = AppComponent;


/***/ },
/* 200 */
/***/ function(module, exports) {

	module.exports = "\n<!--<md-sidenav-layout>\n\n  <md-sidenav #sidenav mode=\"side\" class=\"app-sidenav\">\n    <nav class=\"mdl-navigation\">\n      <a class=\"mdl-navigation__link\" routerLink=\"/home\" routerLinkActive=\"active\" href>Home</a>\n      <a class=\"mdl-navigation__link\" routerLink=\"/export-import\" routerLinkActive=\"active\" href>Export / Import</a>\n      <a class=\"mdl-navigation__link\" routerLink=\"/specifications\" routerLinkActive=\"active\" href>Machine specifications</a>\n      <a class=\"mdl-navigation__link\" routerLink=\"/dicom\" routerLinkActive=\"active\" href>Dicom shape extraction</a>\n      <a class=\"mdl-navigation__link\" routerLink=\"/parameterise\" routerLinkActive=\"active\" href>Parameterise inserts</a>\n      <a class=\"mdl-navigation__link\" routerLink=\"/model\" routerLinkActive=\"active\" href>Model insert factors</a>\n    </nav>\n  </md-sidenav>\n\n  <md-toolbar color=\"primary\">\n    <button class=\"app-icon-button\" (click)=\"sidenav.toggle()\">\n      <i class=\"material-icons app-toolbar-menu\">menu</i>\n    </button>\n\n    {{pageTitle}}\n\n    <span class=\"app-toolbar-filler\"></span>\n    <button md-button (click)=\"isDarkTheme = !isDarkTheme\">TOGGLE DARK THEME</button>\n  </md-toolbar>\n\n  <div class=\"app-content\">\n    <router-outlet></router-outlet>\n  </div>\n\n\n</md-sidenav-layout>-->\n\n\n<mdl-layout mdl-layout-fixed-drawer mdl-layout-fixed-header>\n  <mdl-layout-header>\n    <mdl-layout-header-row>\n      <mdl-layout-title>{{pageTitle}}</mdl-layout-title>\n    </mdl-layout-header-row>\n  </mdl-layout-header>\n  <mdl-layout-drawer>\n    <mdl-layout-title>Electron Factors</mdl-layout-title>\n    <nav class=\"mdl-navigation\">\n      <a class=\"mdl-navigation__link\" routerLink=\"/home\" routerLinkActive=\"active\" href>Home</a>\n      <a class=\"mdl-navigation__link\" routerLink=\"/details\" routerLinkActive=\"active\" href>Further details</a>\n      <a class=\"mdl-navigation__link\" routerLink=\"/specifications\" routerLinkActive=\"active\" href>Machine specifications</a>\n      <a class=\"mdl-navigation__link\" routerLink=\"/dicom\" routerLinkActive=\"active\" href>Dicom shape extraction</a>\n      <a class=\"mdl-navigation__link\" routerLink=\"/parameterise\" routerLinkActive=\"active\" href>Parameterise inserts</a>\n      <a class=\"mdl-navigation__link\" routerLink=\"/create-model\" routerLinkActive=\"active\" href>Create electron model</a>\n      <a class=\"mdl-navigation__link\" routerLink=\"/use-model\" routerLinkActive=\"active\" href>Use electron model</a>\n      <a class=\"mdl-navigation__link\" routerLink=\"/database\" routerLinkActive=\"active\" href>Database management</a>\n    </nav>\n  </mdl-layout-drawer>\n  <mdl-layout-content>\n\n    <router-outlet></router-outlet>\n\n  </mdl-layout-content>\n</mdl-layout>";

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var insert_data_1 = __webpack_require__(128);
	var PlotComponent = (function () {
	    function PlotComponent() {
	        this.insert_x = null;
	        this.insert_y = null;
	        this.circle = null;
	        this.ellipse = null;
	        this.enabled = true;
	        this.plot_width = 300;
	        this.plot_height = 300;
	        this.jsonValid = true;
	        this.plt = Bokeh.Plotting;
	        this.tools = 'pan,crosshair,wheel_zoom,box_zoom,reset,save';
	        this.xrange = Bokeh.Range1d(-6, 6);
	        this.yrange = Bokeh.Range1d(-6, 6);
	        this.fig = this.plt.figure({
	            title: 'Electron Insert Plot', tools: this.tools,
	            x_range: this.xrange, y_range: this.yrange,
	            plot_width: 300, plot_height: 300
	        });
	        this.source = new Bokeh.ColumnDataSource();
	        this.doc = new Bokeh.Document();
	    }
	    PlotComponent.prototype.ngOnChanges = function () {
	        this.jsonValid = false;
	        this.tempSource = {
	            "xs": [[0], [0], [0]],
	            "ys": [[0], [0], [0]],
	            "colour": ["navy", "firebrick", "green"]
	        };
	        var xAll = [];
	        var yAll = [];
	        if (this.enabled) {
	            if (this.insert_x != null && this.insert_y != null) {
	                this.tempSource.xs[0] = this.insert_x.concat(this.insert_x[0]);
	                this.tempSource.ys[0] = this.insert_y.concat(this.insert_y[0]);
	                xAll = xAll.concat(this.tempSource.xs[0]);
	                yAll = yAll.concat(this.tempSource.ys[0]);
	            }
	            if (this.circle) {
	                if ('x' in this.circle && 'y' in this.circle) {
	                    this.tempSource.xs[1] = this.circle.x;
	                    this.tempSource.ys[1] = this.circle.y;
	                    xAll = xAll.concat(this.tempSource.xs[1]);
	                    yAll = yAll.concat(this.tempSource.ys[1]);
	                }
	            }
	            if (this.ellipse) {
	                if ('x' in this.ellipse && 'y' in this.ellipse) {
	                    this.tempSource.xs[2] = this.ellipse.x;
	                    this.tempSource.ys[2] = this.ellipse.y;
	                    xAll = xAll.concat(this.tempSource.xs[2]);
	                    yAll = yAll.concat(this.tempSource.ys[2]);
	                }
	            }
	        }
	        var xMax = Math.max.apply(Math, xAll);
	        var xMin = Math.min.apply(Math, xAll);
	        var yMax = Math.max.apply(Math, yAll);
	        var yMin = Math.min.apply(Math, yAll);
	        var range = Math.max(xMax - xMin, yMax - yMin) * 1.1;
	        var sqXMax = (xMax + xMin) / 2 + range / 2;
	        var sqXMin = (xMax + xMin) / 2 - range / 2;
	        var sqYMax = (yMax + yMin) / 2 + range / 2;
	        var sqYMin = (yMax + yMin) / 2 - range / 2;
	        this.fig.attributes.x_range.start = sqXMin;
	        this.fig.attributes.x_range.end = sqXMax;
	        this.fig.attributes.y_range.start = sqYMin;
	        this.fig.attributes.y_range.end = sqYMax;
	        // this.fig.update_range();
	        // console.log(this.fig);
	        this.source.data = this.tempSource;
	    };
	    PlotComponent.prototype.ngAfterViewInit = function () {
	        // this.ngOnChanges();
	        this.fig.multi_line({ field: 'xs' }, { field: 'ys' }, {
	            source: this.source,
	            line_width: 2,
	            color: { field: 'colour' }
	        });
	        this.doc.add_root(this.fig);
	        Bokeh.embed.add_document_standalone(this.doc, this.bokehplot.nativeElement);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], PlotComponent.prototype, "insert_x", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], PlotComponent.prototype, "insert_y", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', insert_data_1.Coordinates)
	    ], PlotComponent.prototype, "circle", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', insert_data_1.Coordinates)
	    ], PlotComponent.prototype, "ellipse", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], PlotComponent.prototype, "enabled", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], PlotComponent.prototype, "plot_width", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], PlotComponent.prototype, "plot_height", void 0);
	    __decorate([
	        core_1.ViewChild('bokehplot'), 
	        __metadata('design:type', Object)
	    ], PlotComponent.prototype, "bokehplot", void 0);
	    PlotComponent = __decorate([
	        core_1.Component({
	            selector: 'my-plot',
	            template: __webpack_require__(202)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PlotComponent);
	    return PlotComponent;
	}());
	exports.PlotComponent = PlotComponent;


/***/ },
/* 202 */
/***/ function(module, exports) {

	module.exports = "<div \n    class=\"bk-root\" \n    [style.width]=\"plot_width + 'px'\" \n    [style.height]=\"plot_height + 'px'\">\n  <div #bokehplot></div>\n</div>\n";

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var bokeh_pcolour_1 = __webpack_require__(204);
	var BokehCreateModelComponent = (function (_super) {
	    __extends(BokehCreateModelComponent, _super);
	    function BokehCreateModelComponent() {
	        _super.apply(this, arguments);
	        this.title = "Figure Title";
	        this.plot_width = 300;
	        this.plot_height = 300;
	        this.scatter_z = [0.5];
	        this.enabled = true;
	    }
	    BokehCreateModelComponent.prototype.ngOnChanges = function () {
	        this.updateHoverData();
	        this.runAllUpdates();
	    };
	    BokehCreateModelComponent.prototype.updateHoverData = function () {
	        if (this.pcolour_data.x != this.pcolour_x) {
	            this.pcolour_hover_width = [];
	            for (var _i = 0, _a = this.pcolour_x; _i < _a.length; _i++) {
	                var x = _a[_i];
	                this.pcolour_hover_width.push(x.toFixed(1));
	            }
	        }
	        if (this.pcolour_data.y != this.pcolour_y) {
	            this.pcolour_hover_length = [];
	            for (var _b = 0, _c = this.pcolour_y; _b < _c.length; _b++) {
	                var y = _c[_b];
	                this.pcolour_hover_length.push(y.toFixed(1));
	            }
	        }
	        if (this.pcolour_data.z != this.pcolour_z) {
	            this.pcolour_hover_predicted_factor = [];
	            for (var _d = 0, _e = this.pcolour_z; _d < _e.length; _d++) {
	                var z = _e[_d];
	                this.pcolour_hover_predicted_factor.push((Math.round(z * 1000) / 1000).toFixed(3));
	            }
	        }
	    };
	    BokehCreateModelComponent.prototype.ngAfterViewInit = function () {
	        var hover_tool = new Bokeh.HoverTool({
	            tooltips: [
	                ["Width", " @hover_width cm"],
	                ["Length", " @hover_length cm"],
	                ["Predicted Factor", " @hover_predicted_factor"]
	            ],
	            renderers: [
	                this.pcolour_renderer
	            ]
	        });
	        this.fig.add_tools(hover_tool);
	        this.doc.add_root(this.fig);
	        Bokeh.embed.add_document_standalone(this.doc, this.bokehplot.nativeElement);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], BokehCreateModelComponent.prototype, "title", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], BokehCreateModelComponent.prototype, "plot_width", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], BokehCreateModelComponent.prototype, "plot_height", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BokehCreateModelComponent.prototype, "scatter_x", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BokehCreateModelComponent.prototype, "scatter_y", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BokehCreateModelComponent.prototype, "scatter_z", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BokehCreateModelComponent.prototype, "pcolour_x", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BokehCreateModelComponent.prototype, "pcolour_y", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BokehCreateModelComponent.prototype, "pcolour_z", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], BokehCreateModelComponent.prototype, "enabled", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BokehCreateModelComponent.prototype, "selectionList", void 0);
	    __decorate([
	        core_1.ViewChild('bokehplot'), 
	        __metadata('design:type', Object)
	    ], BokehCreateModelComponent.prototype, "bokehplot", void 0);
	    BokehCreateModelComponent = __decorate([
	        core_1.Component({
	            selector: 'my-bokeh-create-model',
	            template: __webpack_require__(202)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], BokehCreateModelComponent);
	    return BokehCreateModelComponent;
	}(bokeh_pcolour_1.BokehPcolour));
	exports.BokehCreateModelComponent = BokehCreateModelComponent;


/***/ },
/* 204 */
/***/ function(module, exports) {

	"use strict";
	var BokehPcolour = (function () {
	    function BokehPcolour() {
	        this.title = "Figure Title";
	        this.plot_width = 300;
	        this.plot_height = 300;
	        this.scatter_z = [0.5];
	        this.enabled = true;
	        this.scatter_edge_colour = 'black';
	        this.pcolour_hover_width = [];
	        this.pcolour_hover_length = [];
	        this.pcolour_hover_predicted_factor = [];
	        this.scatter_hover_width = [];
	        this.scatter_hover_length = [];
	        this.scatter_hover_area = [];
	        this.scatter_hover_measured_factor = [];
	        this.scatter_hover_predicted_factor = [];
	        this.plt = Bokeh.Plotting;
	        this.tools = 'pan,crosshair,wheel_zoom,box_zoom,reset,save';
	        this.old_scatter_z = [];
	        this.old_pcolour_z = [];
	        this.scatter_c = [];
	        this.pcolour_c = [];
	        this.scatter_data = {
	            x: [],
	            y: [],
	            hover_width: [],
	            hover_length: [],
	            hover_area: [],
	            hover_measured_factor: [],
	            hover_predicted_factor: [],
	            c: [],
	            edge_colour: 'black'
	        };
	        this.scatter_source = new Bokeh.ColumnDataSource({
	            data: this.scatter_data
	        });
	        this.pcolour_data = {
	            x: [],
	            y: [],
	            z: [],
	            hover_width: [],
	            hover_length: [],
	            hover_predicted_factor: [],
	            c: []
	        };
	        this.pcolour_source = new Bokeh.ColumnDataSource({
	            data: this.pcolour_data
	        });
	        this.doc = new Bokeh.Document();
	        this.viridis_hex = [
	            "#440154", "#440256", "#450457", "#450559", "#46075a", "#46085c", "#460a5d", "#460b5e", "#470d60", "#470e61", "#471063", "#471164", "#471365", "#481467", "#481668", "#481769", "#48186a", "#481a6c", "#481b6d", "#481c6e", "#481d6f", "#481f70", "#482071", "#482173", "#482374", "#482475", "#482576", "#482677", "#482878", "#482979", "#472a7a", "#472c7a", "#472d7b", "#472e7c", "#472f7d", "#46307e", "#46327e", "#46337f", "#463480", "#453581", "#453781", "#453882", "#443983", "#443a83", "#443b84", "#433d84", "#433e85", "#423f85", "#424086", "#424186", "#414287", "#414487", "#404588", "#404688", "#3f4788", "#3f4889", "#3e4989", "#3e4a89", "#3e4c8a", "#3d4d8a", "#3d4e8a", "#3c4f8a", "#3c508b", "#3b518b", "#3b528b", "#3a538b", "#3a548c", "#39558c", "#39568c", "#38588c", "#38598c", "#375a8c", "#375b8d", "#365c8d", "#365d8d", "#355e8d", "#355f8d", "#34608d", "#34618d", "#33628d", "#33638d", "#32648e", "#32658e", "#31668e", "#31678e", "#31688e", "#30698e", "#306a8e", "#2f6b8e", "#2f6c8e", "#2e6d8e", "#2e6e8e", "#2e6f8e", "#2d708e", "#2d718e", "#2c718e", "#2c728e", "#2c738e", "#2b748e", "#2b758e", "#2a768e", "#2a778e", "#2a788e", "#29798e", "#297a8e", "#297b8e", "#287c8e", "#287d8e", "#277e8e", "#277f8e", "#27808e", "#26818e", "#26828e", "#26828e", "#25838e", "#25848e", "#25858e", "#24868e", "#24878e", "#23888e", "#23898e", "#238a8d", "#228b8d", "#228c8d", "#228d8d", "#218e8d", "#218f8d", "#21908d", "#21918c", "#20928c", "#20928c", "#20938c", "#1f948c", "#1f958b", "#1f968b", "#1f978b", "#1f988b", "#1f998a", "#1f9a8a", "#1e9b8a", "#1e9c89", "#1e9d89", "#1f9e89", "#1f9f88", "#1fa088", "#1fa188", "#1fa187", "#1fa287", "#20a386", "#20a486", "#21a585", "#21a685", "#22a785", "#22a884", "#23a983", "#24aa83", "#25ab82", "#25ac82", "#26ad81", "#27ad81", "#28ae80", "#29af7f", "#2ab07f", "#2cb17e", "#2db27d", "#2eb37c", "#2fb47c", "#31b57b", "#32b67a", "#34b679", "#35b779", "#37b878", "#38b977", "#3aba76", "#3bbb75", "#3dbc74", "#3fbc73", "#40bd72", "#42be71", "#44bf70", "#46c06f", "#48c16e", "#4ac16d", "#4cc26c", "#4ec36b", "#50c46a", "#52c569", "#54c568", "#56c667", "#58c765", "#5ac864", "#5cc863", "#5ec962", "#60ca60", "#63cb5f", "#65cb5e", "#67cc5c", "#69cd5b", "#6ccd5a", "#6ece58", "#70cf57", "#73d056", "#75d054", "#77d153", "#7ad151", "#7cd250", "#7fd34e", "#81d34d", "#84d44b", "#86d549", "#89d548", "#8bd646", "#8ed645", "#90d743", "#93d741", "#95d840", "#98d83e", "#9bd93c", "#9dd93b", "#a0da39", "#a2da37", "#a5db36", "#a8db34", "#aadc32", "#addc30", "#b0dd2f", "#b2dd2d", "#b5de2b", "#b8de29", "#bade28", "#bddf26", "#c0df25", "#c2df23", "#c5e021", "#c8e020", "#cae11f", "#cde11d", "#d0e11c", "#d2e21b", "#d5e21a", "#d8e219", "#dae319", "#dde318", "#dfe318", "#e2e418", "#e5e419", "#e7e419", "#eae51a", "#ece51b", "#efe51c", "#f1e51d", "#f4e61e", "#f6e620", "#f8e621", "#fbe723", "#fde725"];
	        this.colour_mapper = new Bokeh.LinearColorMapper({
	            palette: this.viridis_hex
	        });
	        this.ticker = new Bokeh.BasicTicker();
	        this.colour_bar = new Bokeh.ColorBar({
	            ticker: this.ticker,
	            label_standoff: 7,
	            location: [-6, 0]
	        });
	    }
	    BokehPcolour.prototype.ngOnInit = function () {
	        console.log('bokeh-pcolour ngOnInit');
	        this.figureInitialise();
	    };
	    BokehPcolour.prototype.figureInitialise = function () {
	        console.log('bokeh-pcolour figureInitialise');
	        this.fig = this.plt.figure({
	            title: this.title, tools: this.tools,
	            plot_width: this.plot_width, plot_height: this.plot_height
	        });
	        this.fig.xaxis.axis_label = 'Width (cm @ iso)';
	        this.fig.yaxis.axis_label = 'Length (cm @ iso)';
	        this.colour_bar.title = 'Insert Factor';
	        // console.log(this.colour_bar)
	        this.pcolour_renderer = this.fig.rect({ field: 'x' }, { field: 'y' }, 0.1, 0.1, {
	            source: this.pcolour_source,
	            color: { field: 'c' }
	        });
	        this.scatter_renderer = this.fig.circle({ field: 'x' }, { field: 'y' }, {
	            source: this.scatter_source,
	            size: 15,
	            line_color: { field: 'edge_colour' },
	            fill_color: { field: 'c' },
	            line_width: 2
	        });
	        this.fig.add_layout(this.colour_bar, 'left');
	    };
	    BokehPcolour.prototype.runAllUpdates = function () {
	        console.log('bokeh-pcolour runAllUpdates');
	        this.updateScatterData();
	        this.updatePcolourData();
	        this.updateScatterColour();
	        this.updateSelection();
	        this.updateSourceData();
	        this.updateFigureDimensions();
	    };
	    BokehPcolour.prototype.updateScatterData = function () {
	        console.log('bokeh-pcolour updateScatterData');
	        this.scatter_data = {
	            x: this.scatter_x,
	            y: this.scatter_y,
	            hover_width: this.scatter_hover_width,
	            hover_length: this.scatter_hover_length,
	            hover_area: this.scatter_hover_area,
	            hover_measured_factor: this.scatter_hover_measured_factor,
	            hover_predicted_factor: this.scatter_hover_predicted_factor,
	            c: this.scatter_c,
	            edge_colour: this.scatter_edge_colour
	        };
	    };
	    BokehPcolour.prototype.updatePcolourData = function () {
	        console.log('bokeh-pcolour updatePcolourData');
	        this.pcolour_data = {
	            x: this.pcolour_x,
	            y: this.pcolour_y,
	            z: this.pcolour_z,
	            hover_width: this.pcolour_hover_width,
	            hover_length: this.pcolour_hover_length,
	            hover_predicted_factor: this.pcolour_hover_predicted_factor,
	            c: this.pcolour_c
	        };
	    };
	    BokehPcolour.prototype.updateScatterColour = function () {
	        console.log('bokeh-pcolour updateScatterColour');
	        if (this.old_scatter_z != this.scatter_z || this.old_pcolour_z != this.pcolour_z) {
	            var scatter_z_edit = [];
	            var pcolour_z_edit = [];
	            for (var i = 0; i < this.scatter_z.length; i++) {
	                if (isNaN(Number(this.scatter_z[i])) || this.scatter_z[i] == null) {
	                    scatter_z_edit.push(1);
	                }
	                else {
	                    scatter_z_edit.push(this.scatter_z[i]);
	                }
	            }
	            for (var i = 0; i < this.pcolour_z.length; i++) {
	                if (isNaN(Number(this.pcolour_z[i])) || this.pcolour_z[i] == null) {
	                    pcolour_z_edit.push(1);
	                }
	                else {
	                    pcolour_z_edit.push(this.pcolour_z[i]);
	                }
	            }
	            var allZ = scatter_z_edit.concat(pcolour_z_edit);
	            this.vmin = Math.min.apply(Math, allZ);
	            this.vmax = Math.max.apply(Math, allZ);
	            this.colour_mapper.low = this.vmin;
	            this.colour_mapper.high = this.vmax;
	            this.colour_bar.color_mapper = this.colour_mapper;
	            this.scatter_c = this.colour_mapper.v_compute(scatter_z_edit);
	            this.pcolour_c = this.colour_mapper.v_compute(pcolour_z_edit);
	            for (var i in this.scatter_z) {
	                if (isNaN(Number(this.scatter_z[i])) || this.scatter_z[i] == null) {
	                    this.scatter_c[i] = '#ffffff';
	                }
	            }
	            for (var i in this.pcolour_z) {
	                if (isNaN(Number(this.pcolour_z[i])) || this.pcolour_z[i] == null) {
	                    this.pcolour_c[i] = '#ffffff';
	                }
	            }
	            this.scatter_data.c = this.scatter_c;
	            this.pcolour_data.c = this.pcolour_c;
	            this.old_scatter_z = this.scatter_z;
	            this.old_pcolour_z = this.pcolour_z;
	            if (this.scatter_data.c.length < this.scatter_data.x.length) {
	                var difference = this.scatter_data.x.length - this.scatter_data.c.length;
	                for (var i = 0; i < difference; i++) {
	                    this.scatter_data.c.push('#ffffff');
	                }
	            }
	        }
	    };
	    BokehPcolour.prototype.updateSelection = function () {
	        console.log('bokeh-pcolour updateSelection');
	        if (this.oldSelectionList != this.selectionList) {
	            if (this.selectionList != null) {
	                this.scatter_edge_colour = [];
	                for (var _i = 0, _a = this.selectionList; _i < _a.length; _i++) {
	                    var selection = _a[_i];
	                    if (selection) {
	                        this.scatter_edge_colour.push('gainsboro');
	                    }
	                    else {
	                        this.scatter_edge_colour.push('black');
	                    }
	                }
	            }
	            else {
	                this.scatter_edge_colour = 'black';
	            }
	            this.scatter_data.edge_colour = this.scatter_edge_colour;
	        }
	    };
	    BokehPcolour.prototype.updateSourceData = function () {
	        console.log('bokeh-pcolour updateSourceData');
	        if (this.scatter_source.data != this.scatter_data) {
	            this.scatter_source.data = this.scatter_data;
	        }
	        if (this.pcolour_source.data != this.pcolour_data) {
	            this.pcolour_source.data = this.pcolour_data;
	        }
	    };
	    BokehPcolour.prototype.updateFigureDimensions = function () {
	        console.log('bokeh-pcolour updateFigureDimensions');
	        if (this.fig != null) {
	            if (this.fig.width != this.plot_width) {
	                if (this.plot_width < 200) {
	                    this.fig.width = 200;
	                }
	                else {
	                    this.fig.width = this.plot_width;
	                }
	            }
	            if (this.fig.height != this.plot_height) {
	                this.fig.height = this.plot_height;
	            }
	        }
	    };
	    return BokehPcolour;
	}());
	exports.BokehPcolour = BokehPcolour;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var bokeh_pcolour_1 = __webpack_require__(204);
	var BokehUseModelComponent = (function (_super) {
	    __extends(BokehUseModelComponent, _super);
	    function BokehUseModelComponent() {
	        _super.apply(this, arguments);
	        this.title = "Figure Title";
	        this.plot_width = 300;
	        this.plot_height = 300;
	        this.scatter_z = [0.5];
	        this.enabled = true;
	        this.predicted_factor = [];
	        this.area = [];
	        this.old_area = [];
	        this.old_predicted_factor = [];
	    }
	    BokehUseModelComponent.prototype.ngOnChanges = function () {
	        console.log('bokeh-use-model.component ngOnChanges');
	        this.updateHoverData();
	        this.runAllUpdates();
	    };
	    BokehUseModelComponent.prototype.updateHoverData = function () {
	        console.log('bokeh-use-model.component updateHoverData');
	        if (this.scatter_data.x != this.scatter_x) {
	            this.scatter_hover_width = [];
	            for (var _i = 0, _a = this.scatter_x; _i < _a.length; _i++) {
	                var x = _a[_i];
	                this.scatter_hover_width.push((Math.round(x * 10) / 10).toFixed(1));
	            }
	        }
	        if (this.scatter_data.y != this.scatter_y) {
	            this.scatter_hover_length = [];
	            for (var _b = 0, _c = this.scatter_y; _b < _c.length; _b++) {
	                var y = _c[_b];
	                this.scatter_hover_length.push((Math.round(y * 10) / 10).toFixed(1));
	            }
	        }
	        if (this.old_scatter_z != this.scatter_z) {
	            this.scatter_hover_measured_factor = [];
	            for (var _d = 0, _e = this.scatter_z; _d < _e.length; _d++) {
	                var z = _e[_d];
	                this.scatter_hover_measured_factor.push((Math.round(z * 1000) / 1000).toFixed(3));
	            }
	            if (this.scatter_hover_measured_factor.length < this.scatter_x.length) {
	                var difference = this.scatter_x.length - this.scatter_hover_measured_factor.length;
	                for (var i = 0; i < difference; i++) {
	                    this.scatter_hover_measured_factor.push('Not given');
	                }
	            }
	        }
	        if (this.old_predicted_factor != this.predicted_factor) {
	            this.scatter_hover_predicted_factor = [];
	            for (var _f = 0, _g = this.predicted_factor; _f < _g.length; _f++) {
	                var z = _g[_f];
	                this.scatter_hover_predicted_factor.push((Math.round(z * 1000) / 1000).toFixed(3));
	            }
	            this.old_predicted_factor = this.predicted_factor;
	        }
	        if (this.old_area != this.area) {
	            this.scatter_hover_area = [];
	            for (var _h = 0, _j = this.area; _h < _j.length; _h++) {
	                var a = _j[_h];
	                this.scatter_hover_area.push((Math.round(a * 10) / 10).toFixed(1));
	            }
	            this.old_area = this.area;
	        }
	    };
	    // hover_width: <string[]> [],
	    // hover_length: <string[]> [],
	    // hover_area: <string[]> [],
	    // hover_measured_factor: <string[]> [],
	    // hover_predicted_factor: <string[]> [],
	    BokehUseModelComponent.prototype.ngAfterViewInit = function () {
	        console.log('bokeh-use-model.component ngAfterViewInit');
	        var hover_tool = new Bokeh.HoverTool({
	            tooltips: [
	                ["Width", " @hover_width cm"],
	                ["Length", " @hover_length cm"],
	                ["Area", " @hover_area cm^2"],
	                ["Measured factor", " @hover_measured_factor"],
	                ["Predicted factor", " @hover_predicted_factor"],
	            ],
	            renderers: [
	                this.scatter_renderer
	            ]
	        });
	        this.fig.add_tools(hover_tool);
	        this.doc.add_root(this.fig);
	        Bokeh.embed.add_document_standalone(this.doc, this.bokehplot.nativeElement);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], BokehUseModelComponent.prototype, "title", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], BokehUseModelComponent.prototype, "plot_width", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], BokehUseModelComponent.prototype, "plot_height", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BokehUseModelComponent.prototype, "scatter_x", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BokehUseModelComponent.prototype, "scatter_y", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BokehUseModelComponent.prototype, "scatter_z", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BokehUseModelComponent.prototype, "pcolour_x", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BokehUseModelComponent.prototype, "pcolour_y", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BokehUseModelComponent.prototype, "pcolour_z", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], BokehUseModelComponent.prototype, "enabled", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BokehUseModelComponent.prototype, "predicted_factor", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BokehUseModelComponent.prototype, "selectionList", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BokehUseModelComponent.prototype, "area", void 0);
	    __decorate([
	        core_1.ViewChild('bokehplot'), 
	        __metadata('design:type', Object)
	    ], BokehUseModelComponent.prototype, "bokehplot", void 0);
	    BokehUseModelComponent = __decorate([
	        core_1.Component({
	            selector: 'my-bokeh-use-model',
	            template: __webpack_require__(202)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], BokehUseModelComponent);
	    return BokehUseModelComponent;
	}(bokeh_pcolour_1.BokehPcolour));
	exports.BokehUseModelComponent = BokehUseModelComponent;


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_persistence_service_1 = __webpack_require__(132);
	var specifications_data_service_1 = __webpack_require__(139);
	var ChooseSpecificationsComponent = (function () {
	    function ChooseSpecificationsComponent(dataPersistenceService, machineSpecificationService) {
	        this.dataPersistenceService = dataPersistenceService;
	        this.machineSpecificationService = machineSpecificationService;
	        this.settingsUpdated = new core_1.EventEmitter();
	    }
	    ChooseSpecificationsComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        console.log('choose-specifications.component ngOnInit');
	        this.machineSpecificationService.loadData()
	            .then(function () {
	            _this.settingsUpdated.emit(_this.machineSpecificationService.currentSettings);
	        });
	    };
	    ChooseSpecificationsComponent.prototype.updateMachineID = function (newCurrentMachine) {
	        console.log('choose-specifications.component updateMachineID');
	        this.machineSpecificationService.currentSettings.machine = newCurrentMachine;
	        this.machineSpecificationService.updateCurrentSpecification();
	        this.machineSpecificationService.refreshCurrentSettings();
	        this.dataPersistenceService.saveCurrentSettings(this.machineSpecificationService.currentSettings);
	        this.settingsUpdated.emit(this.machineSpecificationService.currentSettings);
	    };
	    ChooseSpecificationsComponent.prototype.updateEnergy = function (newCurrentEnergy) {
	        console.log('choose-specifications.component updateEnergy');
	        this.machineSpecificationService.currentSettings.energy = Number(newCurrentEnergy);
	        this.dataPersistenceService.saveCurrentSettings(this.machineSpecificationService.currentSettings);
	        this.settingsUpdated.emit(this.machineSpecificationService.currentSettings);
	    };
	    ChooseSpecificationsComponent.prototype.updateApplicator = function (newCurrentApplicator) {
	        console.log('choose-specifications.component updateApplicator');
	        this.machineSpecificationService.currentSettings.applicator = newCurrentApplicator;
	        this.dataPersistenceService.saveCurrentSettings(this.machineSpecificationService.currentSettings);
	        this.settingsUpdated.emit(this.machineSpecificationService.currentSettings);
	    };
	    ChooseSpecificationsComponent.prototype.updateSSD = function (newCurrentSSD) {
	        console.log('choose-specifications.component updateSSD');
	        this.machineSpecificationService.currentSettings.ssd = Number(newCurrentSSD);
	        this.dataPersistenceService.saveCurrentSettings(this.machineSpecificationService.currentSettings);
	        this.settingsUpdated.emit(this.machineSpecificationService.currentSettings);
	    };
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], ChooseSpecificationsComponent.prototype, "settingsUpdated", void 0);
	    ChooseSpecificationsComponent = __decorate([
	        core_1.Component({
	            selector: 'my-choose-specifications',
	            template: __webpack_require__(207)
	        }), 
	        __metadata('design:paramtypes', [data_persistence_service_1.DataPersistenceService, specifications_data_service_1.MachineSpecificationsService])
	    ], ChooseSpecificationsComponent);
	    return ChooseSpecificationsComponent;
	}());
	exports.ChooseSpecificationsComponent = ChooseSpecificationsComponent;


/***/ },
/* 207 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mdl-grid\" *ngIf=\"machineSpecificationService != null && machineSpecificationService.currentSettings != null && machineSpecificationService.currentSpecification != null\">\n  <div \n      *ngIf=\"machineSpecificationService.machineList.length > 0\" \n      class=\"mdl-cell mdl-cell--3-col mdl-cell--4-col-tablet mdl-cell--2-col-phone\">\n    <h6>Machine ID</h6>\n    <select\n        [(ngModel)]=\"machineSpecificationService.currentSettings.machine\"\n        (input)=\"updateMachineID($event.target.value)\">\n      <option *ngFor=\"let machine of machineSpecificationService.machineList\">{{machine}}</option>\n    </select>\n  </div>\n\n  <div \n      *ngIf=\"machineSpecificationService.machineList.length > 0 && machineSpecificationService.currentSettings.machine != null && machineSpecificationService.currentSpecification != null\" \n      class=\"mdl-cell mdl-cell--3-col mdl-cell--4-col-tablet mdl-cell--2-col-phone\">\n    <h6>Energy</h6>\n    <div *ngIf=\"machineSpecificationService.currentSpecification.energy != null\">\n      <select\n          [(ngModel)]=\"machineSpecificationService.currentSettings.energy\"\n          (input)=\"updateEnergy($event.target.value)\"\n          *ngIf=\"machineSpecificationService.currentSpecification.energy.length > 0\">\n        <option *ngFor=\"let energy of machineSpecificationService.currentSpecification.energy\" value=\"{{energy}}\">{{energy}} MeV</option>\n      </select>\n    </div>\n    <p *ngIf=\"machineSpecificationService.currentSpecification.energy.length == 0\">\n      This machine doesn't have any energies defined. Please \n      <a routerLink=\"/specifications\" routerLinkActive=\"active\">\n        define at least one energy.\n      </a>\n    </p>\n  </div>\n\n  <div \n      *ngIf=\"machineSpecificationService.machineList.length > 0 && machineSpecificationService.currentSettings.machine != null && machineSpecificationService.currentSpecification != null\" \n      class=\"mdl-cell mdl-cell--3-col mdl-cell--4-col-tablet mdl-cell--2-col-phone\">\n    <h6>Applicator</h6>\n    <div *ngIf=\"machineSpecificationService.currentSpecification.applicator != null\">\n      <select \n          [(ngModel)]=\"machineSpecificationService.currentSettings.applicator\"\n          (input)=\"updateApplicator($event.target.value)\"\n          *ngIf=\"machineSpecificationService.currentSpecification.applicator.length > 0\">\n        <option *ngFor=\"let applicator of machineSpecificationService.currentSpecification.applicator\">{{applicator}}</option>\n      </select>\n    </div>\n    <p *ngIf=\"machineSpecificationService.currentSpecification.applicator.length == 0\">\n      This machine doesn't have any applicators defined. Please \n      <a routerLink=\"/specifications\" routerLinkActive=\"active\">\n        define at least one applicator.\n      </a>\n    </p>\n  </div>\n\n  <div \n      *ngIf=\"machineSpecificationService.machineList.length > 0 && machineSpecificationService.currentSettings.machine != null && machineSpecificationService.currentSpecification != null\" \n      class=\"mdl-cell mdl-cell--3-col mdl-cell--4-col-tablet mdl-cell--2-col-phone\">\n    <h6>SSD</h6>\n    <div *ngIf=\"machineSpecificationService.currentSpecification.ssd != null\">\n      <select  \n          [(ngModel)]=\"machineSpecificationService.currentSettings.ssd\"\n          (input)=\"updateSSD($event.target.value)\"\n          *ngIf=\"machineSpecificationService.currentSpecification.ssd.length > 0\">\n        <option *ngFor=\"let ssd of machineSpecificationService.currentSpecification.ssd\">{{ssd}}</option>\n      </select>\n    </div>\n    <p *ngIf=\"machineSpecificationService.currentSpecification.ssd.length == 0\">\n      This machine doesn't have an ssd defined. Please \n      <a routerLink=\"/specifications\" routerLinkActive=\"active\">\n        define at least one ssd.\n      </a>\n    </p>\n  </div>\n</div>\n  \n<div class=\"mdl-grid\" *ngIf=\"machineSpecificationService == null || machineSpecificationService.currentSettings == null || machineSpecificationService.currentSpecification == null\">\n  <div class=\"mdl-cell mdl-cell--3-col mdl-cell--4-col-tablet mdl-cell--2-col-phone\">\n    <h6>Machine ID</h6>\n    <select></select>\n  </div>\n</div>";

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var my_json_pipe_1 = __webpack_require__(209);
	var common_1 = __webpack_require__(22);
	var JsonEditComponent = (function () {
	    function JsonEditComponent() {
	        this.buttonText = "Button";
	        this.inputUpdated = new core_1.EventEmitter();
	        this.validationCheck = function (parsedJSON) { };
	        this.useMyJsonPipe = false;
	        this.lines = 10;
	        this.jsonValid = true;
	    }
	    JsonEditComponent.prototype.onInput = function (jsonInput) {
	        this.parseAndCheckJSON(jsonInput);
	    };
	    JsonEditComponent.prototype.ngOnInit = function () {
	        var value = "";
	        if (this.useMyJsonPipe) {
	            value = new my_json_pipe_1.MyJsonPipe().transform(this.input);
	        }
	        else {
	            value = new common_1.JsonPipe().transform(this.input);
	        }
	        this.lines = value.split(/\r\n|\r|\n/).length;
	        this.editedInput = this.input;
	    };
	    JsonEditComponent.prototype.updateInput = function () {
	        this.input = this.editedInput;
	        this.inputUpdated.emit(this.input);
	    };
	    JsonEditComponent.prototype.parseAndCheckJSON = function (jsonInput) {
	        var oldJsonValid = this.jsonValid;
	        this.jsonValid = false;
	        try {
	            var parsedJSON = JSON.parse(jsonInput);
	            this.validationCheck(parsedJSON);
	            this.editedInput = parsedJSON;
	            this.jsonValid = true;
	        }
	        catch (err) {
	            this.jsonErrorMessage = 'Error in JSON input. ' + err;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], JsonEditComponent.prototype, "input", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], JsonEditComponent.prototype, "buttonText", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], JsonEditComponent.prototype, "inputUpdated", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Function)
	    ], JsonEditComponent.prototype, "validationCheck", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], JsonEditComponent.prototype, "useMyJsonPipe", void 0);
	    __decorate([
	        core_1.ViewChild('jsonInput'), 
	        __metadata('design:type', Object)
	    ], JsonEditComponent.prototype, "jsonInputDir", void 0);
	    JsonEditComponent = __decorate([
	        core_1.Component({
	            selector: 'my-json-edit',
	            template: __webpack_require__(210),
	        }), 
	        __metadata('design:paramtypes', [])
	    ], JsonEditComponent);
	    return JsonEditComponent;
	}());
	exports.JsonEditComponent = JsonEditComponent;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var MyJsonPipe = (function () {
	    function MyJsonPipe() {
	    }
	    MyJsonPipe.prototype.transform = function (input) {
	        var jsonText = JSON.stringify(input, null, 4);
	        jsonText = jsonText.replace(/(-?\d+(\.\d+)?),\n\s*/g, "$1, ");
	        jsonText = jsonText.replace(/null,\n\s*/g, "null, ");
	        // jsonText = jsonText.replace(/:/g, ":\n");
	        return jsonText;
	    };
	    MyJsonPipe = __decorate([
	        core_1.Pipe({ name: 'myJson', pure: false }), 
	        __metadata('design:paramtypes', [])
	    ], MyJsonPipe);
	    return MyJsonPipe;
	}());
	exports.MyJsonPipe = MyJsonPipe;


/***/ },
/* 210 */
/***/ function(module, exports) {

	module.exports = "<button\n  mdl-button mdl-button-type=\"raised\" \n  mdl-colored=\"primary\" \n  mdl-ripple\n  [disabled]=\"!jsonValid || input==editedInput\"\n  (click)=\"updateInput()\">{{buttonText}} \n</button>\n<div *ngIf=\"!jsonValid\">\n  {{jsonErrorMessage}}\n</div>\n<mdl-textfield *ngIf=\"!useMyJsonPipe\" #jsonInput\n  [value]=\"input | json\"\n  (input)=\"onInput($event.target.value)\"\n  [rows]=\"20\" \n  style=\"width:100%\">\n</mdl-textfield>\n<mdl-textfield *ngIf=\"useMyJsonPipe\" #jsonInput\n  [value]=\"input | myJson\"\n  (input)=\"onInput($event.target.value)\"\n  [rows]=\"20\" \n  style=\"width:100%\">\n</mdl-textfield>";

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var insert_data_1 = __webpack_require__(128);
	var angular2_mdl_1 = __webpack_require__(71);
	var SendToParameterisationComponent = (function () {
	    function SendToParameterisationComponent() {
	        this.tableData = [
	            { machine: null, applicator: null, energy: null, ssd: null }
	        ];
	        this.tableModel = new angular2_mdl_1.MdlDefaultTableModel([
	            { key: 'machine', name: 'Machine', sortable: true, numeric: false },
	            { key: 'applicator', name: 'App', sortable: true, numeric: false },
	            { key: 'energy', name: 'Eng', sortable: true, numeric: true },
	            { key: 'ssd', name: 'SSD', sortable: true, numeric: true }
	        ]);
	    }
	    SendToParameterisationComponent.prototype.ngOnInit = function () {
	        this.tableData[0].machine = this.insertData.machine;
	        this.tableData[0].applicator = this.insertData.applicator;
	        this.tableData[0].energy = this.insertData.energy;
	        this.tableData[0].ssd = this.insertData.ssd;
	        this.tableModel.addAll(this.tableData);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', insert_data_1.InsertData)
	    ], SendToParameterisationComponent.prototype, "insertData", void 0);
	    SendToParameterisationComponent = __decorate([
	        core_1.Component({
	            selector: 'my-send-to-parameterisation',
	            template: __webpack_require__(212),
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SendToParameterisationComponent);
	    return SendToParameterisationComponent;
	}());
	exports.SendToParameterisationComponent = SendToParameterisationComponent;


/***/ },
/* 212 */
/***/ function(module, exports) {

	module.exports = "<div class=\"mdl-grid\">\n  <div class=\"mdl-cell mdl-cell--12-col\">\n    <my-plot \n      [insert_x]=\"insertData.parameterisation.insert.x\"\n      [insert_y]=\"insertData.parameterisation.insert.y\"\n      [circle]=\"insertData.parameterisation.circle\"\n      [ellipse]=\"insertData.parameterisation.ellipse\">\n    </my-plot>\n  </div>\n  <div class=\"mdl-cell mdl-cell--12-col\">\n    <mdl-table mdl-shadow=\"2\"\n      [table-model]=\"tableModel\">\n    </mdl-table>\n  </div>\n</div>\n\n";

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var angular2_mdl_1 = __webpack_require__(71);
	var WidthLengthTableComponent = (function () {
	    function WidthLengthTableComponent() {
	        this.tableData = [
	            { width: null, length: null }
	        ];
	        this.tableModel = new angular2_mdl_1.MdlDefaultTableModel([
	            { key: 'width', name: 'Width', sortable: true, numeric: true },
	            { key: 'length', name: 'Length', sortable: true, numeric: true }
	        ]);
	    }
	    WidthLengthTableComponent.prototype.ngOnChanges = function () {
	        if (this.enabled) {
	            this.tableData[0].width = this.width;
	            this.tableData[0].length = this.length;
	        }
	        else {
	            this.tableData[0].width = null;
	            this.tableData[0].length = null;
	        }
	    };
	    WidthLengthTableComponent.prototype.ngOnInit = function () {
	        this.tableModel.addAll(this.tableData);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], WidthLengthTableComponent.prototype, "width", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], WidthLengthTableComponent.prototype, "length", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], WidthLengthTableComponent.prototype, "enabled", void 0);
	    WidthLengthTableComponent = __decorate([
	        core_1.Component({
	            selector: 'my-width-length-table',
	            template: __webpack_require__(214),
	        }), 
	        __metadata('design:paramtypes', [])
	    ], WidthLengthTableComponent);
	    return WidthLengthTableComponent;
	}());
	exports.WidthLengthTableComponent = WidthLengthTableComponent;


/***/ },
/* 214 */
/***/ function(module, exports) {

	module.exports = "<mdl-table mdl-shadow=\"2\"\n  [table-model]=\"tableModel\">\n</mdl-table>";

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var angular2_mdl_1 = __webpack_require__(71);
	var InsertTableComponent = (function () {
	    function InsertTableComponent() {
	        this.selectionChangedEvent = new core_1.EventEmitter();
	        this.tableModel = new angular2_mdl_1.MdlDefaultTableModel([
	            { key: 'width', name: 'Width (cm)', sortable: true, numeric: true },
	            { key: 'length', name: 'Length (cm)', sortable: true, numeric: true },
	            { key: 'area', name: 'Area (cm^2)', sortable: true, numeric: true },
	            { key: 'measuredFactor', name: 'Measured Factor', sortable: true, numeric: true },
	            { key: 'predictedFactor', name: 'Predicted Factor', sortable: true, numeric: true },
	            { key: 'difference', name: 'Difference', sortable: true, numeric: true },
	            { key: 'canBeAdded', name: 'Able to add to model?' }
	        ]);
	    }
	    InsertTableComponent.prototype.ngOnChanges = function () {
	        console.log('insert-table.component ngOnChanges');
	        if (this.tableData != null) {
	            this.appendData();
	        }
	    };
	    InsertTableComponent.prototype.ngOnInit = function () {
	        console.log('insert-table.component ngOnInit');
	        this.appendData();
	    };
	    InsertTableComponent.prototype.appendData = function () {
	        console.log('insert-table.component appendData');
	        this.tableData = [
	            {
	                width: null, length: null,
	                area: null, measuredFactor: null,
	                predictedFactor: null, difference: null,
	                canBeAdded: null, selected: false
	            }
	        ];
	        for (var i in this.width) {
	            this.tableData[i] = {
	                width: null, length: null,
	                area: null, measuredFactor: null,
	                predictedFactor: null, difference: null,
	                canBeAdded: null, selected: false
	            };
	            for (var _i = 0, _a = ['width', 'length', 'area', 'measuredFactor', 'predictedFactor', 'canBeAdded']; _i < _a.length; _i++) {
	                var key = _a[_i];
	                this.tableData[i][key] = this[key][i];
	            }
	            this.tableData[i].difference = Math.round((this.predictedFactor[i] - this.measuredFactor[i]) * 1000) / 1000;
	        }
	        this.tableModel.data = this.tableData;
	        this.selectionChanged();
	    };
	    InsertTableComponent.prototype.selectionChanged = function () {
	        console.log('insert-table.component selectionChanged');
	        this.selectionList = [];
	        for (var _i = 0, _a = this.tableData; _i < _a.length; _i++) {
	            var tableItem = _a[_i];
	            this.selectionList.push(tableItem.selected);
	        }
	        this.selectionChangedEvent.emit(this.selectionList);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], InsertTableComponent.prototype, "width", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], InsertTableComponent.prototype, "length", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], InsertTableComponent.prototype, "area", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], InsertTableComponent.prototype, "measuredFactor", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], InsertTableComponent.prototype, "predictedFactor", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], InsertTableComponent.prototype, "canBeAdded", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], InsertTableComponent.prototype, "selectionChangedEvent", void 0);
	    InsertTableComponent = __decorate([
	        core_1.Component({
	            selector: 'my-insert-table',
	            template: __webpack_require__(216),
	        }), 
	        __metadata('design:paramtypes', [])
	    ], InsertTableComponent);
	    return InsertTableComponent;
	}());
	exports.InsertTableComponent = InsertTableComponent;


/***/ },
/* 216 */
/***/ function(module, exports) {

	module.exports = "<mdl-table-selectable mdl-shadow=\"2\"\n    [table-model]=\"tableModel\"\n    [table-model-selected]=\"selected\"\n    (table-model-selectionChanged)=\"selectionChanged()\">\n</mdl-table-selectable>\n<!--<p>{{selectionList | json}}</p>-->";

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var angular2_mdl_1 = __webpack_require__(71);
	var CreateInsertTableComponent = (function () {
	    function CreateInsertTableComponent() {
	        this.selectionChangedEvent = new core_1.EventEmitter();
	        this.tableModel = new angular2_mdl_1.MdlDefaultTableModel([
	            { key: 'width', name: 'Width (cm)', sortable: true, numeric: true },
	            { key: 'length', name: 'Length (cm)', sortable: true, numeric: true },
	            { key: 'area', name: 'Area (cm^2)', sortable: true, numeric: true },
	            { key: 'measuredFactor', name: 'Measured Factor', sortable: true, numeric: true }
	        ]);
	    }
	    CreateInsertTableComponent.prototype.ngOnChanges = function () {
	        console.log('insert-table.component ngOnChanges');
	        if (this.tableData != null) {
	            this.appendData();
	        }
	    };
	    CreateInsertTableComponent.prototype.ngOnInit = function () {
	        console.log('insert-table.component ngOnInit');
	        this.appendData();
	    };
	    CreateInsertTableComponent.prototype.appendData = function () {
	        console.log('insert-table.component appendData');
	        this.tableData = [
	            {
	                width: null, length: null,
	                area: null, measuredFactor: null,
	                selected: false
	            }
	        ];
	        for (var i in this.width) {
	            this.tableData[i] = {
	                width: null, length: null,
	                area: null, measuredFactor: null,
	                selected: false
	            };
	            for (var _i = 0, _a = ['width', 'length', 'area', 'measuredFactor']; _i < _a.length; _i++) {
	                var key = _a[_i];
	                this.tableData[i][key] = this[key][i];
	            }
	        }
	        this.tableModel.data = this.tableData;
	        this.selectionChanged();
	    };
	    CreateInsertTableComponent.prototype.selectionChanged = function () {
	        console.log('insert-table.component selectionChanged');
	        this.selectionList = [];
	        for (var _i = 0, _a = this.tableData; _i < _a.length; _i++) {
	            var tableItem = _a[_i];
	            this.selectionList.push(tableItem.selected);
	        }
	        this.selectionChangedEvent.emit(this.selectionList);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], CreateInsertTableComponent.prototype, "width", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], CreateInsertTableComponent.prototype, "length", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], CreateInsertTableComponent.prototype, "area", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], CreateInsertTableComponent.prototype, "measuredFactor", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], CreateInsertTableComponent.prototype, "selectionChangedEvent", void 0);
	    CreateInsertTableComponent = __decorate([
	        core_1.Component({
	            selector: 'my-create-insert-table',
	            template: __webpack_require__(216),
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CreateInsertTableComponent);
	    return CreateInsertTableComponent;
	}());
	exports.CreateInsertTableComponent = CreateInsertTableComponent;


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var localstoragemodule_1 = __webpack_require__(219);
	var LocalStorageService = (function () {
	    function LocalStorageService() {
	        this.isSupported = localstoragemodule_1.LocalStorage.isSupported;
	        this.hasItem = localstoragemodule_1.LocalStorage.hasItem;
	        this.getRemainingSpace = localstoragemodule_1.LocalStorage.getRemainingSpace;
	        this.getMaximumSpace = localstoragemodule_1.LocalStorage.getMaximumSpace;
	        this.getUsedSpace = localstoragemodule_1.LocalStorage.getUsedSpace;
	        this.getItemUsedSpace = localstoragemodule_1.LocalStorage.getItemUsedSpace;
	        this.getBackup = localstoragemodule_1.LocalStorage.getBackup;
	        this.applyBackup = localstoragemodule_1.LocalStorage.applyBackup;
	        this.consoleInfo = localstoragemodule_1.LocalStorage.consoleInfo;
	    }
	    LocalStorageService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], LocalStorageService);
	    return LocalStorageService;
	}());
	exports.LocalStorageService = LocalStorageService;


/***/ },
/* 219 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Check if localStorage is supported                       const isSupported: boolean
	 * Check if localStorage has an Item                        function hasItem(key: string): boolean
	 * Get the amount of space left in localStorage             function getRemainingSpace(): number
	 * Get the maximum amount of space in localStorage          function getMaximumSpace(): number
	 * Get the used space in localStorage                       function getUsedSpace(): number
	 * Get the used space of an item in localStorage            function getItemUsedSpace(): number
	 * Backup Assosiative Array                                 interface Backup
	 * Get a Backup of localStorage                             function getBackup(): Backup
	 * Apply a Backup to localStorage                           function applyBackup(backup: Backup, fClear: boolean = true, fOverwriteExisting: boolean = true)
	 * Dump all information of localStorage in the console      function consoleInfo(fShowMaximumSize: boolean = false)
	 */
	var LocalStorage;
	(function (LocalStorage) {
	    // Copied from https://gist.github.com/CodeiSir/1fb8bd9154dfde7eb0c7
	    // found from http://stackoverflow.com/a/34245594
	    /**
	     * Flag set true if the Browser supports localStorage, widthout affecting it
	     */
	    LocalStorage.isSupported = (function () {
	        try {
	            var itemBackup = localStorage.getItem("");
	            localStorage.removeItem("");
	            localStorage.setItem("", itemBackup);
	            if (itemBackup === null)
	                localStorage.removeItem("");
	            else
	                localStorage.setItem("", itemBackup);
	            return true;
	        }
	        catch (e) {
	            return false;
	        }
	    })();
	    /**
	     * Check if localStorage has an Item / exists with the give key
	     * @param key the key of the Item
	     */
	    function hasItem(key) {
	        return localStorage.getItem(key) !== null;
	    }
	    LocalStorage.hasItem = hasItem;
	    /**
	     * This will return the left space in localStorage without affecting it's content
	     * Might be slow !!!
	     */
	    function getRemainingSpace() {
	        var itemBackup = localStorage.getItem("");
	        var increase = true;
	        var data = "1";
	        var totalData = "";
	        var trytotalData = "";
	        while (true) {
	            try {
	                trytotalData = totalData + data;
	                localStorage.setItem("", trytotalData);
	                totalData = trytotalData;
	                if (increase)
	                    data += data;
	            }
	            catch (e) {
	                if (data.length < 2) {
	                    break;
	                }
	                increase = false;
	                data = data.substr(data.length / 2);
	            }
	        }
	        if (itemBackup === null)
	            localStorage.removeItem("");
	        else
	            localStorage.setItem("", itemBackup);
	        return totalData.length;
	    }
	    LocalStorage.getRemainingSpace = getRemainingSpace;
	    /**
	     * This function returns the maximum size of localStorage without affecting it's content
	     * Might be slow !!!
	     */
	    function getMaximumSpace() {
	        var backup = getBackup();
	        localStorage.clear();
	        var max = getRemainingSpace();
	        applyBackup(backup);
	        return max;
	    }
	    LocalStorage.getMaximumSpace = getMaximumSpace;
	    /**
	     * This will return the currently used size of localStorage
	     */
	    function getUsedSpace() {
	        var sum = 0;
	        for (var i = 0; i < localStorage.length; ++i) {
	            var key = localStorage.key(i);
	            var value = localStorage.getItem(key);
	            sum += key.length + value.length;
	        }
	        return sum;
	    }
	    LocalStorage.getUsedSpace = getUsedSpace;
	    /**
	     * This will return the currently used size of a given Item, returns NaN if key is not found
	     * @param key
	     */
	    function getItemUsedSpace(key) {
	        var value = localStorage.getItem(key);
	        if (value === null) {
	            return NaN;
	        }
	        else {
	            return key.length + value.length;
	        }
	    }
	    LocalStorage.getItemUsedSpace = getItemUsedSpace;
	    /**
	     * This will return a localStorage-backup (Associative-Array key->value)
	     */
	    function getBackup() {
	        var backup = {};
	        for (var i = 0; i < localStorage.length; ++i) {
	            var key = localStorage.key(i);
	            var value = localStorage.getItem(key);
	            backup[key] = value;
	        }
	        return backup;
	    }
	    LocalStorage.getBackup = getBackup;
	    /**
	     * This will apply a localStorage-Backup (Associative-Array key->value)
	     * @param backup            associative-array
	     * @param fClear             optional flag to clear all existing storage first. Default: true
	     * @param fOverwriteExisting optional flag to replace existing keys. Default: true
	     */
	    function applyBackup(backup, fClear, fOverwriteExisting) {
	        if (fClear === void 0) { fClear = true; }
	        if (fOverwriteExisting === void 0) { fOverwriteExisting = true; }
	        if (fClear == true) {
	            localStorage.clear();
	        }
	        for (var key in backup) {
	            if (fOverwriteExisting === false && backup[key] !== undefined) {
	                continue;
	            }
	            var value = backup[key];
	            localStorage.setItem(key, value);
	        }
	    }
	    LocalStorage.applyBackup = applyBackup;
	    /**
	     * This functions dumps all keys and values of the local Storage to the console,
	     * as well as the current size and number of items
	     * @param fShowMaximumSize optional, flag show maximum size of localStorage. Default: false
	     */
	    function consoleInfo(fShowMaximumSize) {
	        if (fShowMaximumSize === void 0) { fShowMaximumSize = false; }
	        var amount = 0;
	        var size = 0;
	        for (var i = 0; i < localStorage.length; ++i) {
	            var key = localStorage.key(i);
	            var value = localStorage.getItem(key);
	            console.log(amount, key, value);
	            size += key.length + value.length;
	            amount++;
	        }
	        console.log("Total entries:", amount);
	        console.log("Total size:", size);
	        if (fShowMaximumSize === true) {
	            var maxSize = getMaximumSpace();
	            console.log("Total size:", maxSize);
	        }
	    }
	    LocalStorage.consoleInfo = consoleInfo;
	})(LocalStorage = exports.LocalStorage || (exports.LocalStorage = {}));
	/*
	    // Example
	    console.log("LocalStorage supported:", LocalStorage.isSupported)// true - I hope so anyways 😉
	    localStorage.setItem("asd", "ASDASD")                           // sets / overwrites the item "asd"
	    localStorage.setItem("asd" + Math.random(), "ASDASD")           // set another item each time you refresh the page
	    var backup = LocalStorage.getBackup()                           // creates a backup, we will need it later!
	    console.log(JSON.stringify(backup))                             // this is how the backup looks like
	    var usedSpace = LocalStorage.getUsedSpace()                     // amount of space used right now
	    console.log("Used Space:", usedSpace)
	    var maxSpace = LocalStorage.getMaximumSpace()                   // amount of maximum space aviable
	    console.log("Maximum Space:", maxSpace)
	    var remSpace = LocalStorage.getRemainingSpace()                 // amount of remaining space
	    console.log("Remaining Space:", remSpace)
	    console.log("SpaceCheck", maxSpace === usedSpace + remSpace)    // true
	    console.log("hasItem", LocalStorage.hasItem("nothis0ne"))       // we don't have this one in our localStorage
	    localStorage.clear()                                            // oops, we deleted the localStorage!
	    console.log("has asd",LocalStorage.hasItem("asd"))              // item asd is lost 😒
	    LocalStorage.applyBackup(backup)                                // but we have a backup, restore it!
	    LocalStorage.consoleInfo()                                      // show all the info we have, see the backup worked 😊
	*/ 


/***/ }
]);


/** WEBPACK FOOTER **
 ** webapp/app.306186c2f43e8bcbaa2d.js
 **/